<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a class="cursor-pointer">Operational Clarity</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Client Detail</a></li>
        </ul>

        <div v-if="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">


                    <h3>Summary for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="surface-card p-0 m-0 list-none flex overflow-x-auto select-none">
                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 1, 'text-700 border-transparent': activeTab !== 1}"
                               @click="callMenuSummary">
                                <i class="pi pi-home mr-2"></i>
                                <span class="font-medium">Summary</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 2, 'text-700 border-transparent': activeTab !== 2}"
                               @click="callMenuFinancial">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Financial & Risk</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 3, 'text-700 border-transparent': activeTab !== 3}"
                               @click="callMenuUpdate">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Update</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 4, 'text-700 border-transparent': activeTab !== 4}"
                               @click="callMenuManage">
                                <i class="pi pi-shopping-cart mr-2"></i>
                                <span class="font-medium">Manage</span>
                            </a>
                        </li>
                    </ul>

                    <div style="height: 20px;"></div>

                    <div class="col-12 xl:col-12">
                        <div class="surface-card shadow-2 border-round p-4">
                            <div class="surface-card shadow-2 border-round flex p-3 flex-column md:flex-row">
                                <div class="border-bottom-1 md:border-right-1 md:border-bottom-none surface-border flex-auto p-3">
                                    <div class="flex align-items-center mb-3">
                                        <i class="pi pi-shopping-cart text-blue-500 text-xl mr-2"></i>
                                        <span class="text-500 font-medium">AUM</span>
                                    </div>
                                    <span class="block text-900 font-medium mb-4 text-xl">R1,800,000</span>
<!--                                    <div class="flex align-items-center">-->
<!--                                        <i class="pi pi-arrow-down text-pink-500 text-xl mr-2"></i>-->
<!--                                        <span class="text-pink-500 font-medium ">-25</span>-->
<!--                                    </div>-->
                                </div>
                                <div class="border-bottom-1 md:border-right-1 md:border-bottom-none surface-border flex-auto p-3">
                                    <div class="flex align-items-center mb-3">
                                        <i class="pi pi-shopping-cart text-orange-500 text-xl mr-2"></i>
                                        <span class="text-500 font-medium">Average Monthly Revenue (last 12 months)</span>
                                    </div>
                                    <span class="block text-900 font-medium mb-4 text-xl">R7,850</span>
<!--                                    <div class="flex align-items-center">-->
<!--                                        <i class="pi pi-arrow-up text-green-500 text-xl mr-2"></i>-->
<!--                                        <span class="text-green-500 font-medium ">+15</span>-->
<!--                                    </div>-->
                                </div>
                                <div class="border-bottom-1 md:border-right-1 md:border-bottom-none surface-border flex-auto p-3">
                                    <div class="flex align-items-center mb-3">
                                        <i class="pi pi-users text-cyan-500 text-xl mr-2"></i>
                                        <span class="text-500 font-medium">Total Appointments</span>
                                    </div>
                                    <span class="block text-900 font-medium mb-4 text-xl">6</span>
<!--                                    <div class="flex align-items-center">-->
<!--                                        <i class="pi pi-arrow-up text-green-500 text-xl mr-2"></i>-->
<!--                                        <span class="text-green-500 font-medium ">+%12</span>-->
<!--                                    </div>-->
                                </div>
                                <div class="flex-auto p-3">
                                    <div class="flex align-items-center mb-3">
                                        <i class="pi pi-users text-purple-500 text-xl mr-2"></i>
                                        <span class="text-500 font-medium">Total Tasks</span>
                                    </div>
                                    <span class="block text-900 font-medium mb-4 text-xl">72</span>
<!--                                    <div class="flex align-items-center">-->
<!--                                        <i class="pi pi-arrow-up text-green-500 text-xl mr-2"></i>-->
<!--                                        <span class="text-green-500 font-medium ">+20</span>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 xl:col-12">
                        <div class="surface-card shadow-2 border-round p-4">
                            <div class="text-xl text-900 font-medium mb-5">Client Information</div>
                            <ul class="list-none p-0 m-0">

                                <li class="pb-3 border-bottom-1 surface-border">
                                    <div class="grid">

                                        <!-- Type -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">Type</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.type }}
                                            </div>
                                        </div>

                                        <!-- Name -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">Name</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.name }}
                                            </div>
                                        </div>

                                        <!-- Name -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">Status</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.status }}
                                            </div>
                                        </div>

                                    </div>
                                </li>

                                <li class="py-3 border-bottom-1 surface-border">
                                    <div class="grid">

                                        <!-- Type -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">First Name</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.firstName }}
                                            </div>
                                        </div>

                                        <!-- Name -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">Last Name</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.lastName }}
                                            </div>
                                        </div>

                                        <!-- Name -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">Preferred Name</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.preferredName }}
                                            </div>
                                        </div>

                                    </div>
                                </li>

                                <li class="py-3 border-bottom-1 surface-border">
                                    <div class="grid">

                                        <!-- Type -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">Email</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.email }}
                                            </div>
                                        </div>

                                        <!-- Name -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">Alternate Emails</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.alternateEmail }}
                                            </div>
                                        </div>

                                        <!-- Name -->
                                        <div class="col-12 md:col-4">
                                            <div class="font-medium text-900 mb-2">Mobile Number</div>
                                            <div class="line-height-3 text-600">
                                                {{ client.mobile }}
                                            </div>
                                        </div>

                                    </div>
                                </li>


                                <!--                                <li class="py-3 border-bottom-1 surface-border">-->
                                <!--                                    <div class="font-medium text-900 mb-2">In iaculis nunc sed augue lacus</div>-->
                                <!--                                    <div class="line-height-3 text-600" style="max-width: 30rem">Viverra vitae congue.-->
                                <!--                                        Nisi scelerisque eu ultrices vitae auctor eu augue ut lectus. Elementum eu-->
                                <!--                                        facilisis sed odio morbi.-->
                                <!--                                    </div>-->
                                <!--                                </li>-->
                                <!--                                <li class="py-3 border-bottom-1 surface-border">-->
                                <!--                                    <div class="font-medium text-900 mb-2">Proin sagittis nisl rhoncus</div>-->
                                <!--                                    <div class="line-height-3 text-600" style="max-width: 30rem">In pellentesque massa-->
                                <!--                                        placerat duis ultricies lacus. Ac feugiat sed lectus vestibulum mattis-->
                                <!--                                        ullamcorper.-->
                                <!--                                    </div>-->
                                <!--                                </li>-->
                            </ul>

                            <!--                            <div class="flex justify-content-between pt-3">-->
                            <!--                                <Button label="Update" class="p-button-outlined w-12 ml-2"></Button>-->
                            <!--                            </div>-->
                        </div>
                    </div>


                    <div class="card p-fluid">
                        <div class="surface-card shadow-2 border-round p-4">
                            <div class="grid">

                                <div class="col-12 lg:col-4 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start">
                                            <div
                                                class="bg-blue-100 border-round inline-flex align-items-center justify-content-center"
                                                style="width: 52px; height: 52px">
                                                <img src="/images/blocks/illustration/stats-illustration-3.svg" width="38"
                                                     height="38"/>
                                            </div>
                                            <div class="ml-3 flex-1">
                                                <span class="block text-900 mb-1 text-xl font-medium">Tasks</span>
                                                <p class="text-600 mt-0 mb-5 text-sm">Review of Tasks</p>
                                                <div class="flex align-items-center justify-content-between">
                                                    <span class="text-700">Analysis of Tasks</span>
                                                    <span class="font-bold text-700">8/12</span>
                                                </div>
                                                <ul class="list-none p-0 m-0 flex align-content-center mt-2 gap-2">
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-purple-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-purple-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-purple-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-gray-300"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-gray-300"></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 lg:col-4 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start">
                                            <div
                                                class="bg-blue-100 border-round inline-flex align-items-center justify-content-center"
                                                style="width: 52px; height: 52px">
                                                <img src="/images/blocks/illustration/stats-illustration-1.svg" width="38"
                                                     height="38"/>
                                            </div>
                                            <div class="ml-3 flex-1">
                                                <span class="block text-900 mb-1 text-xl font-medium">Review of Products</span>
                                                <p class="text-600 mt-0 mb-5 text-sm">Analysis of Products</p>
                                                <div class="flex align-items-center justify-content-between">
                                                    <span class="text-700">In Progress</span>
                                                    <span class="font-bold text-700">12/12</span>
                                                </div>
                                                <ul class="list-none p-0 m-0 flex align-content-center mt-2 gap-2">
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-blue-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-blue-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-blue-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-blue-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-blue-500"></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 lg:col-4 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start">
                                            <div
                                                class="bg-blue-100 border-round inline-flex align-items-center justify-content-center"
                                                style="width: 52px; height: 52px">
                                                <img src="/images/blocks/illustration/stats-illustration-2.svg" width="38"
                                                     height="38"/>
                                            </div>
                                            <div class="ml-3 flex-1">
                                                <span class="block text-900 mb-1 text-xl font-medium">Review of Appointments</span>
                                                <p class="text-600 mt-0 mb-5 text-sm">Analysis of Appointments</p>
                                                <div class="flex align-items-center justify-content-between">
                                                    <span class="text-700">In Progress</span>
                                                    <span class="font-bold text-700">4/12</span>
                                                </div>
                                                <ul class="list-none p-0 m-0 flex align-content-center mt-2 gap-2">
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-orange-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-orange-500"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-gray-300"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-gray-300"></li>
                                                    <li style="height: 7px; border-radius: 3px"
                                                        class="flex-1 bg-gray-300"></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div style="height: 10px;"></div>

                    <div class="grid">

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Summary of Tasks</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Tasks"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageTasks"></Button>
                                    <Button label="New Task" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callCreateTask"></Button>
                                </div>

                                <DataTable :value="tasks" scrollable scrollHeight="300px" class="mt-6">
                                    <Column field="description" header="Description" frozen style="min-width: 200px" />
                                    <Column field="requesterFirstName" header="Requester" style="min-width: 200px" />
                                    <Column field="start" header="Start" style="min-width: 200px" />
                                    <Column field="due" header="Due" style="min-width: 200px" />
                                </DataTable>
                            </div>
                        </div>

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Summary of Products</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Products"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageProducts"></Button>
                                    <Button label="Add Product" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callAddProduct"></Button>
                                </div>

                                <DataTable :value="products" scrollable scrollHeight="400px" class="mt-6">
                                    <Column field="uniqueId" header="ID" frozen style="min-width: 200px" />
                                    <Column field="productName" header="Name" style="min-width: 200px" />
                                    <Column field="value" header="Value" style="min-width: 200px" />
                                    <Column field="premium" header="Premium" style="min-width: 200px" />
                                </DataTable>

                            </div>
                        </div>
                    </div>


                    <div class="grid">

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Upcoming Appointments</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Appointments"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageAppointments"></Button>
                                    <Button label="New Appointment" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callCreateAppointment"></Button>
                                </div>

                                <DataTable :value="appointments" scrollable scrollHeight="300px" class="mt-6">
                                    <Column field="scheduled" header="Scheduled" frozen style="min-width: 200px" />
                                    <Column field="description" header="Description" style="min-width: 200px" />
                                    <Column field="type" header="Type" style="min-width: 200px" />
                                    <Column field="status" header="Status" style="min-width: 200px" />
<!--                                    <Column field="balance" header="Balance" style="min-width: 200px" alignFrozen="right" :frozen="balanceFrozen">-->
<!--                                        <template #body="{ data }">-->
<!--                                            <span class="font-bold">{{ formatCurrency(data.balance) }}</span>-->
<!--                                        </template>-->
<!--                                    </Column>-->
                                </DataTable>
                            </div>
                        </div>

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Summary of Notes</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Notes"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageNotes"></Button>
                                    <Button label="Create Note" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callCreateNote"></Button>
                                </div>

                                <DataTable :value="notes" scrollable scrollHeight="400px" class="mt-6">
                                    <Column field="subject" header="Subject" frozen style="min-width: 200px" />
                                    <Column field="type" header="Type" style="min-width: 200px" />
                                    <Column field="format" header="Format" style="min-width: 200px" />
                                </DataTable>

                            </div>
                        </div>
                    </div>


                    <div v-if="(this.companyConfiguration.type === 'H')" class="grid">

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Summary of Invoices</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Invoices"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageInvoices"></Button>
                                    <Button label="Create Invoice" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callCreateInvoice"></Button>
                                </div>

                                <DataTable :value="invoices" scrollable scrollHeight="400px" class="mt-6">
                                    <Column field="id" header="ID" frozen style="min-width: 200px" />
                                    <Column field="uniqueId" header="Unique ID" style="min-width: 200px" />
                                </DataTable>
                            </div>
                        </div>

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Summary of Payments</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Payments"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManagePayments"></Button>
                                    <Button label="New Payment" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callCreatePayment"></Button>
                                </div>

                                <DataTable :value="payments" scrollable scrollHeight="400px" class="mt-6">
                                    <Column field="id" header="ID" frozen style="min-width: 200px" />
                                    <Column field="amount" header="Amount" style="min-width: 200px" />
                                </DataTable>
                            </div>
                        </div>
                    </div>


                    <div class="grid">

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Summary of Labels</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Labels"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageLabels"></Button>
                                    <Button label="Add Label" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callAddLabel"></Button>
                                </div>

                                <div style="height: 10px;"></div>

                                <div class="flex flex-wrap gap-1">
                                    <Tag
                                        v-for="label in this.labels"
                                        :key="label.labelId"
                                        :value="label.labelName"
                                        :severity="getLabelSeverity(label)"/>
                                </div>

                            </div>
                        </div>

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Summary of Files</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Files"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageFiles"></Button>
                                    <Button label="Upload File" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callUploadFile"></Button>
                                </div>

                                <DataTable :value="files" scrollable scrollHeight="400px" class="mt-6">
                                    <Column field="id" header="ID" frozen style="min-width: 200px" />
<!--                                    <Column field="lastName" header="Last Name" style="min-width: 200px" />-->
<!--                                    <Column field="mobile" header="Mobile" style="min-width: 200px" />-->
<!--                                    <Column field="email" header="Email" style="min-width: 200px" />-->
                                </DataTable>
                            </div>
                        </div>
                    </div>

                    <div class="grid">

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">
                                <div class="text-xl text-900 font-medium mb-5">Summary of Provisions</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Provisions"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageProvisions"></Button>
                                    <Button label="Add Provision" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callAddProvision"></Button>
                                </div>

                                <DataTable :value="provisions" scrollable scrollHeight="400px" class="mt-6">
                                    <Column field="id" header="First Name" frozen style="min-width: 200px" />
<!--                                    <Column field="lastName" header="Last Name" style="min-width: 200px" />-->
<!--                                    <Column field="mobile" header="Mobile" style="min-width: 200px" />-->
<!--                                    <Column field="email" header="Email" style="min-width: 200px" />-->
                                </DataTable>
                            </div>
                        </div>

                        <div class="col-12 xl:col-6 flex">
                            <div class="surface-card shadow-2 border-round p-4 flex flex-column w-full">

                                <div class="text-xl text-900 font-medium mb-5">Summary of Audit Trails</div>

                                <div class="flex justify-content-between pt-3">
                                    <Button label="Manage All Audit Trails"
                                            class="p-button-outlined p-button-secondary w-6 mr-2"
                                            :loading="submitted" @click="callManageAuditTrails"></Button>
                                    <Button label="Create Audit Trail" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callCreateAuditTrail"></Button>
                                </div>

                                <DataTable :value="auditTrails" scrollable scrollHeight="400px" class="mt-6">
                                    <Column field="id" header="ID" frozen style="min-width: 200px" />
                                    <Column field="description" header="Description" style="min-width: 200px" />
                                </DataTable>
                            </div>
                        </div>
                    </div>

                    <div class="grid">

                        <div class="col-12">
                            <div class="border-round p-4">
                                <div class="text-xl text-900 font-medium mb-5">Timeline</div>

                                <div class="mb-5 flex">
                                    <div class="flex flex-column align-items-center" style="width: 2rem">
                                                <span
                                                    class="bg-blue-500 text-0 flex align-items-center justify-content-center border-circle p-2">
                                                    <i class="pi pi-star text-xl"></i>
                                                </span>
                                        <div class="h-full bg-blue-500" style="width: 2px; min-height: 4rem"></div>
                                    </div>
                                    <div class="ml-5 surface-card shadow-2 border-round p-3 flex-auto">
                                        <div class="mb-3">
                                            <span class="text-900 font-medium inline-block mr-3">Client Anniversary</span>
                                            <span class="text-500 text-sm">{{ formatTime(calculateTimeDifference(this.client.created)) }} ago</span>
                                        </div>
                                        <div class="line-height-3 text-700 mb-3">
                                            {{ this.client.created }}
                                        </div>

                                    </div>
                                </div>

                                <div class="mb-5 flex">
                                    <div class="flex flex-column align-items-center" style="width: 2rem">
                                                <span
                                                    class="bg-pink-500 text-0 flex align-items-center justify-content-center border-circle p-2">
                                                    <i class="pi pi-star text-xl"></i>
                                                </span>
                                        <div class="h-full bg-pink-500" style="width: 2px; min-height: 4rem"></div>
                                    </div>
                                    <div class="ml-5 surface-card shadow-2 border-round p-3 flex-auto">
                                        <div class="mb-3">
                                            <span class="text-900 font-medium inline-block mr-3">Client Birthday</span>
                                            <span class="text-500 text-sm">{{ formatTime(calculateTimeDifferenceForward(this.client.dob)) }} to go</span>
                                        </div>
                                        <div class="line-height-3 text-700 mb-3">
                                            {{ this.client.dob }}
                                        </div>

                                    </div>
                                </div>

                                <div class="mb-5 flex">
                                    <div class="flex flex-column align-items-center" style="width: 2rem">
                                                <span
                                                    class="bg-orange-500 text-0 flex align-items-center justify-content-center border-circle p-2">
                                                    <i class="pi pi-calendar text-xl"></i>
                                                </span>
                                        <div class="h-full bg-orange-500" style="width: 2px; min-height: 4rem"></div>
                                    </div>
                                    <div class="ml-5 surface-card shadow-2 border-round p-3 flex-auto">
                                        <div class="mb-3">
                                            <span class="text-900 font-medium inline-block mr-3">First Appointment</span>
                                            <span class="text-500 text-sm">2 hours ago</span>
                                        </div>
                                        <div class="line-height-3 text-700 mb-3">
                                            01-AUG-2023
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-5 flex">
                                    <div class="flex flex-column align-items-center" style="width: 2rem">
                                                <span
                                                    class="bg-purple-500 text-0 flex align-items-center justify-content-center border-circle p-2">
                                                    <i class="pi pi-shopping-bag text-xl"></i>
                                                </span>
                                        <div class="h-full bg-purple-500" style="width: 2px; min-height: 4rem"></div>
                                    </div>
                                    <div class="ml-5 surface-card shadow-2 border-round p-3 flex-auto">
                                        <div class="mb-3">
                                            <span class="text-900 font-medium inline-block mr-3">Next Review Date</span>
                                            <span class="text-500 text-sm">4 hours ago</span>
                                        </div>
                                        <div class="line-height-3 text-700 mb-3">
                                            TBC
                                        </div>
                                    </div>
                                </div>

<!--                                <div class="mb-5 flex">-->
<!--                                    <div class="flex flex-column align-items-center" style="width: 2rem">-->
<!--                                                <span-->
<!--                                                    class="bg-green-500 text-0 flex align-items-center justify-content-center border-circle p-2">-->
<!--                                                    <i class="pi pi-money-bill text-xl"></i>-->
<!--                                                </span>-->
<!--                                        <div class="h-full bg-green-500" style="width: 2px; min-height: 4rem"></div>-->
<!--                                    </div>-->
<!--                                    <div class="ml-5 surface-card shadow-2 border-round p-3 flex-auto">-->
<!--                                        <div class="mb-3">-->
<!--                                            <span class="text-900 font-medium inline-block mr-3">First Payment</span>-->
<!--                                            <span class="text-500 text-sm">4 hours ago</span>-->
<!--                                        </div>-->
<!--                                        <div class="line-height-3 text-700 mb-3">-->
<!--                                            15-SEP-2023-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Financial and Risks for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callUpdateFinancialInfo" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Update Financial and Risk Info</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="surface-card p-0 m-0 list-none flex overflow-x-auto select-none">
                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 1, 'text-700 border-transparent': activeTab !== 1}"
                               @click="callMenuSummary">
                                <i class="pi pi-home mr-2"></i>
                                <span class="font-medium">Summary</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 2, 'text-700 border-transparent': activeTab !== 2}"
                               @click="callMenuFinancial">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Financial & Risk</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 3, 'text-700 border-transparent': activeTab !== 3}"
                               @click="callMenuUpdate">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Update</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 4, 'text-700 border-transparent': activeTab !== 4}"
                               @click="callMenuManage">
                                <i class="pi pi-shopping-cart mr-2"></i>
                                <span class="font-medium">Manage</span>
                            </a>
                        </li>
                    </ul>

                    <div style="height: 20px;"></div>

                    <div class="card p-fluid">
                        <div class="surface-card shadow-2 border-round p-4">
                            <div class="flex flex-column md:flex-row gap-4 md:align-items-center xl:px-6 pt-6">

                                <div class="shadow-2 surface-card border-round p-4 flex-1 text-center mb-6 md:mb-0">
                                    <div class="mb-4">
                                        <img src="images/blocks/stats/shoes.png" width="100" height="100" class="-mt-8"/>
                                        <span class="block text-900 mb-1 text-xl font-bold">Net Worth</span>
                                        <p class="text-600 m-0 font-medium">Target : R15,000,000</p>
                                    </div>
                                    <div class="flex justify-content-between align-items-center">
                                        <span class="text-600">Lifetime Goal</span>
                                        <span class="text-900 font-medium">61%</span>
                                    </div>
                                    <div class="surface-300 mt-2 mb-3 border-round" style="height: 7px">
                                        <div class="bg-blue-500 h-full border-round w-6"></div>
                                    </div>
                                    <div class="flex justify-content-between align-items-center">
                                        <span class="text-900">R9,200,000</span>
                                        <span class="text-primary font-medium">8 years left</span>
                                    </div>
                                </div>

                                <div class="shadow-2 surface-card border-round p-4 flex-1 text-center">
                                    <div class="mb-4">
                                        <img src="/images/blocks/stats/hats.png" width="100" height="100" class="-mt-8"/>
                                        <span class="block text-900 mb-1 text-xl font-bold">Annual Income</span>
                                        <p class="text-600 m-0 font-medium">Target : R2,400,000</p>
                                    </div>
                                    <div class="flex justify-content-between align-items-center">
                                        <span class="text-600">Annual Goal</span>
                                        <span class="text-900 font-medium">75%</span>
                                    </div>
                                    <div class="surface-300 mt-2 mb-3 border-round" style="height: 7px">
                                        <div class="bg-yellow-500 h-full border-round w-4"></div>
                                    </div>
                                    <div class="flex justify-content-between align-items-center">
                                        <span class="text-900">R1,800,000</span>
                                        <span class="text-primary font-medium">4 years left</span>
                                    </div>
                                </div>

                                <div class="shadow-2 surface-card border-round p-4 flex-1 text-center">
                                    <div class="mb-4">
                                        <img src="/images/blocks/stats/shoes.png" width="100" height="100" class="-mt-8"/>
                                        <span class="block text-900 mb-1 text-xl font-bold">Total Debt</span>
                                        <p class="text-600 m-0 font-medium">Target : R0</p>
                                    </div>
                                    <div class="flex justify-content-between align-items-center">
                                        <span class="text-600">Annual Goal for Debt Repayment</span>
                                        <span class="text-900 font-medium">45%</span>
                                    </div>
                                    <div class="surface-300 mt-2 mb-3 border-round" style="height: 7px">
                                        <div class="bg-yellow-500 h-full border-round w-4"></div>
                                    </div>
                                    <div class="flex justify-content-between align-items-center">
                                        <span class="text-900">R3,200,000</span>
                                        <span class="text-primary font-medium">7 years left</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="card p-fluid">
                        <div class="surface-card shadow-2 border-round p-4">

                            <div class="grid">
                                <div class="col-12 lg:col-4 p-3">
                                    <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                                        <div class="flex align-items-center justify-content-between">
                                            <div>
                                                <span class="text-3xl text-900 font-bold">R150,000 per month</span>
                                                <p class="mt-2 mb-0 text-600 text-xl">Income</p>
                                            </div>
                                            <div>
                                                <img src="/images/blocks/illustration/stats-illustration-4.svg"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 lg:col-4 p-3">
                                    <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                                        <div class="flex align-items-center justify-content-between">
                                            <div>
                                                <span class="text-3xl text-900 font-bold">R95,000 per month</span>
                                                <p class="mt-2 mb-0 text-600 text-xl">Expenses</p>
                                            </div>
                                            <div>
                                                <img src="/images/blocks/illustration/stats-illustration-5.svg"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 lg:col-4 p-3">
                                    <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                                        <div class="flex align-items-center justify-content-between">
                                            <div>
                                                <span class="text-3xl text-900 font-bold">R45,000 per month</span>
                                                <p class="mt-2 mb-0 text-600 text-xl">Tax Payments</p>
                                            </div>
                                            <div>
                                                <img src="/images/blocks/illustration/stats-illustration-6.svg"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card p-fluid">
                        <div class="surface-card shadow-2 border-round p-4">

                            <div class="grid">
                                <div class="col-12 lg:col-3 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start mb-5">
                                            <img src="/images/blocks/avatars/circle-big/avatar-m-1.png" width="56"
                                                 height="56"/>
                                            <div class="ml-3">
                                                <span class="block text-900 mb-1 text-xl font-medium">Investments</span>
                                                <p class="text-600 mt-0 mb-0">Long-Term and Short-Term</p>
                                            </div>
                                        </div>
                                        <ul class="list-none p-0 m-0">
                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Retirement Annuities</span>
                                                </span>
                                                    <span class="text-cyan-500 font-medium">R1,800,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-cyan-500 h-full"
                                                         style="width: 34%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Endowment Policies</span>
                                                </span>
                                                    <span class="text-orange-500 font-medium">R400,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-orange-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Unit Trusts</span>
                                                </span>
                                                    <span class="text-pink-500 font-medium">R600,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-pink-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Other</span>
                                                </span>
                                                    <span class="text-red-500 font-medium">R200,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-red-500 h-full"
                                                         style="width: 79%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                                <div class="col-12 lg:col-3 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start mb-5">
                                            <img src="/images/blocks/avatars/circle-big/avatar-f-2.png" width="56"
                                                 height="56"/>
                                            <div class="ml-3">
                                                <span class="block text-900 mb-1 text-xl font-medium">Risk Cover (Long-Term)</span>
                                                <p class="text-600 mt-0 mb-0">Life, Disability and Dread Disease</p>
                                            </div>
                                        </div>
                                        <ul class="list-none p-0 m-0">
                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Life or Death Cover</span>
                                        </span>
                                                    <span class="text-cyan-500 font-medium">R5,000,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-cyan-500 h-full"
                                                         style="width: 64%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Permanent Disability Cover</span>
                                        </span>
                                                    <span class="text-orange-500 font-medium">R2,000,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-orange-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Severe Illness Cover</span>
                                        </span>
                                                    <span class="text-pink-500 font-medium">R1,000,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-pink-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Income Protection</span>
                                                </span>
                                                    <span class="text-green-500 font-medium">R80,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-green-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Keyman Insurance</span>
                                                </span>
                                                    <span class="text-purple-500 font-medium">R3,000,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-purple-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-12 lg:col-3 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start mb-5">
                                            <img src="/images/blocks/avatars/circle-big/avatar-m-3.png" width="56"
                                                 height="56"/>
                                            <div class="ml-3">
                                                <span class="block text-900 mb-1 text-xl font-medium">Risk Cover (Short-Term)</span>
                                                <p class="text-600 mt-0 mb-0">Cover for the assets and shorter-term needs</p>
                                            </div>
                                        </div>
                                        <ul class="list-none p-0 m-0">
                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Vehicles</span>
                                                </span>
                                                    <span class="text-indigo-500 font-medium">R800,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-indigo-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Household Contents</span>
                                                </span>
                                                    <span class="text-yellow-500 font-medium">R600,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-yellow-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Funeral Cover</span>
                                                </span>
                                                    <span class="text-blue-500 font-medium">R50,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-blue-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Professional Indemnity</span>
                                                </span>
                                                    <span class="text-gray-500 font-medium">R2,000,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-gray-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Public Liability Insurance</span>
                                                </span>
                                                    <span class="text-red-500 font-medium">R5,000,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-red-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Building Insurance</span>
                                        </span>
                                                    <span class="text-teal-500 font-medium">R4,500,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-teal-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-12 lg:col-3 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start mb-5">
                                            <img src="/images/blocks/avatars/circle-big/avatar-m-3.png" width="56"
                                                 height="56"/>
                                            <div class="ml-3">
                                                <span class="block text-900 mb-1 text-xl font-medium">Health Cover</span>
                                                <p class="text-600 mt-0 mb-0">Day-to-Day Expenses, Hospital Cover and Savings Benefit</p>
                                            </div>
                                        </div>
                                        <ul class="list-none p-0 m-0">
                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Day-To-Day Expenses</span>
                                        </span>
                                                    <span class="text-cyan-500 font-medium">R40,000 annually</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-cyan-500 h-full"
                                                         style="width: 34%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Hospital Benefit</span>
                                        </span>
                                                    <span class="text-orange-500 font-medium">300% of recommended rates</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-orange-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Savings Benefit</span>
                                        </span>
                                                    <span class="text-pink-500 font-medium">R25,000 annually</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-pink-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Gap Cover</span>
                                        </span>
                                                    <span class="text-green-500 font-medium">500% of medical aid rates</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-green-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Prescribed Minimum Benefits</span>
                                        </span>
                                                    <span class="text-indigo-500 font-medium">15 sessions annually</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-indigo-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Mental Health Benefit</span>
                                        </span>
                                                    <span class="text-yellow-500 font-medium">R25,000 annually</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-yellow-500 h-full"
                                                         style="width: 79%; border-radius: 4px"></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="card p-fluid">
                        <div class="surface-card shadow-2 border-round p-4">

                            <div class="grid">
                                <div class="col-12 lg:col-3 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start mb-5">
                                            <img src="/images/blocks/avatars/circle-big/avatar-m-1.png" width="56"
                                                 height="56"/>
                                            <div class="ml-3">
                                                <span class="block text-900 mb-1 text-xl font-medium">Assets</span>
                                                <p class="text-600 mt-0 mb-0">Summary of all assets</p>
                                            </div>
                                        </div>

                                        <ul class="list-none p-0 m-0">
                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Real Estate Portfolio</span>
                                                </span>
                                                    <span class="text-green-500 font-medium">R4,500,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-green-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Share Portfolio</span>
                                                </span>
                                                    <span class="text-indigo-500 font-medium">R2,200,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-indigo-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Dividend Income Portfolio</span>
                                                </span>
                                                    <span class="text-yellow-500 font-medium">R650,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-yellow-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Business Portfolio</span>
                                                </span>
                                                    <span class="text-blue-500 font-medium">R1,500,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-blue-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Crypto Portfolio</span>
                                                </span>
                                                    <span class="text-gray-500 font-medium">R150,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-gray-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Motor Vehicle Portfolio</span>
                                                </span>
                                                    <span class="text-purple-500 font-medium">R800,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-purple-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Other</span>
                                                </span>
                                                    <span class="text-red-500 font-medium">R200,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-red-500 h-full"
                                                         style="width: 79%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                                <div class="col-12 lg:col-3 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start mb-5">
                                            <img src="/images/blocks/avatars/circle-big/avatar-f-2.png" width="56"
                                                 height="56"/>
                                            <div class="ml-3">
                                                <span class="block text-900 mb-1 text-xl font-medium">Liabilities</span>
                                                <p class="text-600 mt-0 mb-0">Summary of all liabilities</p>
                                            </div>
                                        </div>
                                        <ul class="list-none p-0 m-0">
                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Real Estate Related</span>
                                        </span>
                                                    <span class="text-cyan-500 font-medium">R2,500,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-cyan-500 h-full"
                                                         style="width: 64%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Motor Vehicle Related</span>
                                        </span>
                                                    <span class="text-orange-500 font-medium">R450,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-orange-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Credit Card Related</span>
                                        </span>
                                                    <span class="text-pink-500 font-medium">R120,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-pink-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Short-Term Loan Related</span>
                                                </span>
                                                    <span class="text-green-500 font-medium">R130,000</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-green-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-12 lg:col-3 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start mb-5">
                                            <img src="/images/blocks/avatars/circle-big/avatar-m-3.png" width="56"
                                                 height="56"/>
                                            <div class="ml-3">
                                                <span class="block text-900 mb-1 text-xl font-medium">Income</span>
                                                <p class="text-600 mt-0 mb-0">Summary of all income</p>
                                            </div>
                                        </div>
                                        <ul class="list-none p-0 m-0">
                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Professional Income or Salary</span>
                                                </span>
                                                    <span class="text-indigo-500 font-medium">R90,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-indigo-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Business Income</span>
                                                </span>
                                                    <span class="text-yellow-500 font-medium">R30,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-yellow-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Rental Income</span>
                                                </span>
                                                    <span class="text-blue-500 font-medium">R15,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-blue-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Investment Income</span>
                                                </span>
                                                    <span class="text-gray-500 font-medium">R5,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-gray-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Dividend Income</span>
                                                </span>
                                                    <span class="text-red-500 font-medium">R10,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-red-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Other Income</span>
                                                </span>
                                                    <span class="text-purple-500 font-medium">R0 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-purple-500 h-full"
                                                         style="width: 75%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                                <div class="col-12 lg:col-3 p-2">
                                    <div class="shadow-2 surface-card border-round p-4 h-full">
                                        <div class="flex align-items-start mb-5">
                                            <img src="/images/blocks/avatars/circle-big/avatar-m-3.png" width="56"
                                                 height="56"/>
                                            <div class="ml-3">
                                                <span class="block text-900 mb-1 text-xl font-medium">Expenses</span>
                                                <p class="text-600 mt-0 mb-0">Summary of all expenses</p>
                                            </div>
                                        </div>

                                        <ul class="list-none p-0 m-0">
                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Accommodation Related</span>
                                                </span>
                                                    <span class="text-green-500 font-medium">R35,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-green-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Travel Related</span>
                                                </span>
                                                    <span class="text-indigo-500 font-medium">R12,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-indigo-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Groceries</span>
                                                </span>
                                                    <span class="text-yellow-500 font-medium">R15,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-yellow-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Entertainment</span>
                                                </span>
                                                    <span class="text-blue-500 font-medium">R8,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-blue-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Debt Repayments</span>
                                                </span>
                                                    <span class="text-gray-500 font-medium">R15,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-gray-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Miscellaneous</span>
                                                </span>
                                                    <span class="text-purple-500 font-medium">R5,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-purple-500 h-full"
                                                         style="width: 45%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Emergency Fund Savings</span>
                                                </span>
                                                    <span class="text-red-500 font-medium">R3,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-red-500 h-full"
                                                         style="width: 79%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Investing</span>
                                                </span>
                                                    <span class="text-teal-500 font-medium">R7,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-teal-500 h-full"
                                                         style="width: 79%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Risk Cover (Long-Term)</span>
                                                </span>
                                                    <span class="text-orange-500 font-medium">R4,000 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-orange-500 h-full"
                                                         style="width: 79%; border-radius: 4px"></div>
                                                </div>
                                            </li>

                                            <li class="mb-5">
                                                <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Risk Cover (Short-Term)</span>
                                                </span>
                                                    <span class="text-pink-500 font-medium">R2,500 per month</span>
                                                </div>
                                                <div class="surface-300 w-full mt-2"
                                                     style="height: 7px; border-radius: 4px">
                                                    <div class="bg-pink-500 h-full"
                                                         style="width: 79%; border-radius: 4px"></div>
                                                </div>
                                            </li>



                                        </ul>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="surface-card p-0 m-0 list-none flex overflow-x-auto select-none">
                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 1, 'text-700 border-transparent': activeTab !== 1}"
                               @click="callMenuSummary">
                                <i class="pi pi-home mr-2"></i>
                                <span class="font-medium">Summary</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 2, 'text-700 border-transparent': activeTab !== 2}"
                               @click="callMenuFinancial">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Financial & Risk</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 3, 'text-700 border-transparent': activeTab !== 3}"
                               @click="callMenuUpdate">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Update</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 4, 'text-700 border-transparent': activeTab !== 4}"
                               @click="callMenuManage">
                                <i class="pi pi-shopping-cart mr-2"></i>
                                <span class="font-medium">Manage</span>
                            </a>
                        </li>
                    </ul>

                    <div style="height: 20px;"></div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted"
                            @click="updateHealthcareClient"></Button>

                    <Accordion class="accordion-custom" :activeIndex="0">

                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>General</span>
                            </template>

                            <div class="field">
                                <label for="type">Type</label>
                                <Dropdown v-model="client.type" :options="clientTypes" optionLabel="name"
                                          optionValue="code"
                                          placeholder="Select a Type"/>
                            </div>

                            <div v-show="client.type === 'J'" class="field">
                                <label for="name">Name</label>
                                <InputText id="name" v-model.trim="client.name" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="firstName">First Name</label>
                                <InputText id="firstName" v-model.trim="client.firstName" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="lastName">Last Name</label>
                                <InputText id="lastName" v-model.trim="client.lastName" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="preferredName">Preferred Name</label>
                                <InputText id="preferredName" v-model.trim="client.preferredName" required="true"/>
                            </div>

                            <div class="field">
                                <label for="email">Email</label>
                                <InputText id="email" v-model.trim="client.email" required="true"/>
                            </div>

                            <div class="field">
                                <label for="alternateEmail">Alternate Emails (separated by comma)</label>
                                <InputText id="alternateEmail" v-model.trim="client.alternateEmail" required="false"/>
                            </div>

                            <div class="field">
                                <label for="mobile">Mobile Number</label>
                                <InputText id="mobile" v-model.trim="client.mobile" required="true"/>
                            </div>

                            <div class="field">
                                <label for="idNumber">ID Number</label>
                                <InputText id="idNumber" v-model.trim="client.idNumber" required="false"/>
                            </div>

                            <div class="field">
                                <label for="dob">Date of Birth</label>
                                <Calendar id="dob" v-model="client.dob" dateFormat="yy-mm-dd"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="gender">Gender</label>
                                <Dropdown v-model="client.gender" :options="genderTypes" optionLabel="name"
                                          required="true"
                                          optionValue="code" placeholder="Select a Gender"/>
                            </div>

                            <div v-show="(client.type === 'N' || client.type === 'M') && client.gender === 'O'"
                                 class="field">
                                <label for="genderOther">Please Specify Gender Type</label>
                                <InputText id="genderOther" v-model.trim="client.genderOther" required="true"/>
                            </div>

                            <div class="field">
                                <label for="commStatus">Communication Approval?</label>
                                <Dropdown v-model="client.commStatus" :options="confirmationTypes" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="taxRegistered">Tax Registered?</label>
                                <Dropdown v-model="client.taxRegistered" :options="confirmationTypes" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div v-show="client.taxRegistered == 'Y'" class="field">
                                <label for="taxNumber">Tax Number</label>
                                <InputText id="taxNumber" v-model.trim="client.taxNumber" required="false"/>
                            </div>

                            <div class="field">
                                <label for="addressCountry">Country</label>
                                <Dropdown v-model="client.addressCountry" :options="countries" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="address1">Address Line 1</label>
                                <InputText id="address1" v-model.trim="client.address1" required="true"/>
                            </div>

                            <div class="field">
                                <label for="address2">Address Line 2</label>
                                <InputText id="address2" v-model.trim="client.address2" required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressRegion">Region</label>
                                <InputText id="addressRegion" v-model.trim="client.addressRegion" required="true"/>
                            </div>

                            <div v-show="client.addressCountry === 'ZA'" class="field">
                                <label for="addressState">Province</label>
                                <Dropdown v-model="client.addressState" :options="regionsSouthAfrica" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div v-show="client.addressCountry === 'UK'" class="field">
                                <label for="addressState">County</label>
                                <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                            </div>

                            <div v-show="client.addressCountry != 'ZA' && client.addressCountry != 'UK'" class="field">
                                <label for="addressState">State</label>
                                <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressPostalCode">Postal Code</label>
                                <InputText id="addressPostalCode" v-model.trim="client.addressPostalCode"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="status">Status</label>
                                <Dropdown v-model="client.status" :options="statusTypes" optionLabel="name"
                                          optionValue="code"
                                          placeholder="Select a Status"/>
                            </div>

                            <div v-show="client.type === 'M'" class="field">
                                <label for="fatherClientName">Parent or Guardian #1</label>
                                <AutoComplete v-model="client.fatherName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div v-show="client.type === 'M'" class="field">
                                <label for="motherClientName">Parent or Guardian #2</label>
                                <AutoComplete v-model="client.motherName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="billingClient">Billing Contact</label>
                                <AutoComplete v-model="client.billingClientName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="adminClient">Administration Contact</label>
                                <AutoComplete v-model="client.adminClientName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <!--                            <div class="field">-->
                            <!--                                <label for="affiliateContact">Affiliate Contact</label>-->
                            <!--                                <AutoComplete v-model="client.affiliateClientName" :dropdown="true" :multiple="false"-->
                            <!--                                              :suggestions="filteredAffiliateClients" @complete="searchAffiliateClients($event)"-->
                            <!--                                              field="name" placeholder="Type the first few characters to search"/>-->
                            <!--                            </div>-->

                            <div v-show="companyConfiguration.type === 'H'" class="field">
                                <label for="practitioner">Assigned Practitioner</label>
                                <AutoComplete v-model="client.practitionerName" :dropdown="true" :multiple="false"
                                              :suggestions="filteredPractitioners"
                                              @complete="searchCompanyPractitionersInternal($event)"
                                              field="fullName" placeholder="Type the first few characters to search"/>
                            </div>

                        </AccordionTab>

                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>Diagnostic</span>
                            </template>

                            <div class="field">
                                <label for="icd10Code1">ICD10 Code (Primary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode1"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="icd10Code2">ICD10 Code (Supplementary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode2"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="icd10Code3">ICD10 Code (Supplementary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode3"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="icd10Code4">ICD10 Code (Supplementary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode4"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="icd10Code5">ICD10 Code (Supplementary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode5"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>
                        </AccordionTab>


                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>Health Insurance</span>
                            </template>

                            <div class="field">
                                <label for="medicalProviderId">Current Provider #</label>
                                <InputText id="medicalProviderId" type="text" :disabled="true"
                                           v-model.trim="clientConfiguration.providerId"/>
                            </div>

                            <div class="field">
                                <label for="medicalName">Medical Name</label>
                                <AutoComplete v-model="clientConfiguration.medicalName" :dropdown="false"
                                              :multiple="false" :suggestions="filteredProviders"
                                              @complete="searchProviders($event)" field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="medicalNumber">Medical Number</label>
                                <InputText id="medicalNumber" v-model.trim="clientConfiguration.medicalNumber"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalPlan">Medical Plan</label>
                                <InputText id="medicalPlan" v-model.trim="clientConfiguration.medicalPlan"
                                           required="true"/>
                            </div>

                            <div style="height: 20px;"></div>

                            <div class="field flex align-items-center">
                                <Checkbox
                                    id="copyMainMemberDetails"
                                    v-model="clientConfiguration.copyMainMemberDetails"
                                    :binary="true"/>
                                <label for="copyMainMemberDetails" class="ml-2 mb-0">
                                    Copy Main Member Details?
                                </label>
                            </div>

                            <div style="height: 20px;"></div>

                            <div class="field">
                                <label for="medicalMemberFirstname">Main Member - First Name</label>
                                <InputText id="medicalMemberFirstname"
                                           v-model.trim="clientConfiguration.medicalMemberFirstname" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalMemberLastname">Main Member - Last Name</label>
                                <InputText id="medicalMemberLastname"
                                           v-model.trim="clientConfiguration.medicalMemberLastname" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalMemberInitials">Main Member - Initials</label>
                                <InputText id="medicalMemberInitials"
                                           v-model.trim="clientConfiguration.medicalMemberInitials" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalMemberId">Main Member - ID Number</label>
                                <InputText id="medicalMemberId" v-model.trim="clientConfiguration.medicalMemberId"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalMemberCode">Main Member - Code</label>
                                <InputText id="medicalMemberCode" v-model.trim="clientConfiguration.medicalMemberCode"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantFirstname">Patient - First Name</label>
                                <InputText id="medicalDependantFirstname"
                                           v-model.trim="clientConfiguration.medicalDependantFirstname"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantLastname">Patient - Last Name</label>
                                <InputText id="medicalDependantLastname"
                                           v-model.trim="clientConfiguration.medicalDependantLastname" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantInitials">Patient - Initials</label>
                                <InputText id="medicalDependantInitials"
                                           v-model.trim="clientConfiguration.medicalDependantInitials" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantId">Patient - ID Number</label>
                                <InputText id="medicalDependantId" v-model.trim="clientConfiguration.medicalDependantId"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantCode">Patient - Code</label>
                                <InputText id="medicalDependantCode"
                                           v-model.trim="clientConfiguration.medicalDependantCode" required="true"/>
                            </div>

                            <div class="field">
                                <label for="claimPreference">Do You Wish to Claim from Health
                                    Insurance?</label>
                                <Dropdown v-model="clientConfiguration.claimPreference" :options="confirmationTypes"
                                          optionLabel="name" optionValue="code" placeholder="Select a Response"/>
                            </div>

                            <div class="field">
                                <label for="authorisation">Authorisation Number</label>
                                <InputText id="authorisation" v-model.trim="clientConfiguration.authorisation"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="inHospital">In-Hospital Client?</label>
                                <Dropdown v-model="clientConfiguration.inHospital" :options="confirmationTypes"
                                          optionLabel="name" optionValue="code" placeholder="Select a Response"/>
                            </div>

                            <div class="field">
                                <label for="pmb">Prescribed Minimum Benefit (PMB) Client?</label>
                                <Dropdown v-model="clientConfiguration.pmb" :options="confirmationTypes"
                                          optionLabel="name" optionValue="code" placeholder="Select a Response"/>
                            </div>

                            <Button label="Check Health Insurance Details" class="mr-2 mb-2" :loading="submitted"
                                    @click="updateHealthcareInsuranceDetails"></Button>

                        </AccordionTab>


                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>Referring Healthcare Practitioner</span>
                            </template>

                            <div class="field">
                                <label for="useExistingReferringPractitioner">Use Existing Referring
                                    Practitioner?</label>
                                <Dropdown v-model="clientConfiguration.useExistingReferringPractitioner"
                                          :options="confirmationTypes" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'Y'" class="field">
                                <label for="referringPractitioner">Referring Practitioner</label>
                                <AutoComplete v-model="clientConfiguration.referringName" :dropdown="true"
                                              :multiple="false"
                                              :suggestions="filteredPractitionersReferring"
                                              @complete="searchCompanyPractitionersReferring($event)"
                                              field="fullName" placeholder="Type the first few characters to search"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringFirstname">First Name</label>
                                <InputText id="referringFirstname" v-model.trim="clientConfiguration.referringFirstname"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringLastname">Last Name</label>
                                <InputText id="referringLastname" v-model.trim="clientConfiguration.referringLastname"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringEmail">Email</label>
                                <InputText id="referringEmail" v-model.trim="clientConfiguration.referringEmail"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringMobile">Mobile</label>
                                <InputText id="referringMobile" v-model.trim="clientConfiguration.referringMobile"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringRegistrationNumber">Registration Number</label>
                                <InputText id="referringRegistrationNumber"
                                           v-model.trim="clientConfiguration.referringRegistrationNumber"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringPracticeNumber">Practice Number</label>
                                <InputText id="referringPracticeNumber"
                                           v-model.trim="clientConfiguration.referringPracticeNumber" required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringQualification">Qualification</label>
                                <InputText id="referringQualification"
                                           v-model.trim="clientConfiguration.referringQualification" required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="type">Practitioner Type</label>
                                <Dropdown v-model="clientConfiguration.referringType" :options="practitionerTypes"
                                          optionLabel="name" optionValue="code"
                                          placeholder="Select a Practitioner Type"/>
                            </div>


                        </AccordionTab>

                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>Road Accident Fund</span>
                            </template>

                            <div class="field">
                                <label for="rafLinkNumber">Link Number</label>
                                <InputText id="rafLinkNumber" v-model.trim="clientConfiguration.rafLinkNumber"
                                           required="true"/>
                            </div>

                        </AccordionTab>

                    </Accordion>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted"
                            @click="updateHealthcareClient"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="surface-card p-0 m-0 list-none flex overflow-x-auto select-none">
                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 1, 'text-700 border-transparent': activeTab !== 1}"
                               @click="callMenuSummary">
                                <i class="pi pi-home mr-2"></i>
                                <span class="font-medium">Summary</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 2, 'text-700 border-transparent': activeTab !== 2}"
                               @click="callMenuFinancial">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Financial & Risk</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 3, 'text-700 border-transparent': activeTab !== 3}"
                               @click="callMenuUpdate">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Update</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 4, 'text-700 border-transparent': activeTab !== 4}"
                               @click="callMenuManage">
                                <i class="pi pi-shopping-cart mr-2"></i>
                                <span class="font-medium">Manage</span>
                            </a>
                        </li>
                    </ul>

                    <div style="height: 20px;"></div>

                    <div class="surface-section">
                        <div class="text-500 mb-5">Select an operation below.</div>
                        <ul class="list-none p-0 m-0">
                            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                <div class="text-500 w-6 md:w-2 font-medium">Send an Email</div>
                                <div class="w-6 md:w-4 flex justify-content-end">
                                    <Button label="Send Email" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callSendEmail"></Button>
                                </div>
                            </li>

                            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                <div class="text-500 w-6 md:w-2 font-medium">Send an SMS</div>
                                <div class="w-6 md:w-4 flex justify-content-end">
                                    <Button label="Send SMS" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callSendSms"></Button>
                                </div>
                            </li>

                            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                <div class="text-500 w-6 md:w-2 font-medium">Send Booking Link</div>
                                <div class="w-6 md:w-4 flex justify-content-end">
                                    <Button label="Send Booking Link" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callSendBookingLink"></Button>
                                </div>
                            </li>

                            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                <div class="text-500 w-6 md:w-2 font-medium">Send Digital Form Link</div>
                                <div class="w-6 md:w-4 flex justify-content-end">
                                    <Button label="Send Digital Form Link" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callSendDigitalFormLink"></Button>
                                </div>
                            </li>

                            <li v-if="companyConfiguration.type !== 'F'" class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                <div class="text-500 w-6 md:w-2 font-medium">Send Unpaid Notice</div>
                                <div class="w-6 md:w-4 flex justify-content-end">
                                    <Button label="Send Unpaid Notice" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callCreateUnpaidNotice"></Button>
                                </div>
                            </li>

                            <li v-if="companyConfiguration.type !== 'F'" class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                <div class="text-500 w-6 md:w-2 font-medium">Send Statement</div>
                                <div class="w-6 md:w-4 flex justify-content-end">
                                    <Button label="Send Statement" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callSendStatement"></Button>
                                </div>
                            </li>

                            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                <div class="text-500 w-6 md:w-2 font-medium">Archive Client</div>
                                <div class="w-6 md:w-4 flex justify-content-end">
                                    <Button label="Archive Client" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callArchiveClient"></Button>
                                </div>
                            </li>

                            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                                <div class="text-500 w-6 md:w-2 font-medium">Delete Client</div>
                                <div class="w-6 md:w-4 flex justify-content-end">
                                    <Button label="Delete Client" class="p-button-outlined w-6 ml-2"
                                            :loading="submitted" @click="callDeleteClient"></Button>
                                </div>
                            </li>

                        </ul>
                    </div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Financial and Risk Information for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                    <h4>Investments</h4>

                    <div class="field">
                        <label for="retirementAnnuities">Retirement Annuities</label>
                        <InputNumber id="retirementAnnuities" v-model="financialInfo.retirementAnnuities" required="true"/>
                    </div>

                    <div class="field">
                        <label for="endowmentPolicies">Endowment Policies</label>
                        <InputNumber id="endowmentPolicies" v-model="financialInfo.endowmentPolicies" required="true"/>
                    </div>

                    <div class="field">
                        <label for="unitTrusts">Unit Trusts</label>
                        <InputNumber id="unitTrusts" v-model="financialInfo.unitTrusts" required="true"/>
                    </div>

                    <div class="field">
                        <label for="other">Other</label>
                        <InputNumber id="other" v-model="financialInfo.other" required="true"/>
                    </div>

                    <div style="height: 20px;"></div>
                    <h4>Risk Cover (Long-Term)</h4>

                    <div class="field">
                        <label for="lifeCover">Life or Death Cover</label>
                        <InputNumber id="lifeCover" v-model="financialInfo.lifeCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="disabilityCover">Permanent Disability Cover</label>
                        <InputNumber id="disabilityCover" v-model="financialInfo.disabilityCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="illnessCover">Severe Illness Cover</label>
                        <InputNumber id="illnessCover" v-model="financialInfo.illnessCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="incomeProtection">Income Protection</label>
                        <InputNumber id="incomeProtection" v-model="financialInfo.incomeProtection" required="true"/>
                    </div>

                    <div class="field">
                        <label for="keyman">Keyman Insurance</label>
                        <InputNumber id="keyman" v-model="financialInfo.keyman" required="true"/>
                    </div>


                    <div style="height: 20px;"></div>
                    <h4>Risk Cover (Short-Term)</h4>

                    <div class="field">
                        <label for="vehicles">Vehicles</label>
                        <InputNumber id="vehicles" v-model="financialInfo.vehicles" required="true"/>
                    </div>

                    <div class="field">
                        <label for="householdContents">Household Contents</label>
                        <InputNumber id="householdContents" v-model="financialInfo.householdContents" required="true"/>
                    </div>

                    <div class="field">
                        <label for="funeralCover">Funeral Cover</label>
                        <InputNumber id="funeralCover" v-model="financialInfo.funeralCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="professionalIndemnity">Professional Indemnity</label>
                        <InputNumber id="professionalIndemnity" v-model="financialInfo.professionalIndemnity" required="true"/>
                    </div>

                    <div class="field">
                        <label for="publicLiability">Public Liability Insurance</label>
                        <InputNumber id="publicLiability" v-model="financialInfo.publicLiability" required="true"/>
                    </div>

                    <div class="field">
                        <label for="buildingInsurance">Building Insurance</label>
                        <InputNumber id="buildingInsurance" v-model="financialInfo.buildingInsurance" required="true"/>
                    </div>


                    <div style="height: 20px;"></div>
                    <h4>Health Cover</h4>

                    <div class="field">
                        <label for="dayToDay">Day-To-Day Expenses</label>
                        <InputNumber id="dayToDay" v-model="financialInfo.dayToDay" required="true"/>
                    </div>

                    <div class="field">
                        <label for="hospitalBenefit">Hospital Benefit</label>
                        <InputNumber id="hospitalBenefit" v-model="financialInfo.hospitalBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="savingsBenefit">Savings Benefit</label>
                        <InputNumber id="savingsBenefit" v-model="financialInfo.savingsBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Gap Cover</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="pmb">Prescribed Minimum Benefits</label>
                        <InputNumber id="pmb" v-model="financialInfo.pmb" required="true"/>
                    </div>

                    <div class="field">
                        <label for="mentalHealthBenefit">Mental Health Benefit</label>
                        <InputNumber id="mentalHealthBenefit" v-model="financialInfo.mentalHealthBenefit" required="true"/>
                    </div>


                    <div style="height: 20px;"></div>
                    <h4>Assets</h4>

                    <div class="field">
                        <label for="dayToDay">Real Estate Portfolio</label>
                        <InputNumber id="dayToDay" v-model="financialInfo.dayToDay" required="true"/>
                    </div>

                    <div class="field">
                        <label for="hospitalBenefit">Share Portfolio</label>
                        <InputNumber id="hospitalBenefit" v-model="financialInfo.hospitalBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="savingsBenefit">Dividend Income Portfolio</label>
                        <InputNumber id="savingsBenefit" v-model="financialInfo.savingsBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Business Portfolio</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="pmb">Crypto Portfolio</label>
                        <InputNumber id="pmb" v-model="financialInfo.pmb" required="true"/>
                    </div>

                    <div class="field">
                        <label for="mentalHealthBenefit">Motor Vehicle Portfolio</label>
                        <InputNumber id="mentalHealthBenefit" v-model="financialInfo.mentalHealthBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="mentalHealthBenefit">Other</label>
                        <InputNumber id="mentalHealthBenefit" v-model="financialInfo.mentalHealthBenefit" required="true"/>
                    </div>

                    <div style="height: 20px;"></div>
                    <h4>Liabilities</h4>

                    <div class="field">
                        <label for="dayToDay">Real Estate Related</label>
                        <InputNumber id="dayToDay" v-model="financialInfo.dayToDay" required="true"/>
                    </div>

                    <div class="field">
                        <label for="hospitalBenefit">Motor Vehicle Related</label>
                        <InputNumber id="hospitalBenefit" v-model="financialInfo.hospitalBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="savingsBenefit">Credit Card Related</label>
                        <InputNumber id="savingsBenefit" v-model="financialInfo.savingsBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Short-Term Loan Related</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>


                    <div style="height: 20px;"></div>
                    <h4>Income</h4>

                    <div class="field">
                        <label for="dayToDay">Professional Income or Salary</label>
                        <InputNumber id="dayToDay" v-model="financialInfo.dayToDay" required="true"/>
                    </div>

                    <div class="field">
                        <label for="hospitalBenefit">Business Income</label>
                        <InputNumber id="hospitalBenefit" v-model="financialInfo.hospitalBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="savingsBenefit">Rental Income</label>
                        <InputNumber id="savingsBenefit" v-model="financialInfo.savingsBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Investment Income</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Dividend Income</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Other Income</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>


                    <div style="height: 20px;"></div>
                    <h4>Expenses</h4>

                    <div class="field">
                        <label for="dayToDay">Accommodation Related</label>
                        <InputNumber id="dayToDay" v-model="financialInfo.dayToDay" required="true"/>
                    </div>

                    <div class="field">
                        <label for="hospitalBenefit">Travel Related</label>
                        <InputNumber id="hospitalBenefit" v-model="financialInfo.hospitalBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="savingsBenefit">Groceries</label>
                        <InputNumber id="savingsBenefit" v-model="financialInfo.savingsBenefit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Entertainment</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Debt Repayments</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Miscellaneous</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Emergency Fund Savings</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Investing</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Risk Cover (Long-Term)</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>

                    <div class="field">
                        <label for="gapCover">Risk Cover (Short-Term)</label>
                        <InputNumber id="gapCover" v-model="financialInfo.gapCover" required="true"/>
                    </div>


                </div>
            </div>
        </div>


        <div v-if="activeTab === 101" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Appointments for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 102" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Appointment for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 103" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Tasks for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 104" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Task for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 105" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Products for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 106" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Product for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                    <div class="field">
                        <label for="product">Product</label>
                        <AutoComplete placeholder="Search" :dropdown="true" :multiple="false" :required="true"
                                      v-model="selectedProduct.product" :suggestions="filteredProducts"
                                      @complete="searchProducts($event)" field="name"/>
                    </div>

                    <Button label="Add" class="mr-2 mb-2" :loading="submitted" @click="addProduct"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuSummary"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 107" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Notes for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 108" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Note for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 109" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Invoices for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 110" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Invoice for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 111" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Payments for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 112" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Payment for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 113" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Labels for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                    <DataTable :value="labels" :paginator="true" class="p-datatable-gridlines" :rows="100"
                               dataKey="id" :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true"
                               :striped-rows="true"
                               :reorderableColumns="true" :sortMode="'multiple'" responsiveLayout="scroll">

                        <template #empty>
                            No labels found.
                        </template>

                        <template #loading>
                            Loading labels. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1" :loading="submitted"
                                        @click="callDeleteLabel(data)"/>
                            </template>
                        </Column>

                        <Column field="labelName" header="Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Name</span>
                                {{ data.labelName }}
                            </template>
                        </Column>
                    </DataTable>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 114" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Label for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                    <div class="field">
                        <label for="label">Label</label>
                        <AutoComplete placeholder="Search" :dropdown="true" :multiple="false" :required="true"
                                      v-model="selectedLabel.label" :suggestions="filteredLabels"
                                      @complete="searchLabels($event)" field="name"/>
                    </div>

                    <Button label="Add" class="mr-2 mb-2" :disabled="!canAddLabel"
                            :loading="submitted" @click="addLabel"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetLabels"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 115" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Files for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 116" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Upload File for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                    <div class="p-field">
                        <input
                            type="file"
                            ref="fileInput"
                            @change="handleClientFileUpload"
                            accept="application/pdf,image/png,image/jpeg"/>
                    </div>

                    <br/>

                    <div class="p-field">
                        <Button label="Upload" class="mr-2 mb-2" :disabled="!file"
                                @click="uploadClientFile"></Button>
                    </div>

                    <br/>
                    <div class="p-field">
                        <Button label="Cancel" class="mr-2 mb-2" :loading="submitted"
                                @click="callResetUploadClientFiles"></Button>
                    </div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 117" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Provisions for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 118" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Provision for Client {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                    <div class="field">
                        <label for="product">Provision</label>
                        <AutoComplete placeholder="Search" :dropdown="true" :multiple="false" :required="true"
                                      v-model="selectedProvision.provision" :suggestions="filteredProvisions"
                                      @complete="searchProvisions($event)" field="name"/>
                    </div>

                    <Button label="Add" class="mr-2 mb-2" :loading="submitted" @click="addProvision"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuSummary"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 119" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Audit Trails for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 120" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Audit Trail for Client {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callMenuSummary" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Summary</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 20px;"></div>

                    <div class="field">
                        <label for="auditTrailSubProcess">Audit Trail Sub Process</label>
                        <Dropdown v-model="auditTrail.auditTrailSubProcess" :options="subProcessTypes"
                                  optionLabel="name" optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="auditTrailDescription">Audit Trail Description</label>
                        <Textarea v-model="auditTrail.auditTrailDescription" :autoResize="true" rows="10" cols="50"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted" @click="createAuditTrail"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuSummary"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 401" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send Email for {{ this.client.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callBackToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Clients Overview</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callMenuUpdate" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Manage Client</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="surface-card p-0 m-0 list-none flex overflow-x-auto select-none">
                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 1, 'text-700 border-transparent': activeTab !== 1}"
                               @click="callMenuSummary">
                                <i class="pi pi-home mr-2"></i>
                                <span class="font-medium">Summary</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 2, 'text-700 border-transparent': activeTab !== 2}"
                               @click="callMenuFinancial">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Financial & Risk</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 3, 'text-700 border-transparent': activeTab !== 3}"
                               @click="callMenuUpdate">
                                <i class="pi pi-users mr-2"></i>
                                <span class="font-medium">Update</span>
                            </a>
                        </li>

                        <li class="flex-1">
                            <a v-ripple
                               class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple"
                               :class="{'border-teal-500 text-teal-500 hover:border-teal-500': activeTab === 4, 'text-700 border-transparent': activeTab !== 4}"
                               @click="callMenuManage">
                                <i class="pi pi-shopping-cart mr-2"></i>
                                <span class="font-medium">Manage</span>
                            </a>
                        </li>
                    </ul>

                    <div style="height: 20px;"></div>

                    <h3>Send Email to Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="emailSubject">Email Subject</label>
                        <InputText id="emailSubject" v-model.trim="email.emailSubject" required="true"/>
                    </div>

                    <div class="field">
                        <label for="emailMessage">Email Message</label>
                        <Editor v-model="email.emailMessage" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="sendEmail"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuManage"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 30" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Client</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="newClient.type" :options="clientTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-show="newClient.type === 'J'" class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="newClient.name" required="true"/>
                    </div>

                    <div v-show="newClient.type === 'N' || newClient.type === 'M'" class="field">
                        <label for="firstName">First Name</label>
                        <InputText id="firstName" v-model.trim="newClient.firstName" required="true"/>
                    </div>

                    <div v-show="newClient.type === 'N' || newClient.type === 'M'" class="field">
                        <label for="lastName">Last Name</label>
                        <InputText id="lastName" v-model.trim="newClient.lastName" required="true"/>
                    </div>

                    <div v-show="newClient.type === 'N' || newClient.type === 'M'" class="field">
                        <label for="preferredName">Preferred Name</label>
                        <InputText id="preferredName" v-model.trim="newClient.preferredName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" v-model.trim="newClient.email" required="true"/>
                    </div>

                    <div class="field">
                        <label for="alternateEmail">Alternate Emails (separated by comma)</label>
                        <InputText id="alternateEmail" v-model.trim="newClient.alternateEmail" required="false"/>
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile Number</label>
                        <InputText id="mobile" v-model.trim="newClient.mobile" required="true"/>
                    </div>

                    <div class="field">
                        <label for="idNumber">ID Number</label>
                        <InputText id="idNumber" v-model.trim="newClient.idNumber" required="false"/>
                    </div>

                    <div class="field">
                        <label for="dob">Date of Birth</label>
                        <Calendar id="dob" v-model="newClient.dob" dateFormat="yy-mm-dd"/>
                    </div>

                    <div v-show="newClient.type === 'N' || newClient.type === 'M'" class="field">
                        <label for="gender">Gender</label>
                        <Dropdown v-model="newClient.gender" :options="genderTypes" optionLabel="name" required="true"
                                  optionValue="code" placeholder="Select a Gender"/>
                    </div>

                    <div v-show="(newClient.type === 'N' || newClient.type === 'M') && newClient.gender === 'O'"
                         class="field">
                        <label for="genderOther">Please Specify Gender Type</label>
                        <InputText id="genderOther" v-model.trim="newClient.genderOther" required="true"/>
                    </div>

                    <div class="field">
                        <label for="commStatus">Communication Approval?</label>
                        <Dropdown v-model="newClient.commStatus" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="taxRegistered">Tax Registered?</label>
                        <Dropdown v-model="newClient.taxRegistered" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="newClient.taxRegistered === 'Y'" class="field">
                        <label for="taxNumber">Tax Number</label>
                        <InputText id="taxNumber" v-model.trim="newClient.taxNumber" required="false"/>
                    </div>

                    <div class="field">
                        <label for="addressCountry">Country</label>
                        <Dropdown v-model="newClient.addressCountry" :options="countries" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="address1">Address Line 1</label>
                        <InputText id="address1" v-model.trim="newClient.address1" required="true"/>
                    </div>

                    <div class="field">
                        <label for="address2">Address Line 2</label>
                        <InputText id="address2" v-model.trim="newClient.address2" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressRegion">Region</label>
                        <InputText id="addressRegion" v-model.trim="newClient.addressRegion" required="true"/>
                    </div>

                    <div v-show="newClient.addressCountry === 'ZA'" class="field">
                        <label for="addressState">Province</label>
                        <Dropdown v-model="newClient.addressState" :options="regionsSouthAfrica" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="newClient.addressCountry === 'UK'" class="field">
                        <label for="addressState">County</label>
                        <InputText id="addressState" v-model.trim="newClient.addressState" required="true"/>
                    </div>

                    <div v-show="newClient.addressCountry != 'ZA' && newClient.addressCountry != 'UK'" class="field">
                        <label for="addressState">State</label>
                        <InputText id="addressState" v-model.trim="newClient.addressState" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Postal Code</label>
                        <InputText id="addressPostalCode" v-model.trim="newClient.addressPostalCode" required="true"/>
                    </div>

                    <div v-show="newClient.type === 'M'" class="field">
                        <label for="father">Parent or Guardian #1</label>
                        <AutoComplete v-model="newClient.fatherName" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div v-show="newClient.type === 'M'" class="field">
                        <label for="father">Parent or Guardian #2</label>
                        <AutoComplete v-model="newClient.motherName" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div class="field">
                        <label for="billingClient">Billing Contact</label>
                        <AutoComplete v-model="newClient.billingClientName" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div class="field">
                        <label for="adminContact">Administration Contact</label>
                        <AutoComplete v-model="newClient.adminClientName" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <!--                    <div class="field">-->
                    <!--                        <label for="affiliateContact">Affiliate Contact</label>-->
                    <!--                        <AutoComplete v-model="newClient.affiliateClientName" :dropdown="true" :multiple="false"-->
                    <!--                                      :suggestions="filteredAffiliateClients" @complete="searchAffiliateClients($event)"-->
                    <!--                                      field="name" placeholder="Type the first few characters to search"/>-->
                    <!--                    </div>-->

                    <div v-show="companyConfiguration.type === 'H'" class="field">
                        <label for="practitionerName">Assigned Practitioner</label>
                        <AutoComplete v-model="newClient.practitionerName" :dropdown="true" :multiple="false"
                                      :suggestions="filteredPractitioners"
                                      @complete="searchCompanyPractitionersInternal($event)"
                                      field="fullName" placeholder="Type the first few characters to search"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted" @click="createClient"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 31" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Client {{ this.client.name }}</h3>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted"
                            @click="updateHealthcareClient"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                    <Accordion class="accordion-custom" :activeIndex="0">

                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>General</span>
                            </template>

                            <div class="field">
                                <label for="type">Type</label>
                                <Dropdown v-model="client.type" :options="clientTypes" optionLabel="name"
                                          optionValue="code"
                                          placeholder="Select a Type"/>
                            </div>

                            <div v-show="client.type === 'J'" class="field">
                                <label for="name">Name</label>
                                <InputText id="name" v-model.trim="client.name" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="firstName">First Name</label>
                                <InputText id="firstName" v-model.trim="client.firstName" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="lastName">Last Name</label>
                                <InputText id="lastName" v-model.trim="client.lastName" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="preferredName">Preferred Name</label>
                                <InputText id="preferredName" v-model.trim="client.preferredName" required="true"/>
                            </div>

                            <div class="field">
                                <label for="email">Email</label>
                                <InputText id="email" v-model.trim="client.email" required="true"/>
                            </div>

                            <div class="field">
                                <label for="alternateEmail">Alternate Emails (separated by comma)</label>
                                <InputText id="alternateEmail" v-model.trim="client.alternateEmail" required="false"/>
                            </div>

                            <div class="field">
                                <label for="mobile">Mobile Number</label>
                                <InputText id="mobile" v-model.trim="client.mobile" required="true"/>
                            </div>

                            <div class="field">
                                <label for="idNumber">ID Number</label>
                                <InputText id="idNumber" v-model.trim="client.idNumber" required="false"/>
                            </div>

                            <div class="field">
                                <label for="dob">Date of Birth</label>
                                <Calendar id="dob" v-model="client.dob" dateFormat="yy-mm-dd"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="gender">Gender</label>
                                <Dropdown v-model="client.gender" :options="genderTypes" optionLabel="name"
                                          required="true"
                                          optionValue="code" placeholder="Select a Gender"/>
                            </div>

                            <div v-show="(client.type === 'N' || client.type === 'M') && client.gender === 'O'"
                                 class="field">
                                <label for="genderOther">Please Specify Gender Type</label>
                                <InputText id="genderOther" v-model.trim="client.genderOther" required="true"/>
                            </div>

                            <div class="field">
                                <label for="commStatus">Communication Approval?</label>
                                <Dropdown v-model="client.commStatus" :options="confirmationTypes" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="taxRegistered">Tax Registered?</label>
                                <Dropdown v-model="client.taxRegistered" :options="confirmationTypes" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div v-show="client.taxRegistered == 'Y'" class="field">
                                <label for="taxNumber">Tax Number</label>
                                <InputText id="taxNumber" v-model.trim="client.taxNumber" required="false"/>
                            </div>

                            <div class="field">
                                <label for="addressCountry">Country</label>
                                <Dropdown v-model="client.addressCountry" :options="countries" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="address1">Address Line 1</label>
                                <InputText id="address1" v-model.trim="client.address1" required="true"/>
                            </div>

                            <div class="field">
                                <label for="address2">Address Line 2</label>
                                <InputText id="address2" v-model.trim="client.address2" required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressRegion">Region</label>
                                <InputText id="addressRegion" v-model.trim="client.addressRegion" required="true"/>
                            </div>

                            <div v-show="client.addressCountry === 'ZA'" class="field">
                                <label for="addressState">Province</label>
                                <Dropdown v-model="client.addressState" :options="regionsSouthAfrica" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div v-show="client.addressCountry === 'UK'" class="field">
                                <label for="addressState">County</label>
                                <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                            </div>

                            <div v-show="client.addressCountry != 'ZA' && client.addressCountry != 'UK'" class="field">
                                <label for="addressState">State</label>
                                <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressPostalCode">Postal Code</label>
                                <InputText id="addressPostalCode" v-model.trim="client.addressPostalCode"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="status">Status</label>
                                <Dropdown v-model="client.status" :options="statusTypes" optionLabel="name"
                                          optionValue="code"
                                          placeholder="Select a Status"/>
                            </div>

                            <div v-show="client.type === 'M'" class="field">
                                <label for="fatherClientName">Parent or Guardian #1</label>
                                <AutoComplete v-model="client.fatherName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div v-show="client.type === 'M'" class="field">
                                <label for="motherClientName">Parent or Guardian #2</label>
                                <AutoComplete v-model="client.motherName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="billingClient">Billing Contact</label>
                                <AutoComplete v-model="client.billingClientName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="adminClient">Administration Contact</label>
                                <AutoComplete v-model="client.adminClientName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <!--                            <div class="field">-->
                            <!--                                <label for="affiliateContact">Affiliate Contact</label>-->
                            <!--                                <AutoComplete v-model="client.affiliateClientName" :dropdown="true" :multiple="false"-->
                            <!--                                              :suggestions="filteredAffiliateClients" @complete="searchAffiliateClients($event)"-->
                            <!--                                              field="name" placeholder="Type the first few characters to search"/>-->
                            <!--                            </div>-->

                            <div v-show="companyConfiguration.type === 'H'" class="field">
                                <label for="practitioner">Assigned Practitioner</label>
                                <AutoComplete v-model="client.practitionerName" :dropdown="true" :multiple="false"
                                              :suggestions="filteredPractitioners"
                                              @complete="searchCompanyPractitionersInternal($event)"
                                              field="fullName" placeholder="Type the first few characters to search"/>
                            </div>

                        </AccordionTab>

                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>Diagnostic</span>
                            </template>

                            <div class="field">
                                <label for="icd10Code1">ICD10 Code (Primary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode1"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="icd10Code2">ICD10 Code (Supplementary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode2"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="icd10Code3">ICD10 Code (Supplementary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode3"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="icd10Code4">ICD10 Code (Supplementary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode4"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="icd10Code5">ICD10 Code (Supplementary)</label>
                                <AutoComplete v-model="clientConfiguration.diagnosisCode5"
                                              :suggestions="filteredDiagnosticCodes"
                                              @complete="searchDiagnosticCodes($event)"
                                              field="icd10CodeLongDescription"
                                              placeholder="Type the first few characters to search"/>
                            </div>
                        </AccordionTab>


                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>Health Insurance</span>
                            </template>

                            <div class="field">
                                <label for="medicalProviderId">Current Provider #</label>
                                <InputText id="medicalProviderId" type="text" :disabled="true"
                                           v-model.trim="clientConfiguration.providerId"/>
                            </div>

                            <div class="field">
                                <label for="medicalName">Medical Name</label>
                                <AutoComplete v-model="clientConfiguration.medicalName" :dropdown="false"
                                              :multiple="false" :suggestions="filteredProviders"
                                              @complete="searchProviders($event)" field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="medicalNumber">Medical Number</label>
                                <InputText id="medicalNumber" v-model.trim="clientConfiguration.medicalNumber"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalPlan">Medical Plan</label>
                                <InputText id="medicalPlan" v-model.trim="clientConfiguration.medicalPlan"
                                           required="true"/>
                            </div>

                            <div style="height: 20px;"></div>

                            <div class="field flex align-items-center">
                                <Checkbox
                                    id="copyMainMemberDetails"
                                    v-model="clientConfiguration.copyMainMemberDetails"
                                    :binary="true"/>
                                <label for="copyMainMemberDetails" class="ml-2 mb-0">
                                    Copy Main Member Details?
                                </label>
                            </div>

                            <div style="height: 20px;"></div>

                            <div class="field">
                                <label for="medicalMemberFirstname">Main Member - First Name</label>
                                <InputText id="medicalMemberFirstname"
                                           v-model.trim="clientConfiguration.medicalMemberFirstname" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalMemberLastname">Main Member - Last Name</label>
                                <InputText id="medicalMemberLastname"
                                           v-model.trim="clientConfiguration.medicalMemberLastname" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalMemberInitials">Main Member - Initials</label>
                                <InputText id="medicalMemberInitials"
                                           v-model.trim="clientConfiguration.medicalMemberInitials" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalMemberId">Main Member - ID Number</label>
                                <InputText id="medicalMemberId" v-model.trim="clientConfiguration.medicalMemberId"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalMemberCode">Main Member - Code</label>
                                <InputText id="medicalMemberCode" v-model.trim="clientConfiguration.medicalMemberCode"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantFirstname">Patient - First Name</label>
                                <InputText id="medicalDependantFirstname"
                                           v-model.trim="clientConfiguration.medicalDependantFirstname"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantLastname">Patient - Last Name</label>
                                <InputText id="medicalDependantLastname"
                                           v-model.trim="clientConfiguration.medicalDependantLastname" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantInitials">Patient - Initials</label>
                                <InputText id="medicalDependantInitials"
                                           v-model.trim="clientConfiguration.medicalDependantInitials" required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantId">Patient - ID Number</label>
                                <InputText id="medicalDependantId" v-model.trim="clientConfiguration.medicalDependantId"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="medicalDependantCode">Patient - Code</label>
                                <InputText id="medicalDependantCode"
                                           v-model.trim="clientConfiguration.medicalDependantCode" required="true"/>
                            </div>

                            <div class="field">
                                <label for="claimPreference">Do You Wish to Claim from Health
                                    Insurance?</label>
                                <Dropdown v-model="clientConfiguration.claimPreference" :options="confirmationTypes"
                                          optionLabel="name" optionValue="code" placeholder="Select a Response"/>
                            </div>

                            <div class="field">
                                <label for="authorisation">Authorisation Number</label>
                                <InputText id="authorisation" v-model.trim="clientConfiguration.authorisation"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="inHospital">In-Hospital Client?</label>
                                <Dropdown v-model="clientConfiguration.inHospital" :options="confirmationTypes"
                                          optionLabel="name" optionValue="code" placeholder="Select a Response"/>
                            </div>

                            <div class="field">
                                <label for="pmb">Prescribed Minimum Benefit (PMB) Client?</label>
                                <Dropdown v-model="clientConfiguration.pmb" :options="confirmationTypes"
                                          optionLabel="name" optionValue="code" placeholder="Select a Response"/>
                            </div>

                            <Button label="Check Health Insurance Details" class="mr-2 mb-2" :loading="submitted"
                                    @click="updateHealthcareInsuranceDetails"></Button>

                        </AccordionTab>


                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>Referring Healthcare Practitioner</span>
                            </template>

                            <div class="field">
                                <label for="useExistingReferringPractitioner">Use Existing Referring
                                    Practitioner?</label>
                                <Dropdown v-model="clientConfiguration.useExistingReferringPractitioner"
                                          :options="confirmationTypes" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'Y'" class="field">
                                <label for="referringPractitioner">Referring Practitioner</label>
                                <AutoComplete v-model="clientConfiguration.referringName" :dropdown="true"
                                              :multiple="false"
                                              :suggestions="filteredPractitionersReferring"
                                              @complete="searchCompanyPractitionersReferring($event)"
                                              field="fullName" placeholder="Type the first few characters to search"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringFirstname">First Name</label>
                                <InputText id="referringFirstname" v-model.trim="clientConfiguration.referringFirstname"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringLastname">Last Name</label>
                                <InputText id="referringLastname" v-model.trim="clientConfiguration.referringLastname"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringEmail">Email</label>
                                <InputText id="referringEmail" v-model.trim="clientConfiguration.referringEmail"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringMobile">Mobile</label>
                                <InputText id="referringMobile" v-model.trim="clientConfiguration.referringMobile"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringRegistrationNumber">Registration Number</label>
                                <InputText id="referringRegistrationNumber"
                                           v-model.trim="clientConfiguration.referringRegistrationNumber"
                                           required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringPracticeNumber">Practice Number</label>
                                <InputText id="referringPracticeNumber"
                                           v-model.trim="clientConfiguration.referringPracticeNumber" required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="referringQualification">Qualification</label>
                                <InputText id="referringQualification"
                                           v-model.trim="clientConfiguration.referringQualification" required="true"/>
                            </div>

                            <div v-if="clientConfiguration.useExistingReferringPractitioner === 'N'" class="field">
                                <label for="type">Practitioner Type</label>
                                <Dropdown v-model="clientConfiguration.referringType" :options="practitionerTypes"
                                          optionLabel="name" optionValue="code"
                                          placeholder="Select a Practitioner Type"/>
                            </div>


                        </AccordionTab>

                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>Road Accident Fund</span>
                            </template>

                            <div class="field">
                                <label for="rafLinkNumber">Link Number</label>
                                <InputText id="rafLinkNumber" v-model.trim="clientConfiguration.rafLinkNumber"
                                           required="true"/>
                            </div>

                        </AccordionTab>

                    </Accordion>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted"
                            @click="updateHealthcareClient"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 41" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Client {{ this.client.name }}</h3>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted"
                            @click="updateHealthcareClient"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                    <Accordion class="accordion-custom" :activeIndex="0">

                        <AccordionTab>
                            <template #header>
                                <i class="pi pi-user"></i>
                                <span>General</span>
                            </template>

                            <div class="field">
                                <label for="type">Type</label>
                                <Dropdown v-model="client.type" :options="clientTypes" optionLabel="name"
                                          optionValue="code"
                                          placeholder="Select a Type"/>
                            </div>

                            <div v-show="client.type === 'J'" class="field">
                                <label for="name">Name</label>
                                <InputText id="name" v-model.trim="client.name" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="firstName">First Name</label>
                                <InputText id="firstName" v-model.trim="client.firstName" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="lastName">Last Name</label>
                                <InputText id="lastName" v-model.trim="client.lastName" required="true"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="preferredName">Preferred Name</label>
                                <InputText id="preferredName" v-model.trim="client.preferredName" required="true"/>
                            </div>

                            <div class="field">
                                <label for="email">Email</label>
                                <InputText id="email" v-model.trim="client.email" required="true"/>
                            </div>

                            <div class="field">
                                <label for="alternateEmail">Alternate Emails (separated by comma)</label>
                                <InputText id="alternateEmail" v-model.trim="client.alternateEmail" required="false"/>
                            </div>

                            <div class="field">
                                <label for="mobile">Mobile Number</label>
                                <InputText id="mobile" v-model.trim="client.mobile" required="true"/>
                            </div>

                            <div class="field">
                                <label for="idNumber">ID Number</label>
                                <InputText id="idNumber" v-model.trim="client.idNumber" required="false"/>
                            </div>

                            <div class="field">
                                <label for="dob">Date of Birth</label>
                                <Calendar id="dob" v-model="client.dob" dateFormat="yy-mm-dd"/>
                            </div>

                            <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                                <label for="gender">Gender</label>
                                <Dropdown v-model="client.gender" :options="genderTypes" optionLabel="name"
                                          required="true"
                                          optionValue="code" placeholder="Select a Gender"/>
                            </div>

                            <div v-show="(client.type === 'N' || client.type === 'M') && client.gender === 'O'"
                                 class="field">
                                <label for="genderOther">Please Specify Gender Type</label>
                                <InputText id="genderOther" v-model.trim="client.genderOther" required="true"/>
                            </div>

                            <div class="field">
                                <label for="commStatus">Communication Approval?</label>
                                <Dropdown v-model="client.commStatus" :options="confirmationTypes" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="taxRegistered">Tax Registered?</label>
                                <Dropdown v-model="client.taxRegistered" :options="confirmationTypes" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div v-show="client.taxRegistered == 'Y'" class="field">
                                <label for="taxNumber">Tax Number</label>
                                <InputText id="taxNumber" v-model.trim="client.taxNumber" required="false"/>
                            </div>

                            <div class="field">
                                <label for="addressCountry">Country</label>
                                <Dropdown v-model="client.addressCountry" :options="countries" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="address1">Address Line 1</label>
                                <InputText id="address1" v-model.trim="client.address1" required="true"/>
                            </div>

                            <div class="field">
                                <label for="address2">Address Line 2</label>
                                <InputText id="address2" v-model.trim="client.address2" required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressRegion">Region</label>
                                <InputText id="addressRegion" v-model.trim="client.addressRegion" required="true"/>
                            </div>

                            <div v-show="client.addressCountry === 'ZA'" class="field">
                                <label for="addressState">Province</label>
                                <Dropdown v-model="client.addressState" :options="regionsSouthAfrica" optionLabel="name"
                                          optionValue="code" placeholder="Select an Option"/>
                            </div>

                            <div v-show="client.addressCountry === 'UK'" class="field">
                                <label for="addressState">County</label>
                                <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                            </div>

                            <div v-show="client.addressCountry != 'ZA' && client.addressCountry != 'UK'" class="field">
                                <label for="addressState">State</label>
                                <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                            </div>

                            <div class="field">
                                <label for="addressPostalCode">Postal Code</label>
                                <InputText id="addressPostalCode" v-model.trim="client.addressPostalCode"
                                           required="true"/>
                            </div>

                            <div class="field">
                                <label for="status">Status</label>
                                <Dropdown v-model="client.status" :options="statusTypes" optionLabel="name"
                                          optionValue="code"
                                          placeholder="Select a Status"/>
                            </div>

                            <div v-show="client.type === 'M'" class="field">
                                <label for="fatherClientName">Parent or Guardian #1</label>
                                <AutoComplete v-model="client.fatherName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div v-show="client.type === 'M'" class="field">
                                <label for="motherClientName">Parent or Guardian #2</label>
                                <AutoComplete v-model="client.motherName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="billingClient">Billing Contact</label>
                                <AutoComplete v-model="client.billingClientName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                            <div class="field">
                                <label for="adminClient">Administration Contact</label>
                                <AutoComplete v-model="client.adminClientName" :dropdown="false" :multiple="false"
                                              :suggestions="filteredClients" @complete="searchClients($event)"
                                              field="name"
                                              placeholder="Type the first few characters to search"/>
                            </div>

                        </AccordionTab>

                    </Accordion>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted"
                            @click="updateHealthcareClient"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 32" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="client.type" :options="clientTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-show="client.type === 'J'" class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="client.name" required="true"/>
                    </div>

                    <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                        <label for="firstName">First Name</label>
                        <InputText id="firstName" v-model.trim="client.firstName" required="true"/>
                    </div>

                    <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                        <label for="lastName">Last Name</label>
                        <InputText id="lastName" v-model.trim="client.lastName" required="true"/>
                    </div>

                    <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                        <label for="preferredName">Preferred Name</label>
                        <InputText id="preferredName" v-model.trim="client.preferredName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" v-model.trim="client.email" required="true"/>
                    </div>

                    <div class="field">
                        <label for="alternateEmail">Alternate Emails (separated by comma)</label>
                        <InputText id="alternateEmail" v-model.trim="client.alternateEmail" required="true"/>
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile Number</label>
                        <InputText id="mobile" v-model.trim="client.mobile" required="true"/>
                    </div>

                    <div class="field">
                        <label for="idNumber">ID Number</label>
                        <InputText id="idNumber" v-model.trim="client.idNumber" required="false"/>
                    </div>

                    <div class="field">
                        <label for="dob">Date of Birth</label>
                        <Calendar id="dob" v-model="client.dob" dateFormat="yy-mm-dd"/>
                    </div>

                    <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                        <label for="gender">Gender</label>
                        <Dropdown v-model="client.gender" :options="genderTypes" optionLabel="name" required="true"
                                  optionValue="code" placeholder="Select a Gender"/>
                    </div>

                    <div v-show="(client.type === 'N' || client.type === 'M') && client.gender === 'O'" class="field">
                        <label for="genderOther">Please Specify Gender Type</label>
                        <InputText id="genderOther" v-model.trim="client.genderOther" required="true"/>
                    </div>

                    <div class="field">
                        <label for="commStatus">Communication Approval?</label>
                        <Dropdown v-model="client.commStatus" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="taxRegistered">Tax Registered?</label>
                        <Dropdown v-model="client.taxRegistered" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="client.taxRegistered == 'Y'" class="field">
                        <label for="taxNumber">Tax Number</label>
                        <InputText id="taxNumber" v-model.trim="client.taxNumber" required="false"/>
                    </div>

                    <div class="field">
                        <label for="addressCountry">Country</label>
                        <Dropdown v-model="client.addressCountry" :options="countries" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="address1">Address Line 1</label>
                        <InputText id="address1" v-model.trim="client.address1" required="true"/>
                    </div>

                    <div class="field">
                        <label for="address2">Address Line 2</label>
                        <InputText id="address2" v-model.trim="client.address2" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressRegion">Region</label>
                        <InputText id="addressRegion" v-model.trim="client.addressRegion" required="true"/>
                    </div>

                    <div v-show="client.addressCountry === 'ZA'" class="field">
                        <label for="addressState">Province</label>
                        <Dropdown v-model="client.addressState" :options="regionsSouthAfrica" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="client.addressCountry === 'UK'" class="field">
                        <label for="addressState">County</label>
                        <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                    </div>

                    <div v-show="client.addressCountry != 'ZA' && client.addressCountry != 'UK'" class="field">
                        <label for="addressState">State</label>
                        <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Postal Code</label>
                        <InputText id="addressPostalCode" v-model.trim="client.addressPostalCode" required="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="client.status" :options="statusTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div v-show="client.type === 'M'" class="field">
                        <label for="fatherClientName">Parent or Guardian #1</label>
                        <AutoComplete v-model="client.fatherName" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div v-show="client.type === 'M'" class="field">
                        <label for="motherClientName">Parent or Guardian #2</label>
                        <AutoComplete v-model="client.motherName" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div class="field">
                        <label for="billingClient">Billing Contact</label>
                        <AutoComplete v-model="client.billingClientName" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div class="field">
                        <label for="adminContact">Administration Contact</label>
                        <AutoComplete v-model="client.adminClientName" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <!--                    <div class="field">-->
                    <!--                        <label for="affiliateContact">Affiliate Contact</label>-->
                    <!--                        <AutoComplete v-model="client.affiliateClientName" :dropdown="true" :multiple="false"-->
                    <!--                                      :suggestions="filteredAffiliateClients" @complete="searchAffiliateClients($event)"-->
                    <!--                                      field="name" placeholder="Type the first few characters to search"/>-->
                    <!--                    </div>-->

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateClient"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 407" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Client?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>


                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteClient"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuManage"></Button>

                </div>
            </div>
        </div>



        <div v-if="activeTab === 7" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Products for Client {{ this.client.name }}</h3>

                    <DataTable :value="clientProducts" :paginator="true" class="p-datatable-gridlines" :rows="100"
                               dataKey="id" :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true"
                               :striped-rows="true"
                               :reorderableColumns="true" :sortMode="'multiple'" responsiveLayout="scroll">

                        <template #empty>
                            No products found.
                        </template>

                        <template #loading>
                            Loading products. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1" :loading="submitted"
                                        @click="callUpdateProduct(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1" :loading="submitted"
                                        @click="callDeleteProduct(data)"/>
                            </template>
                        </Column>

                        <Column field="uniqueId" header="Unique #" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Unique #</span>
                                {{ data.uniqueId }}
                            </template>
                        </Column>

                        <Column field="name" header="Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Name</span>
                                {{ data.name }}
                            </template>
                        </Column>

                        <Column field="billingPlanName" header="Billing Plan Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Billing Plan Name</span>
                                {{ data.billingPlanName }}
                            </template>
                        </Column>

                        <Column field="premium" header="Premium" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Premium</span>
                                {{ data.premium }}
                            </template>
                        </Column>

                        <Column field="value" header="Value" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Value</span>
                                {{ data.value }}
                            </template>
                        </Column>

                    </DataTable>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 8" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Note for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="note.type" :options="noteTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="format">Format</label>
                        <Dropdown v-model="note.format" :options="formatTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Format"/>
                    </div>

                    <div v-show="note.format === 'O'" class="field">
                        <label for="videoSource">Media Source</label>
                        <Dropdown v-model="videoSource" :options="videoSources" optionLabel="name" optionValue="code"
                                  placeholder="Select a Media Source"/>
                    </div>

                    <div class="field">
                        <label for="subject">Subject</label>
                        <InputText id="subject" v-model.trim="note.subject" required="true"/>
                    </div>

                    <div v-show="note.format === 'R'" class="field">
                        <label for="description">Description</label>
                        <Editor v-model="note.description" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>

                            </template>
                        </Editor>
                    </div>

                    <div v-show="note.format === 'V'" class="field">
                        <label for="description">Description</label>

                        <Editor v-model="note.description" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>

                            </template>
                        </Editor>

                        <div class="mt-3 flex flex-wrap gap-2">
                            <Button label="🎙 Start voice transcription" class="mr-2 mb-2" :disabled="voiceActive"
                                    @click="startVoiceDescription"></Button>

                            <Button label="⏹ Stop voice transcription" class="mr-2 mb-2" :disabled="!voiceActive"
                                    @click="stopVoiceDescription"></Button>

                            <small v-if="voiceActive" class="text-green-600">
                                Listening…
                            </small>
                            <small v-else-if="voiceError" class="text-red-600">
                                {{ voiceError }}
                            </small>
                        </div>

                    </div>

                    <div v-show="note.format === 'C'" class="field">
                        <label for="description">Description</label>
                        <Editor v-model="note.description" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>

                            </template>
                        </Editor>
                    </div>

                    <div v-show="note.format === 'C'" class="field">
                        <label for="canvas">Canvas</label>

                        <div v-show="newImageEditorReady" class="iso-image-editor">
                            <div class="toolbar">
                                <div class="toolbar-buttons">
                                    <div class="mode-buttons">
                                        <button id="new-drawing-mode-toggle" type="button">Draw Mode</button>
                                        <button id="new-set-background-toggle" type="button">Set Background</button>
                                    </div>

                                    <div id="new-action-buttons" class="action-buttons">
                                        <button id="new-remove-object" type="button" disabled="disabled">Remove
                                            Selection
                                        </button>
                                        <button id="new-clear-canvas" type="button">Clear Canvas</button>
                                    </div>
                                </div>

                                <div id="new-drawing-mode-options" class="drawing-mode-options">
                                    <div class="field-group">
                                        <div class="field">
                                            <label for="new-drawing-mode-selector">Mode:</label>
                                            <select id="new-drawing-mode-selector">
                                                <option>Pencil</option>
                                                <option>Circle</option>
                                                <option>Spray</option>
                                                <option>Pattern</option>
                                            </select>
                                        </div>

                                        <div class="field">
                                            <label for="new-drawing-line-width">Line width:</label>
                                            <span class="info">5</span><input type="range" value="5" min="5" max="150"
                                                                              id="new-drawing-line-width"/>
                                        </div>

                                        <div class="field">
                                            <label for="new-drawing-color">Line color:</label>
                                            <input type="color" value="#005E7A" id="new-drawing-color"/>
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <div class="field">
                                            <label for="new-drawing-shadow-width">Shadow width:</label>
                                            <span class="info">0</span><input type="range" value="0" min="0" max="50"
                                                                              id="new-drawing-shadow-width"/>
                                        </div>

                                        <div class="field">
                                            <label for="new-drawing-shadow-offset">Shadow offset:</label>
                                            <span class="info">0</span><input type="range" value="0" min="0" max="50"
                                                                              id="new-drawing-shadow-offset"/>
                                        </div>

                                        <div class="field">
                                            <label for="new-drawing-shadow-color">Shadow color:</label>
                                            <input type="color" value="#A7AFB1" id="new-drawing-shadow-color"/>
                                        </div>
                                    </div>
                                </div>

                                <div id="new-set-background-options" class="set-background-options">
                                    <div class="field-group">
                                        <div class="field">
                                            <label for="new-canvas-background-selector">Background Image:</label>
                                            <select id="new-canvas-background-selector">
                                                <option value="Select">Select</option>
                                                <option value="0">None</option>
                                                <option v-for="image in backgroundImageOptions" :key="image.id"
                                                        :value="image.id">
                                                    {{ image.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <canvas id="new-noteCanvas" class="image-canvas" width="790" height="340"></canvas>
                        </div>

                        <Button v-show="!newImageEditorReady" label="Show Canvas" class="mr-2 mb-2"
                                @click="initNewImageEditor"></Button>
                    </div>

                    <div v-show="note.format === 'A'" class="field">
                        <label for="description">Description</label>

                        <Editor v-model="note.description" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>

                            </template>
                        </Editor>

                        <input
                            type="file"
                            accept="audio/*,.mp3,.m4a,.wav,.aac,.aiff,.aif"
                            @change="e => file = e.target.files[0]"/>

                        <div class="mt-3 flex flex-wrap gap-2">
                            <Button label="🎙 Start audio transcription" class="mr-2 mb-2"
                                    :disabled="transcriptionActive" @click="submitAudioFile"></Button>

                            <small v-if="transcriptionActive" class="text-green-600">
                                Transcribing…
                            </small>
                            <small v-else-if="transcriptionError" class="text-red-600">
                                {{ transcriptionError }}
                            </small>
                        </div>
                    </div>

                    <div v-show="note.format === 'O'" class="field">
                        <label for="description">Description</label>

                        <Editor v-model="note.description" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>

                            </template>
                        </Editor>

                        <div class="mt-3 flex flex-wrap gap-2">
                            <Button label="Start media recording" class="mr-2 mb-2"
                                    :disabled="videoActive || (newVideoRecorder != null)"
                                    @click="startVideoRecording"></Button>

                            <Button label="Stop media recording" class="mr-2 mb-2" :disabled="!videoActive"
                                    @click="stopVideoRecording"></Button>

                            <div id="note-video-container" class="notes-video-container">
                                <video id="note-video-preview" height="240" autoplay muted></video>
                            </div>
                            <small v-if="videoError" class="text-red-600">
                                {{ videoError }}
                            </small>
                        </div>
                    </div>

                    <div v-show="note.format === 'O'" class="field">
                        <label for="note-video-timer">Recording Time</label>
                        <div id="note-video-timer" class="note-video-timer">
                            0:00
                        </div>
                    </div>

                    <div class="field">
                        <label for="sharable">Is this Sharable?</label>
                        <Dropdown v-model="note.sharable" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-if="this.note.sharable === 'Y'" class="field">
                        <label for="editable">Is this Editable by the Client?</label>
                        <Dropdown v-model="note.editable" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="note.status" :options="statusTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <Button label="Add" class="mr-2 mb-2" :loading="submitted" :disabled="!canCreateNote"
                            @click="addNote"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" :disabled="!canCancelNote"
                            @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 9" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Notes for Client {{ this.client.name }}</h3>

                    <DataTable :value="notes" :paginator="true" class="p-datatable-gridlines" :rows="100" dataKey="id"
                               :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true" :striped-rows="true"
                               :reorderableColumns="true" :sortMode="'multiple'" responsiveLayout="scroll">

                        <template #empty>
                            No notes found.
                        </template>

                        <template #loading>
                            Loading notes. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <SplitButton icon="pi pi-pencil" label="Select" :model="getFilteredItemsNotes(data)"
                                             severity="success" @click="chooseBlankSelection(data)"
                                             class="mb-2 mr-2 ml-2 mt-2"/>
                            </template>
                        </Column>

                        <Column field="subject" header="Subject" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Subject</span>
                                {{ data.subject }}
                            </template>
                        </Column>

                        <Column field="context" header="Context" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Context</span>
                                <span v-if="data.context === 'A'"
                                      :class="'type-badge status-' + data.type">Appointment</span>
                                <span v-else-if="data.context === 'C'"
                                      :class="'type-badge status-' + data.type">Client</span>
                                <span v-else-if="data.context === 'T'"
                                      :class="'type-badge status-' + data.type">Task</span>
                                <span v-else-if="data.context === 'P'" :class="'type-badge status-' + data.type">Prospect</span>
                                <span v-else-if="data.context === 'G'"
                                      :class="'type-badge status-' + data.type">General</span>
                            </template>
                        </Column>

                        <Column field="type" header="Type" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Type</span>
                                <span v-if="data.type === 'C'" :class="'type-badge status-' + data.type">Clinical</span>
                                <span v-if="data.type === 'P'" :class="'type-badge status-' + data.type">Personal</span>
                            </template>
                        </Column>

                        <Column field="format" header="Format" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Format</span>
                                <span v-if="data.format === 'R'" :class="'format-badge status-' + data.format">
                                    Rich Text</span>
                                <span v-if="data.format === 'V'"
                                      :class="'format-badge status-' + data.format">Voice Transcription</span>
                                <span v-if="data.format === 'C'"
                                      :class="'format-badge status-' + data.format">Freeform</span>
                                <span v-if="data.format === 'A'"
                                      :class="'format-badge status-' + data.format">Audio Recording</span>
                                <span v-if="data.format === 'O'"
                                      :class="'format-badge status-' + data.format">Media recording</span>
                            </template>
                        </Column>

                        <Column field="editable" header="Editable" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Editable</span>
                                <span v-if="data.editable === 'Y'"
                                      :class="'type-badge status-' + data.editable">Yes</span>
                                <span v-if="data.editable === 'N'"
                                      :class="'type-badge status-' + data.editable">No</span>
                            </template>
                        </Column>

                        <Column field="sharable" header="Sharable" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Sharable</span>
                                <span v-if="data.sharable === 'Y'"
                                      :class="'type-badge status-' + data.sharable">Yes</span>
                                <span v-if="data.sharable === 'N'"
                                      :class="'type-badge status-' + data.sharable">No</span>
                            </template>
                        </Column>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'A'"
                                      :class="'status-badge status-' + data.status">Active</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                            </template>
                        </Column>

                        <Column field="created" header="Created" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Created</span>
                                {{ data.created }}
                            </template>
                        </Column>

                    </DataTable>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 10" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Task for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="process">Process</label>
                        <AutoComplete placeholder="Search" :dropdown="false" :multiple="false" v-model="newTask.process"
                                      :suggestions="filteredProcesses" @complete="searchProcesses($event)"
                                      field="name"/>
                    </div>

                    <div v-show="companyConfiguration.type != 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="newTask.type" :options="taskTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-show="companyConfiguration.type === 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="newTask.type" :options="taskTypesFinancialAdvisor" optionLabel="name"
                                  optionValue="code" placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="clientVisible">Client Visible?</label>
                        <Dropdown v-model="newTask.clientVisible" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="user">User</label>
                        <AutoComplete placeholder="Select" :dropdown="true" :multiple="false" v-model="newTask.user"
                                      :suggestions="filteredUsers" @complete="searchUsers()" field="username"/>
                    </div>

                    <div v-if="newTask.description === ''" class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model.trim="newTask.description" :required="true"
                                   class="p-invalid"/>
                        <InlineMessage>Field is required</InlineMessage>
                    </div>

                    <div v-if="newTask.description != ''" class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model.trim="newTask.description" :required="true"/>
                    </div>

                    <div class="field">
                        <label for="note">Notes</label>
                        <Editor v-model="newTask.note" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Add" class="mr-2 mb-2" :loading="submitted" @click="addTask"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 11" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Tasks for Client {{ this.client.name }}</h3>

                    <DataTable :value="tasks" :paginator="true" class="p-datatable-gridlines" :rows="100" dataKey="id"
                               :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true" :striped-rows="true"
                               :reorderableColumns="true" :sortMode="'multiple'" responsiveLayout="scroll">

                        <template #empty>
                            No tasks found.
                        </template>

                        <template #loading>
                            Loading tasks. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 5%">
                            <template #body="{ data }">
                                <Button v-tooltip="'View'" icon="pi pi-eye" class="p-button-rounded p-button-help m-1"
                                        :loading="submitted" @click="callViewTask(data)"/>
                            </template>
                        </Column>

                        <Column field="processName" header="Process Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Process Name</span>
                                {{ data.processName }}
                            </template>
                        </Column>

                        <Column field="type" header="Type" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Type</span>
                                <span v-if="data.type === 'S'" :class="'type-badge status-' + data.type">Software
                                    Support</span>
                                <span v-if="data.type === 'B'" :class="'type-badge status-' + data.type">Billing</span>
                                <span v-if="data.type === 'C'" :class="'type-badge status-' + data.type">Client
                                    Management</span>
                                <span v-if="data.type === 'U'" :class="'type-badge status-' + data.type">Unpaids
                                    Management</span>
                                <span v-if="data.type === 'P'" :class="'type-badge status-' + data.type">Payment
                                    Management</span>
                                <span v-if="data.type === 'O'" :class="'type-badge status-' + data.type">Other</span>

                            </template>
                        </Column>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Initiated</span>
                                <span v-if="data.status === 'W'" :class="'status-badge status-' + data.status">Working
                                    On It</span>
                                <span v-if="data.status === 'C'"
                                      :class="'status-badge status-' + data.status">Completed</span>
                                <span v-if="data.status === 'R'" :class="'status-badge status-' + data.status">Rejected
                                    and Closed</span>

                            </template>
                        </Column>

                        <Column field="clientVisible" header="Client Visible?" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Client Visible?</span>
                                <span v-if="data.clientVisible === 'Y'"
                                      :class="'type-badge status-' + data.clientVisible">Yes</span>
                                <span v-if="data.clientVisible === 'N'"
                                      :class="'type-badge status-' + data.clientVisible">No</span>
                            </template>
                        </Column>

                        <Column field="description" header="Description" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Description</span>
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="elapsed" header="Elapsed" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Elapsed</span>
                                {{ formatTime(data.elapsed) }}
                            </template>
                        </Column>

                        <Column field="duration" header="Duration" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Duration</span>
                                {{ formatTime(data.duration) }}
                            </template>
                        </Column>

                        <Column field="username" header="User" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">User</span>
                                {{ data.username }}
                            </template>
                        </Column>

                    </DataTable>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 406" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send Statement to Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="status">Statement Type</label>
                        <Dropdown v-model="newStatement.type" :options="statementTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="newStatement.startDate" required="true" :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="newStatement.endDate" required="true" :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="Download" class="mr-2 mb-2" :loading="submitted" @click="downloadStatement"></Button>
                    <Button label="Email" class="mr-2 mb-2" :loading="submitted" @click="emailStatement"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuManage"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 13" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send Email to Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="emailSubject">Email Subject</label>
                        <InputText id="emailSubject" v-model.trim="email.emailSubject" required="true"/>
                    </div>

                    <div class="field">
                        <label for="emailMessage">Email Message</label>
                        <Editor v-model="email.emailMessage" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="sendEmail"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 402" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send SMS to Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="smsMessage">SMS Message</label>
                        <InputText id="smsMessage" v-model.trim="sms.smsMessage" required="true"/>
                    </div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="sendSms"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuManage"></Button>

                </div>
            </div>
        </div>





        <div v-if="activeTab === 405" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Unpaid Notice for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="unpaidType">Type</label>
                        <Dropdown v-model="unpaid.unpaidType" :options="unpaidTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="unpaidAmountOutstanding">Amount Outstanding</label>
                        <InputText id="unpaidAmountOutstanding" v-model.trim="unpaid.unpaidAmountOutstanding"
                                   required="true"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted" @click="createUnpaidNotice"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuManage"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 17" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create Invoice for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="invoiceOption">Billing Plan or Product Invoice?</label>
                        <Dropdown v-model="invoice.type" :options="invoiceTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div v-show="invoice.type === 'P'" class="field">
                        <label for="product">Product</label>
                        <AutoComplete placeholder="Search" :dropdown="true" :multiple="false" :required="true"
                                      v-model="invoice.product" :suggestions="filteredProducts"
                                      @complete="searchProducts($event)"
                                      field="name"/>
                    </div>

                    <div v-show="invoice.type === 'B'" class="field">
                        <label for="billingPlan">Billing Plan</label>
                        <AutoComplete placeholder="Search" :dropdown="true" :multiple="false" :required="true"
                                      v-model="invoice.billingPlan" :suggestions="filteredBillingPlans"
                                      @complete="searchBillingPlan($event)"
                                      field="name"/>
                    </div>

                    <div v-if="company && company.taxRegistered === 'Y'" class="field">
                        <label for="useTaxRate">Use Tax Rate?</label>
                        <Dropdown v-model="useTaxRate" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="invoiced">Invoice Date</label>
                        <Calendar id="invoiced" v-model="invoice.invoiced" required="true"
                                  :showTime="true"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <!--                    <div v-show="(companyConfiguration.type==='H') && (invoice.type === 'B')" class="field">-->
                    <!--                        <label for="submissionOption">Invoice Submission Method</label>-->
                    <!--                        <Dropdown v-model="invoice.submissionMethod" :options="submissionMethod"-->
                    <!--                                  optionLabel="name"-->
                    <!--                                  optionValue="code"-->
                    <!--                                  placeholder="Select an Option"/>-->
                    <!--                    </div>-->

                    <!--                    <div v-show="(companyConfiguration.type==='H') && (invoice.submissionMethod!=='C') && (invoice.type === 'B')" class="field">-->
                    <!--                        <label for="healthInsuranceSubmission">Health Insurance Submission Method</label>-->
                    <!--                        <Dropdown v-model="invoice.healthInsuranceSubmission"-->
                    <!--                                  :options="healthInsuranceSubmissionMethod"-->
                    <!--                                  optionLabel="name"-->
                    <!--                                  optionValue="code"-->
                    <!--                                  placeholder="Select an Option"/>-->
                    <!--                    </div>-->

                    <!--                    <div v-show="(companyConfiguration.type==='H') && (invoice.type === 'B')" class="field">-->
                    <!--                        <label for="useSystemProcedureRates">Use System Procedure Rates?</label>-->
                    <!--                        <Dropdown v-model="invoice.useSystemProcedureRates" :options="confirmationTypes"-->
                    <!--                                  optionLabel="name"-->
                    <!--                                  optionValue="code"-->
                    <!--                                  placeholder="Select an Option"/>-->
                    <!--                    </div>-->

                    <!--                    <div v-show="(invoice.useSystemProcedureRates==='Y') && (invoice.type === 'B')" class="field">-->
                    <!--                        <label for="rateOption">Rate Option?</label>-->
                    <!--                        <Dropdown v-model="invoice.rateOption" :options="rateOptionTypes"-->
                    <!--                                  optionLabel="name"-->
                    <!--                                  optionValue="code"-->
                    <!--                                  placeholder="Select an Option"/>-->
                    <!--                    </div>-->

                    <!--                    <div v-show="(companyConfiguration.type==='H') && (invoice.submissionMethod!=='C')" class="field">-->
                    <!--                        <label for="useAutomaticSubmission">Automatically Submit Invoice and/or Claim?</label>-->
                    <!--                        <Dropdown v-model="invoice.useAutomaticSubmission" :options="confirmationTypes"-->
                    <!--                                  optionLabel="name"-->
                    <!--                                  optionValue="code"-->
                    <!--                                  placeholder="Select an Option"/>-->
                    <!--                    </div>-->

                    <div class="field">
                        <label for="useAutomaticSubmission">Automatically Submit Invoice?</label>
                        <Dropdown v-model="invoice.useAutomaticSubmission" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :disabled="!canCreateInvoice"
                            :loading="submitted" @click="createInvoice"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 18" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Product {{ this.product.name }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="product.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="billingPlan">Billing Plan</label>
                        <AutoComplete placeholder="Search or Select" :dropdown="true" :multiple="false"
                                      v-model="product.billingPlanName" :suggestions="filteredBillingPlans"
                                      @complete="searchBillingPlan($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <Textarea v-model="product.description" :autoResize="true" rows="10" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="uniqueId">Unique #</label>
                        <InputText id="uniqueId" v-model.trim="product.uniqueId" required="true"/>
                    </div>

                    <div class="field">
                        <label for="premium">Premium</label>
                        <InputText id="premium" v-model.trim="product.premium" required="true"/>
                    </div>

                    <div class="field">
                        <label for="value">Value</label>
                        <InputText id="value" v-model.trim="product.value" required="true"/>
                    </div>

                    <div class="field">
                        <label for="value">Created</label>
                        <InputText id="created" v-model.trim="product.created" required="true" disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="value">Updated</label>
                        <InputText id="updated" v-model.trim="product.updated" required="true" disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="value">Inception Date</label>
                        <Calendar id="scheduled" v-model="product.inception" required="true" :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div class="field">
                        <label for="value">Termination Date</label>
                        <Calendar id="scheduled" v-model="product.termination" required="true" :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="product.status" :options="statusTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select an Action"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateProduct"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetProducts"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 19" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Product {{ this.product.name }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Product from the
                            Client?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteProduct"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetProducts"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 20" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Note {{ this.note.id }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown :disabled="true" v-model="note.type" :options="noteTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="subject">Subject</label>
                        <InputText :disabled="true" :readonly="true" id="subject" v-model.trim="note.subject"
                                   required="true"/>
                    </div>

                    <div
                        v-show="(note.format === 'R') || (note.format === 'V') || (note.format === 'C') || (note.format === 'A') || (note.format === 'O')"
                        class="field">
                        <label for="description">Description</label>
                        <Editor v-model="note.description" :readonly="true" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">

                                </span>
                            </template>
                        </Editor>

                    </div>

                    <div v-show="(note.format === 'O') || (note.format === 'C')" class="card p-fluid">
                        <label for="clientFile">Media File</label>

                        <div v-if="note.clientFile" class="card p-fluid">
                            <Button v-tooltip="'View'" icon="pi pi-eye"
                                    class="p-button-rounded p-button-success m-1"
                                    @click="viewClientFile(note.clientFile)"/>
                            <Button v-tooltip="'Download'" icon="pi pi-cloud-download"
                                    class="p-button-rounded p-button-help m-1"
                                    @click="downloadClientFile(note.clientFile)"/>
                        </div>
                        <small v-else class="text-red-600">
                            No media file found!
                        </small>
                    </div>

                    <div v-show="note.format === 'C'" class="field">
                        <label for="canvas">Canvas</label>

                        <div v-show="viewImageEditorReady" class="iso-image-editor">
                            <div class="toolbar" style="display: none;">
                                <div class="toolbar-buttons">
                                    <div class="mode-buttons">
                                        <button id="view-drawing-mode-toggle" type="button">Draw Mode</button>
                                        <button id="view-set-background-toggle" type="button">Set Background</button>
                                    </div>

                                    <div id="view-action-buttons" class="action-buttons">
                                        <button id="view-remove-object" type="button" disabled="disabled">Remove
                                            Selection
                                        </button>
                                        <button id="view-clear-canvas" type="button">Clear Canvas</button>
                                    </div>
                                </div>

                                <div id="view-drawing-mode-options" class="drawing-mode-options">
                                    <div class="field-group">
                                        <div class="field">
                                            <label for="view-drawing-mode-selector">Mode:</label>
                                            <select id="view-drawing-mode-selector">
                                                <option>Pencil</option>
                                                <option>Circle</option>
                                                <option>Spray</option>
                                                <option>Pattern</option>
                                            </select>
                                        </div>

                                        <div class="field">
                                            <label for="view-drawing-line-width">Line width:</label>
                                            <span class="info">5</span><input type="range" value="5" min="5" max="150"
                                                                              id="view-drawing-line-width"/>
                                        </div>

                                        <div class="field">
                                            <label for="view-drawing-color">Line color:</label>
                                            <input type="color" value="#005E7A" id="view-drawing-color"/>
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <div class="field">
                                            <label for="view-drawing-shadow-width">Shadow width:</label>
                                            <span class="info">0</span><input type="range" value="0" min="0" max="50"
                                                                              id="view-drawing-shadow-width"/>
                                        </div>

                                        <div class="field">
                                            <label for="view-drawing-shadow-offset">Shadow offset:</label>
                                            <span class="info">0</span><input type="range" value="0" min="0" max="50"
                                                                              id="view-drawing-shadow-offset"/>
                                        </div>

                                        <div class="field">
                                            <label for="view-drawing-shadow-color">Shadow color:</label>
                                            <input type="color" value="#A7AFB1" id="view-drawing-shadow-color"/>
                                        </div>
                                    </div>
                                </div>

                                <div id="view-set-background-options" class="set-background-options">
                                    <div class="field-group">
                                        <div class="field">
                                            <label for="view-canvas-background-selector">Background Image:</label>
                                            <select id="view-canvas-background-selector">
                                                <option value="Select">Select</option>
                                                <option value="0">None</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <canvas id="view-noteCanvas" class="image-canvas" width="790" height="340"></canvas>
                        </div>

                        <Button v-show="!viewImageEditorReady" label="Show Canvas" class="mr-2 mb-2"
                                @click="initViewImageEditor"></Button>
                    </div>

                    <div class="field">
                        <label for="sharable">Is this Sharable?</label>
                        <Dropdown :disabled="true" v-model="note.sharable" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-if="this.note.sharable === 'Y'" class="field">
                        <label for="editable">Is this Editable by the Client?</label>
                        <Dropdown :disabled="true" v-model="note.editable" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown :disabled="true" v-model="note.status" :options="statusTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="created">Created</label>
                        <InputText :disabled="true" :readonly="true" id="created" v-model.trim="note.created"
                                   required="true"/>
                    </div>

                    <!--                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateNote"></Button>-->
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetNotes"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 21" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Note {{ this.note.id }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="note.type" :options="noteTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="subject">Subject</label>
                        <InputText id="subject" v-model.trim="note.subject" required="true"/>
                    </div>

                    <div
                        v-show="(note.format === 'R') || (note.format === 'V') || (note.format === 'C') || (note.format === 'A') || (note.format === 'O')"
                        class="field">
                        <label for="description">Description</label>
                        <Editor v-model="note.description" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>

                            </template>
                        </Editor>
                    </div>

                    <div v-show="(note.format === 'O') || (note.format === 'C')" class="card p-fluid">
                        <label for="clientFile">Media File</label>

                        <div v-if="note.clientFile" class="card p-fluid">
                            <Button v-tooltip="'View'" icon="pi pi-eye"
                                    class="p-button-rounded p-button-success m-1"
                                    @click="viewClientFile(note.clientFile)"/>
                            <Button v-tooltip="'Download'" icon="pi pi-cloud-download"
                                    class="p-button-rounded p-button-help m-1"
                                    @click="downloadClientFile(note.clientFile)"/>
                        </div>
                        <small v-else class="text-red-600">
                            No media file found!
                        </small>
                    </div>

                    <div v-show="note.format === 'C'" class="field">
                        <label for="canvas">Canvas</label>

                        <div v-show="updateImageEditorReady" class="iso-image-editor">
                            <div class="toolbar">
                                <div class="toolbar-buttons">
                                    <div class="mode-buttons">
                                        <button id="update-drawing-mode-toggle" type="button">Draw Mode</button>
                                        <button id="update-set-background-toggle" type="button">Set Background</button>
                                    </div>

                                    <div id="update-action-buttons" class="action-buttons">
                                        <button id="update-remove-object" type="button" disabled="disabled">Remove
                                            Selection
                                        </button>
                                        <button id="update-clear-canvas" type="button">Clear Canvas</button>
                                    </div>
                                </div>

                                <div id="update-drawing-mode-options" class="drawing-mode-options">
                                    <div class="field-group">
                                        <div class="field">
                                            <label for="update-drawing-mode-selector">Mode:</label>
                                            <select id="update-drawing-mode-selector">
                                                <option>Pencil</option>
                                                <option>Circle</option>
                                                <option>Spray</option>
                                                <option>Pattern</option>
                                            </select>
                                        </div>

                                        <div class="field">
                                            <label for="update-drawing-line-width">Line width:</label>
                                            <span class="info">5</span><input type="range" value="5" min="5" max="150"
                                                                              id="update-drawing-line-width"/>
                                        </div>

                                        <div class="field">
                                            <label for="update-drawing-color">Line color:</label>
                                            <input type="color" value="#005E7A" id="update-drawing-color"/>
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <div class="field">
                                            <label for="update-drawing-shadow-width">Shadow width:</label>
                                            <span class="info">0</span><input type="range" value="0" min="0" max="50"
                                                                              id="update-drawing-shadow-width"/>
                                        </div>

                                        <div class="field">
                                            <label for="update-drawing-shadow-offset">Shadow offset:</label>
                                            <span class="info">0</span><input type="range" value="0" min="0" max="50"
                                                                              id="update-drawing-shadow-offset"/>
                                        </div>

                                        <div class="field">
                                            <label for="update-drawing-shadow-color">Shadow color:</label>
                                            <input type="color" value="#A7AFB1" id="update-drawing-shadow-color"/>
                                        </div>
                                    </div>
                                </div>

                                <div id="update-set-background-options" class="set-background-options">
                                    <div class="field-group">
                                        <div class="field">
                                            <label for="update-canvas-background-selector">Background Image:</label>
                                            <select id="update-canvas-background-selector">
                                                <option value="Select">Select</option>
                                                <option value="0">None</option>
                                                <option v-for="image in backgroundImageOptions" :key="image.id"
                                                        :value="image.id">
                                                    {{ image.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <canvas id="update-noteCanvas" class="image-canvas" width="790" height="340"></canvas>
                        </div>

                        <Button v-show="!updateImageEditorReady" label="Show Canvas" class="mr-2 mb-2"
                                @click="initUpdateImageEditor"></Button>
                    </div>

                    <div class="field">
                        <label for="sharable">Is this Sharable?</label>
                        <Dropdown v-model="note.sharable" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-if="this.note.sharable === 'Y'" class="field">
                        <label for="editable">Is this Editable by the Client?</label>
                        <Dropdown v-model="note.editable" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="note.status" :options="statusTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateNote"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetNotes"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 22" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Task {{ this.task.name }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="process">Process</label>
                        <InputText id="processName" v-model.trim="task.processName" :disabled="true"/>
                    </div>

                    <div v-show="companyConfiguration.type != 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="task.type" :options="taskTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-show="companyConfiguration.type === 'F'" class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="task.type" :options="taskTypesFinancialAdvisor" optionLabel="name"
                                  optionValue="code" placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="clientVisible">Client Visible?</label>
                        <Dropdown :disabled="true" v-model="task.clientVisible" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="user">User</label>
                        <InputText id="username" v-model.trim="task.username" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="client">Client</label>
                        <InputText id="clientName" v-model.trim="task.clientName" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model.trim="task.description" :disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="note">Notes</label>
                        <Editor :disabled="true" v-model="task.note" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                    <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                    <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                    <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                    <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                    <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                    <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                    <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                    <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                    <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                    <button class="ql-video" v-tooltip.bottom="'Video'"></button>
                                    <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown :disabled="true" v-model="task.status" :options="statusTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Status"/>
                    </div>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetTasks"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 23" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Note {{ this.note.id }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Note from the
                            Client?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteNote"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetNotes"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 24" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Sending Bulk SMSs to All Active Clients</h3>

                    <div class="field">
                        <label for="bulkSmsMessage">Message</label>
                        <InputText id="bulkSmsMessage" v-model.trim="bulkSmsMessage" :disabled="false"/>
                    </div>

                    <div class="field">
                        <span>
                            Note: Sufficient prepaid will be needed to send this bulk sms campaign.
                        </span>
                    </div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="processBulkSms"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 25" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Note with a Template for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="noteTemplateId" :options="noteTemplates" optionLabel="subject"
                                  optionValue="id" placeholder="Select a Type"/>
                    </div>

                    <Button label="Add" class="mr-2 mb-2" :loading="submitted" @click="addNoteWithTemplate"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 26" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Import Client Intake</h3>

                    <div class="field">
                        <label for="inputFormat">Input Format</label>
                        <Dropdown v-model="inputFormat" :options="inputFormats" optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="p-field">
                        <input type="file" @change="handleFileUpload" accept=".csv, application/pdf"/>
                    </div>

                    <br/>

                    <div class="p-field">
                        <Button label="Review" :loading="submitted" class="mr-2 mb-2" :disabled="!file"
                                @click="submitFile"></Button>
                    </div>

                    <br/>
                    <div class="p-field">
                        <Button label="Cancel" class="mr-2 mb-2" :loading="submitted"
                                @click="callResetImportPayments"></Button>
                    </div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 27" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Client User</h3>

                    <div class="field">
                        <label for="location">Location</label>
                        <Dropdown v-model="clientUser.userConfigDto.siLocation" :options="locations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Region"/>
                    </div>

                    <div class="field">
                        <label for="plan">Plan</label>
                        <Dropdown v-model="clientUser.userConfigDto.siPlan" :options="plans" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Account Type"/>
                    </div>

                    <div class="field">
                        <label for="siEnableUs">Access to US Stock Market?</label>
                        <Dropdown v-model="clientUser.userConfigDto.enableSiUs" :options="confirmationTypes"
                                  :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableCa">Access to Canadian Stock Market?</label>
                        <Dropdown v-model="clientUser.userConfigDto.enableSiCa" :options="confirmationTypes"
                                  :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableUk">Access to UK Stock Market?</label>
                        <Dropdown v-model="clientUser.userConfigDto.enableSiUk" :options="confirmationTypes"
                                  :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableZa">Access to South African Stock Market?</label>
                        <Dropdown v-model="clientUser.userConfigDto.enableSiZa" :options="confirmationTypes"
                                  :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <!--                    <div class="field">-->
                    <!--                        <label for="siEnableUk">Access to SI Course?</label>-->
                    <!--                        <InputText id="courseRights" type="text" :disabled="true" v-model.trim="courseRights"/>-->
                    <!--                    </div>-->

                    <!--                    <div class="field">-->
                    <!--                        <span class="p-column-title">&nbsp;</span>-->
                    <!--                    </div>-->

                    <!--                    <h3>Subscription Cancellation</h3>-->
                    <!--                    <div class="field">-->
                    <!--                        <label for="siActiveSubscription">Subscription Status</label>-->
                    <!--                        <InputText-->
                    <!--                            id="siActiveSubscription"-->
                    <!--                            type="text"-->
                    <!--                            :disabled="true"-->
                    <!--                            :value="subscriptionStatusLabel"/>-->
                    <!--                    </div>-->

                </div>
            </div>
        </div>

        <div v-if="activeTab === 28" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Files</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callUploadClientFile" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Upload File</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Overview</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable
                        :value="clientFiles"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        v-model:filters="filtersForFiles"
                        filterDisplay="menu"
                        :loading="submitted"
                        responsiveLayout="scroll"
                        :globalFilterFields="['simpleFilename']">

                        <template #header>
                            <div class="p-grid">

                                <div class="grid">
                                    <div class="col-12 lg:col-12 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                class="p-button-outlined p-ml-2" @click="clearFilterForFiles()"/>
                                    </div>
                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filtersForFiles['global'].value"
                                                   placeholder="Keyword Search on File Name"
                                                   style="width: 100%"/>
                                    </span>
                                </div>
                            </div>

                        </template>

                        <template #empty>
                            No files found.
                        </template>

                        <template #loading>
                            Loading files. Please wait.
                        </template>

                        <Column field="selectAnOption" headerStyle="width: 140px"
                                bodyStyle="width: 140px; overflow: hidden; white-space: nowrap;">
                            <template #body="{ data }">
                                <Button v-tooltip="'View'" icon="pi pi-eye"
                                        class="p-button-rounded p-button-success m-1"
                                        @click="viewClientFile(data)"/>

                                <Button v-tooltip="'Download'" icon="pi pi-cloud-download"
                                        class="p-button-rounded p-button-help m-1"
                                        @click="downloadClientFile(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1"
                                        @click="callDeleteClientFile(data)"/>

                            </template>
                        </Column>

                        <Column field="type" header="Type" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Type</span>
                                <span v-if="data.type === 'G'"
                                      :class="'type-badge status-' + data.type">General</span>
                                <span v-if="data.type === 'C'"
                                      :class="'type-badge status-' + data.type">Client</span>
                                <span v-if="data.type === 'N'"
                                      :class="'type-badge status-' + data.type">Note</span>
                                <span v-if="data.type === 'T'"
                                      :class="'type-badge status-' + data.type">Task</span>
                            </template>
                        </Column>

                        <Column field="simpleFilename" header="File Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">File Name</span>
                                {{ data.simpleFilename }}
                            </template>
                        </Column>

                        <Column field="created" header="Created" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Created</span>
                                {{ formatDate(data.created) }}
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 30" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete File {{ this.specificClientFile.simpleFilename }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this File?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>


                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteClientFile"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 32" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Provisions for Client {{ this.client.name }}</h3>

                    <DataTable :value="clientProvisions" :paginator="true" class="p-datatable-gridlines" :rows="100"
                               dataKey="id" :rowsPerPageOptions="[10, 20, 50, 100]" :rowHover="true"
                               :striped-rows="true"
                               :reorderableColumns="true" :sortMode="'multiple'" responsiveLayout="scroll">

                        <template #empty>
                            No provisions found.
                        </template>

                        <template #loading>
                            Loading provisions. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 15%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1" :loading="submitted"
                                        @click="callUpdateProvision(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1" :loading="submitted"
                                        @click="callDeleteProvision(data)"/>

                                <Button v-tooltip="'View'" icon="pi pi-bars"
                                        class="p-button-rounded p-button-info m-1" :loading="submitted"
                                        @click="callViewProvisionComponents(data)"/>
                            </template>
                        </Column>

                        <Column field="name" header="Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Name</span>
                                {{ data.name }}
                            </template>
                        </Column>

                        <Column field="billingPlanName" header="Billing Plan Name" :sortable="true">
                            <template #body="{ data }">
                                <span class="p-column-title">Billing Plan Name</span>
                                {{ data.billingPlanName }}
                            </template>
                        </Column>

                    </DataTable>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 33" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create New Client using Healthcare Insurance Check</h3>

                    <div class="field">
                        <span>Note: If the client details are found, a new client, including the dependants,
                            will be created. If the client already exists on your account, the details will be updated.
                        </span>
                    </div>

                    <div style="height: 10px;"></div>

                    <div class="field">
                        <label for="medicalName">Medical Name</label>
                        <AutoComplete v-model="clientConfiguration.medicalName" :dropdown="false"
                                      :multiple="false" :suggestions="filteredProviders"
                                      @complete="searchProviders($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div class="field">
                        <label for="medicalNumber">Medical Number</label>
                        <InputText id="medicalNumber" v-model.trim="clientConfiguration.medicalNumber"
                                   required="true"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted"
                            @click="createClientHealthcareInsurance"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>


                </div>
            </div>
        </div>

        <div v-if="activeTab === 34" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Member Benefit Check</h3>

                    <div class="field">
                        <span>Note: This is not an actual claim, and is just an indication from the health insurance
                            company whether a submitted claim will be accepted or not.
                        </span>
                    </div>

                    <div style="height: 10px;"></div>

                    <div class="field">
                        <label for="medicalName">Medical Name</label>
                        <AutoComplete v-model="clientConfiguration.medicalName" :dropdown="false"
                                      :multiple="false" :suggestions="filteredProviders"
                                      @complete="searchProviders($event)" field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div class="field">
                        <label for="medicalNumber">Medical Number</label>
                        <InputText id="medicalNumber" v-model.trim="clientConfiguration.medicalNumber"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="billingPlan">Billing Plan</label>
                        <AutoComplete placeholder="Search" :dropdown="true" :multiple="false" :required="true"
                                      v-model="clientConfiguration.billingPlan" :suggestions="filteredBillingPlans"
                                      @complete="searchBillingPlan($event)"
                                      field="name"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted"
                            @click="createMemberBenefitCheck"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>


                </div>
            </div>
        </div>


        <div v-if="activeTab === 35" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Member Benefit Check Results</h3>

                    <div class="field">
                        <span>Note: This is not an actual claim, and is just an indication from the health insurance
                            company whether a submitted claim will be accepted or not.
                        </span>
                    </div>

                    <div style="height: 10px;"></div>

                    <div class="field">
                        <label for="responseCode">Result</label>
                        <br/>
                        <span v-if="clientConfiguration.responseCode === 'FA'"
                              :class="'status-badge status-A'">Full Acceptance</span>
                        <span v-else-if="clientConfiguration.responseCode === 'PA'"
                              :class="'status-badge status-I'">Partial Acceptance</span>
                        <span v-else-if="clientConfiguration.responseCode === 'RJ'"
                              :class="'status-badge status-P'">Rejected</span>
                        <span v-else
                              :class="'status-badge status-P'">Unknown</span>
                    </div>

                    <div class="field">
                        <label for="responseReference">Reference</label>
                        <InputText id="responseReference" disabled="true"
                                   v-model.trim="clientConfiguration.responseReference"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="responseDescription">Response</label>
                        <Textarea placeholder="Your Message" rows="5" cols="30" id="responseDescription"
                                  v-model.trim="clientConfiguration.responseDescription" required="false"
                                  disabled="true"/>
                    </div>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>


                </div>
            </div>
        </div>

        <div v-if="activeTab === 36" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Provision {{ this.provision.name }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="provision.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="billingPlan">Billing Plan</label>
                        <AutoComplete placeholder="Search or Select" :dropdown="true" :multiple="false"
                                      v-model="provision.billingPlanName" :suggestions="filteredBillingPlans"
                                      @complete="searchBillingPlan($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <Textarea v-model="provision.description" :autoResize="true" rows="10" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="value">Created</label>
                        <InputText id="created" v-model.trim="provision.created" required="true" disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="provision.status" :options="statusTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Action"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateProvision"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetProvisions"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 37" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Provision {{ this.provision.name }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Provision from the
                            Client?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteProvision"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetProvisions"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 38" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Components of Provision {{ this.clientProvision.name }} for Client
                        {{ this.clientProvision.clientName }}</h3>

                    <DataTable
                        :value="clientProvisionComponents"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        v-model:filters="filters"
                        filterDisplay="menu"
                        :loading="loading"
                        responsiveLayout="scroll"
                        :globalFilterFields="['name', 'description']">

                        <template #header>
                            <div class="p-grid">
                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filters['global'].value"
                                                   placeholder="Keyword Search on Name or Description"
                                                   style="width: 100%"/>
                                    </span>
                                </div>
                            </div>

                        </template>

                        <template #empty>
                            No provision components found.
                        </template>

                        <template #loading>
                            Loading provision components. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 15%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1" :loading="submitted"
                                        @click="callUpdateProvisionComponent(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1" :loading="submitted"
                                        @click="callDeleteProvisionComponent(data)"/>
                            </template>
                        </Column>

                        <!--                        <Column field="selectAnOption" style="width: 10%">-->
                        <!--                            <template #body="{ data }">-->
                        <!--                                <SplitButton icon="pi pi-pencil" label="Select"-->
                        <!--                                             :model="getFilteredItemsComponents(data)"-->
                        <!--                                             severity="success"-->
                        <!--                                             @click="chooseBlankSelection(data)" class="mb-2 mr-2 ml-2 mt-2"/>-->
                        <!--                            </template>-->
                        <!--                        </Column>-->

                        <Column field="name" header="Name" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Name</span>
                                {{ data.name }}
                            </template>
                        </Column>

                        <Column field="type" header="Type" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Type</span>
                                <span v-if="data.type === 'I'"
                                      :class="'component-badge status-' + data.type">Indirect</span>
                                <span v-if="data.type === 'D'"
                                      :class="'component-badge status-' + data.type">Direct</span>
                            </template>
                        </Column>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                                <span v-if="data.status === 'A'"
                                      :class="'status-badge status-' + data.status">Active</span>
                            </template>
                        </Column>

                        <Column field="quantity" header="Quantity" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Quantity</span>
                                {{ data.quantity }}
                            </template>
                        </Column>

                        <Column field="used" header="Used" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Used</span>
                                {{ data.used }}
                            </template>
                        </Column>

                        <Column field="billingPlan" header="Billing Plan" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Billing Plan</span>
                                {{ data.billingPlanName }}
                            </template>
                        </Column>

                    </DataTable>

                    <Button label="Back" class="mr-2 mb-2" :loading="submitted" @click="callResetProvisions"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 403" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send Online Booking Link to Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Send the Online Booking Link?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="sendBookingLink"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuManage"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 40" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Import Clients</h3>

                    <div class="field">
                        <label for="inputFormat">Input Format</label>
                        <Dropdown v-model="inputFormatClientImport" :options="inputFormatsClientImport"
                                  optionLabel="name" optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="p-field">
                        <input type="file" @change="handleFileUploadClientImport" accept=".csv"/>
                    </div>

                    <br/>

                    <div class="p-field">
                        <Button label="Import" :loading="submitted" class="mr-2 mb-2" :disabled="!fileClientImport"
                                @click="submitFileClientImport"></Button>
                    </div>

                    <br/>
                    <div class="p-field">
                        <Button label="Cancel" class="mr-2 mb-2" :loading="submitted"
                                @click="callResetImportClients"></Button>
                    </div>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 404" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send Digital Form Link to Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="selectedDigitalForm">Digital Form</label>
                        <AutoComplete placeholder="Search" :dropdown="true" :multiple="false" :required="true"
                                      v-model="selectedDigitalForm" :suggestions="filteredDigitalForms"
                                      @complete="searchDigitalForms($event)" field="name"/>
                    </div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="sendDigitalFormLink"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callMenuManage"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 42" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Send WhatsApp to Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="smsMessage">WhatsApp Message</label>
                        <InputText id="smsMessage" v-model.trim="sms.smsMessage" required="true"/>
                    </div>

                    <Button label="Send" class="mr-2 mb-2" :loading="submitted" @click="sendWhatsapp"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 43" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Summary of {{ this.client.name }}</h3>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                    <div style="height: 1px;"></div>

                    <h3>Profile Information</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="client.type" :disabled="true" :options="clientTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div v-show="client.type === 'J'" class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="client.name" :disabled="true" required="true"/>
                    </div>

                    <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                        <label for="firstName">First Name</label>
                        <InputText id="firstName" v-model.trim="client.firstName" :disabled="true" required="true"/>
                    </div>

                    <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                        <label for="lastName">Last Name</label>
                        <InputText id="lastName" v-model.trim="client.lastName" :disabled="true" required="true"/>
                    </div>

                    <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                        <label for="preferredName">Preferred Name</label>
                        <InputText id="preferredName" v-model.trim="client.preferredName" :disabled="true"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" v-model.trim="client.email" :disabled="true" required="true"/>
                    </div>

                    <div class="field">
                        <label for="alternateEmail">Alternate Emails (separated by comma)</label>
                        <InputText id="alternateEmail" v-model.trim="client.alternateEmail" :disabled="true"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile Number</label>
                        <InputText id="mobile" v-model.trim="client.mobile" :disabled="true" required="true"/>
                    </div>

                    <div class="field">
                        <label for="idNumber">ID Number</label>
                        <InputText id="idNumber" v-model.trim="client.idNumber" :disabled="true" required="false"/>
                    </div>

                    <div class="field">
                        <label for="dob">Date of Birth</label>
                        <Calendar id="dob" v-model="client.dob" :disabled="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div v-show="client.type === 'N' || client.type === 'M'" class="field">
                        <label for="gender">Gender</label>
                        <Dropdown v-model="client.gender" :disabled="true" :options="genderTypes" optionLabel="name"
                                  required="true"
                                  optionValue="code" placeholder="Select a Gender"/>
                    </div>

                    <div v-show="(client.type === 'N' || client.type === 'M') && client.gender === 'O'"
                         class="field">
                        <label for="genderOther">Please Specify Gender Type</label>
                        <InputText id="genderOther" v-model.trim="client.genderOther" :disabled="true" required="true"/>
                    </div>

                    <div class="field">
                        <label for="commStatus">Communication Approval?</label>
                        <Dropdown v-model="client.commStatus" :disabled="true" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="taxRegistered">Tax Registered?</label>
                        <Dropdown v-model="client.taxRegistered" :disabled="true" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="client.taxRegistered == 'Y'" class="field">
                        <label for="taxNumber">Tax Number</label>
                        <InputText id="taxNumber" v-model.trim="client.taxNumber" :disabled="true" required="false"/>
                    </div>

                    <div class="field">
                        <label for="addressCountry">Country</label>
                        <Dropdown v-model="client.addressCountry" :disabled="true" :options="countries"
                                  optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="address1">Address Line 1</label>
                        <InputText id="address1" v-model.trim="client.address1" :disabled="true" required="true"/>
                    </div>

                    <div class="field">
                        <label for="address2">Address Line 2</label>
                        <InputText id="address2" v-model.trim="client.address2" :disabled="true" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressRegion">Region</label>
                        <InputText id="addressRegion" v-model.trim="client.addressRegion" :disabled="true"
                                   required="true"/>
                    </div>

                    <div v-show="client.addressCountry === 'ZA'" class="field">
                        <label for="addressState">Province</label>
                        <Dropdown v-model="client.addressState" :disabled="true" :options="regionsSouthAfrica"
                                  optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <div v-show="client.addressCountry === 'UK'" class="field">
                        <label for="addressState">County</label>
                        <InputText id="addressState" v-model.trim="client.addressState" required="true"/>
                    </div>

                    <div v-show="client.addressCountry != 'ZA' && client.addressCountry != 'UK'" class="field">
                        <label for="addressState">State</label>
                        <InputText id="addressState" v-model.trim="client.addressState" :disabled="true"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Postal Code</label>
                        <InputText id="addressPostalCode" v-model.trim="client.addressPostalCode" :disabled="true"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="client.status" :disabled="true" :options="statusTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div v-show="client.type === 'M'" class="field">
                        <label for="fatherClientName">Parent or Guardian #1</label>
                        <AutoComplete v-model="client.fatherName" :disabled="true" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)"
                                      field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div v-show="client.type === 'M'" class="field">
                        <label for="motherClientName">Parent or Guardian #2</label>
                        <AutoComplete v-model="client.motherName" :disabled="true" :dropdown="false" :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)"
                                      field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div class="field">
                        <label for="billingClient">Billing Contact</label>
                        <AutoComplete v-model="client.billingClientName" :disabled="true" :dropdown="false"
                                      :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)"
                                      field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>

                    <div class="field">
                        <label for="adminClient">Administration Contact</label>
                        <AutoComplete v-model="client.adminClientName" :disabled="true" :dropdown="false"
                                      :multiple="false"
                                      :suggestions="filteredClients" @complete="searchClients($event)"
                                      field="name"
                                      placeholder="Type the first few characters to search"/>
                    </div>


                    <div style="height: 20px;"></div>

                    <h3>Products</h3>

                    <div class="card">
                        <DataTable :value="clientProducts" scrollable scrollHeight="400px" class="mt-2">
                            <Column field="productName" header="Name" style="min-width: 200px" frozen
                                    class="font-bold"/>
                            <Column field="productUniqueId" header="Unique #" style="min-width: 100px"/>
                            <Column field="billingPlanName" header="Billing Plan" style="min-width: 100px"/>

                            <Column field="premium" header="Premium" style="min-width: 100px" alignFrozen="right">
                                <template #body="{ data }">
                                    <span>{{ formatAmount(data.premium) }}</span>
                                </template>
                            </Column>

                            <Column field="value" header="Value" style="min-width: 100px" alignFrozen="right">
                                <template #body="{ data }">
                                    <span>{{ formatAmount(data.value) }}</span>
                                </template>
                            </Column>

                            <Column field="inception" header="Inception" style="min-width: 100px"/>
                            <Column field="termination" header="Termination" style="min-width: 100px"/>
                        </DataTable>
                    </div>

                    <div style="height: 20px;"></div>

                    <h3>Tasks</h3>

                    <div class="card">
                        <DataTable :value="clientTasks" scrollable scrollHeight="400px" class="mt-2">
                            <Column field="id" header="Task #" style="min-width: 50px" frozen class="font-bold"/>
                            <Column field="processName" header="Process" style="min-width: 100px"/>
                            <Column field="description" header="Description" style="min-width: 200px"/>

                            <Column field="requester" header="Requester" style="min-width: 100px">
                                <template #body="{ data }">
                                    <span>{{ data.requesterFirstName + ' ' + data.requesterLastName }}</span>
                                </template>
                            </Column>

                            <Column field="assigned" header="Assigned To" style="min-width: 100px">
                                <template #body="{ data }">
                                    <span>{{ data.userFirstName + ' ' + data.userLastName }}</span>
                                </template>
                            </Column>

                            <Column field="status" header="Status" style="min-width: 100px">
                                <template #body="{ data }">
                                    <span v-if="data.status === 'I'">{{ "Initiated" }}</span>
                                    <span v-else-if="data.status === 'C'">{{ "Completed" }}</span>
                                    <span v-else>{{ "Working on it" }}</span>
                                </template>
                            </Column>

                            <Column field="start" header="Start Date" style="min-width: 100px">
                                <template #body="{ data }">
                                    <span>{{ formatDate(data.start) }}</span>
                                </template>
                            </Column>

                            <Column field="end" header="Completed Date" style="min-width: 100px" alignFrozen="right">
                                <template #body="{ data }">
                                    <span>{{ formatDate(data.end) }}</span>
                                </template>
                            </Column>

                        </DataTable>
                    </div>

                    <div style="height: 20px;"></div>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-if="activeTab === 46" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Label {{ this.label.labelName }} for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Label from the
                            Client?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteLabel"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetLabels"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import ClientService from "@/service/ClientService";
import moment from "moment";
import ClientProductService from "@/service/ClientProductService";
import NoteService from "@/service/NoteService";
import TaskService from "@/service/TaskService";
import InvoiceService from "@/service/InvoiceService";
import ProductService from "@/service/ProductService";
import ProcessService from "@/service/ProcessService";
import BillingPlanService from "@/service/BillingPlanService";
import ProviderService from "@/service/ProviderService";
import Icd10CodeService from "@/service/Icd10CodeService";
import NoteTemplateService from "@/service/NoteTemplateService";
import axios from "axios";
import PractitionerService from "@/service/PractitionerService";
import StorageService from "@/service/StorageService";
import ClaimService from "@/service/ClaimService";
import ProvisionService from "@/service/ProvisionService";
import ClientProvisionService from "@/service/ClientProvisionService";
import ClientProvisionComponentService from "@/service/ClientProvisionComponentService";
import VideoRecorder from "@/service/VideoRecorder";
import ImageEditor from "@/service/ImageEditor";
import DigitalFormService from "@/service/DigitalFormService";
import numeral from "numeral";
import ClientLabelService from "@/service/ClientLabelService";
import LabelService from "@/service/LabelService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    props: {
        inputClientId: {
            type: String,
            required: false
        },
        inputActiveTab: {
            type: String,
            required: false
        }
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    computed: {
        canCreateInvoice() {
            if ((this.invoice.type === 'B') && (this.invoice.billingPlan)) {
                return true;
            } else if ((this.invoice.type === 'P') && (this.invoice.product)) {
                return true;
            } else {
                return false;
            }
        },
        canCreateNote() {
            if ((this.note.format === 'R') || (this.note.format === 'V') || (this.note.format === 'C') || (this.note.format === 'A')) {
                if ((this.note.subject) && (this.note.description)) {
                    return true;
                } else {
                    return false;
                }
            } else if (this.note.format === 'O') {
                if ((this.note.subject) && (this.note.description) && (this.note.videoSessionId) && (!this.videoActive)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }

        },
        canCancelNote() {
            if (this.note.format === 'O') {
                if (!this.videoActive) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        canAddLabel() {
            if (this.selectedLabel.label) {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        this.initFilters();
        this.icd10CodeService = new Icd10CodeService();

        this.columnsDefault = [
            {field: 'name', header: 'Name', sortable: true},
            {field: 'firstName', header: 'First Name', sortable: true},
            {field: 'preferredName', header: 'Preferred Name', sortable: true},
            {field: 'lastName', header: 'Last Name', sortable: true},
            {field: 'email', header: 'Email', sortable: true},
            {field: 'mobile', header: 'Mobile', sortable: true},
            {field: 'type', header: 'Type', sortable: true},
            {field: 'status', header: 'Status', sortable: true},
            {field: 'labels', header: 'Labels', sortable: true}
        ];

        this.columnsFullList = [
            {field: 'companyId', header: 'Company ID', sortable: true},
            {field: 'id', header: 'ID', sortable: true},
            {field: 'name', header: 'Name', sortable: true},
            {field: 'firstName', header: 'First Name', sortable: true},
            {field: 'preferredName', header: 'Preferred Name', sortable: true},
            {field: 'lastName', header: 'Last Name', sortable: true},
            {field: 'email', header: 'Email', sortable: true},
            {field: 'mobile', header: 'Mobile', sortable: true},
            {field: 'type', header: 'Type', sortable: true},
            {field: 'status', header: 'Status', sortable: true},
            {field: 'category', header: 'Category', sortable: true},
            {field: 'labels', header: 'Labels', sortable: true}
        ];

        this.selectedColumns = this.columnsDefault;

        this.standardFilters = [
            {field: 'active', header: 'Active Clients'},
            {field: 'inactive', header: 'Inactive Clients'},
            {field: 'pending', header: 'Pending Clients'},
            {field: 'natural', header: 'Natural Person (Adult)'},
            {field: 'minor', header: 'Natural Person (Minor)'},
            {field: 'juristic', header: 'Juristic Type'}
        ];
    },
    async mounted() {
        const state = history.state || {};

        this.activeClientId = state.inputClientId || this.inputClientId;

        console.log('[ClientDetail][mounted] this.activeClientId = ', this.activeClientId);

        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[ClientDetail][mounted] System is active.");
            console.log("[ClientDetail][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[ClientDetail][mounted] System is NOT active.");
            console.log("[ClientDetail][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[ClientDetail][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();

        console.log("[ClientDetail][mounted] this.companyConfiguration.type = ", this.companyConfiguration.type);

    },
    data() {

        return {
            profile: {},
            userConfiguration: {},
            companyConfiguration: {},
            client: {},
            activeTab: 1,
            activeClientId: 0,
            submitted: false,
            appointments: [],
            tasks: [],
            products: [],
            notes: [],
            invoices: [],
            payments: [],
            labels: [],
            files: [],
            provisions: [],
            auditTrails: [],
            practitioners: [],
            allLabels: [],
            financialInfo: {},
            file: null,
            fileClientImport: null,
            transcriptionActive: false,
            transcriptionError: "",
            voiceSocket: null,
            voiceActive: false,
            voiceError: null,
            mediaStream: null,
            audioContext: null,
            scriptNode: null,
            voiceCommittedText: "",
            voiceCurrentTurn: "",
            reconnectTimer: null,
            wsHeartbeat: null,
            lastWsPong: null,
            audioFaultTimer: null,
            newVideoRecorder: null,
            backgroundImageOptions: null,
            newImageEditor: null,
            newImageEditorReady: false,
            updateImageEditor: null,
            updateImageEditorReady: false,
            viewImageEditor: null,
            viewImageEditorReady: false,
            videoSource: 'C',
            videoSocket: null,
            videoActive: false,
            videoError: null,
            clientFiles: null,
            specificClientFile: {},
            clientFile: null,
            clientFileUrl: "/storage/1",
            clientFileAccept: 'application/pdf',
            selectedClientFileType: 'C',
            clientFileTypes: [
                {name: 'General', code: 'G'},
                {name: 'Client', code: 'C'},
                {name: 'Task', code: 'T'},
                {name: 'Note', code: 'N'},
                {name: 'Prospect', code: 'P'}
            ],
            lastSubmitTime: 0,
            submitCooldownMs: 2000,
            totalRecords: 0,
            lazyParams: {
                first: 0,
                rows: 100,
                sortField: null,
                sortOrder: 1,
                filters: {}
            },
            filters: null,
            filtersForFiles: null,
            inputFormat: null,
            inputFormatClientImport: null,
            url: "/client1/import/1/upload/document/evexia", // URL for API call
            urlClientImport: "/client1/import/1/upload/generic/clients", // URL for API call
            fileAccept: 'application/pdf', // Accept CSV and PDF files
            inputFormats: [
                {name: 'Evexia Form (PDF)', code: '001'},
                {name: 'Netcare Form (PDF)', code: '002'}
            ],
            inputFormatsClientImport: [
                {name: 'IsoEvolve Format', code: '001'},
                {name: 'smeMetrics Format', code: '002'},
            ],
            bulkSmsMessage: null,
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            selectedStandardFilter: null,
            selectedDigitalForm: null,
            digitalForms: [],
            standardFilters: null,
            useTaxRate: 'N',
            filteredItemsCache: new Map(),
            filteredItemsNotesCache: new Map(),
            advancedView: true,
            reloadKey: 0,
            clientTasks: [],
            clientProducts: [],
            clientLabels: [],
            clients: null,
            newClient: {},
            originalClients: null,
            product: {},
            label: {},
            selectedProduct: {},
            selectedLabel: {},
            selectedProvision: {},
            clientProvisions: null,
            clientProvisionComponents: null,
            provisionComponents: null,
            provisionComponent: {},
            clientProvision: {},
            clientProvisionComponent: {},
            clientUser: {
                userConfigDto: {
                    siPlan: null,
                    siLocation: null,
                    enableSiUs: null,
                    enableSiCa: null,
                    enableSiUk: null,
                    enableSiZa: null,
                }
            },
            note: {},
            task: {},
            newTask: {},
            newStatement: {},
            invoice: {},
            unpaid: {},
            auditTrail: {},
            email: {},
            sms: {},
            company: {},
            clientConfiguration: {},
            filteredDiagnosticCodes: [],
            filteredProducts: [],
            filteredLabels: [],
            filteredProvisions: [],
            filteredDigitalForms: [],
            filteredBillingPlans: [],
            filteredProcesses: [],
            filteredUsers: [],
            filteredClients: [],
            filteredAffiliateClients: [],
            filteredPractitioners: [],
            filteredPractitionersReferring: [],
            filteredProviders: [],
            confirmationResponse: 'N',
            // useExistingReferringPractitioner: 'N',
            noteTemplates: null,
            noteTemplateId: null,
            courseRights: "No",
            plans: [
                {name: 'Monthly', code: 'M'},
                {name: 'Annual', code: 'A'}
            ],
            locations: [
                {name: 'United States', code: 'US'},
                {name: 'Canada', code: 'CA'},
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Other', code: 'O'}
            ],
            statementTypes: [
                {name: 'Compact', code: 'C'},
                {name: 'Detailed', code: 'D'},
                {name: 'Recon', code: 'R'}
            ],
            statusTypes: [
                {name: 'Active', code: 'A'},
                {name: 'Inactive', code: 'I'},
                {name: 'Pending', code: 'P'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            invoiceTypes: [
                {name: 'Billing Plan', code: 'B'},
                {name: 'Product', code: 'P'}
            ],
            clientTypes: [
                {name: 'Natural Person (Adult)', code: 'N'},
                {name: 'Natural Person (Minor)', code: 'M'},
                {name: 'Juristic Person', code: 'J'},
            ],
            noteTypes: [
                {name: 'Personal', code: 'P'},
                {name: 'Clinical', code: 'C'},
            ],
            videoSources: [
                {name: 'Audio Only', code: 'A'},
                {name: 'Camera', code: 'C'},
                {name: 'Screen', code: 'S'},
            ],
            formatTypes: [
                {name: 'Rich Text', code: 'R'},
                {name: 'Freeform', code: 'C'},
                {name: 'Media recording', code: 'O'},
                {name: 'Voice Transcription', code: 'V'},
                {name: 'Audio Transcription', code: 'A'}
            ],
            rateOptionTypes: [
                {name: 'Base Rate (Default)', code: 'D'},
                {name: 'Premier Rate A', code: 'A'},
                {name: 'Premier Rate B', code: 'B'}
            ],
            submissionMethod: [
                {name: 'Invoice Only', code: 'C'},
                {name: 'Invoice and Health Insurance Claim', code: 'B'}
            ],
            healthInsuranceSubmissionMethod: [
                {name: 'Email', code: 'E'},
                {name: 'Electronic Data Interchange (EDI)', code: 'D'}
            ],
            subProcessTypes: [
                {name: 'Unpaids Management', code: 'Unpaids Management'},
                {name: 'Client Management', code: 'Client Management'},
                {name: 'Billing Management', code: 'Billing Management'}
            ],
            unpaidTypes: [
                {name: 'Member Liable', code: 'M'},
                {name: 'Gentle Notice', code: 'G'},
                {name: 'First Notice', code: 'F'},
                {name: 'Final Notice', code: 'S'},
                {name: 'Litigation Notice', code: 'L'},
                {name: 'Account Internally Written Off', code: 'C'}
            ],
            genderTypes: [
                {name: 'Male', code: 'M'},
                {name: 'Female', code: 'F'},
                {name: 'Other', code: 'O'}
            ],
            countries: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'India', code: 'IN'},
                {name: 'United States', code: 'US'},
                {name: 'Namibia', code: 'NA'},
                {name: 'Botswana', code: 'BW'},
                {name: 'Australia', code: 'AU'},
                {name: 'New Zealand', code: 'NZ'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'Slovenia', code: 'SV'},
                {name: 'Taiwan', code: 'TW'},
                {name: 'Other', code: 'OT'}
            ],
            regionsSouthAfrica: [
                {name: 'Gauteng', code: 'Gauteng'},
                {name: 'Western Cape', code: 'Western Cape'},
                {name: 'Kwa-Zulu Natal', code: 'Kwa-Zulu Natal'},
                {name: 'North-West', code: 'North-West'},
                {name: 'Free State', code: 'Free State'},
                {name: 'Eastern Cape', code: 'Eastern Cape'},
                {name: 'Mpumalanga', code: 'Mpumalanga'},
                {name: 'Northern Cape', code: 'Northern Cape'},
                {name: 'Limpopo', code: 'Limpopo'}
            ],
            taskTypes: [
                {name: 'Software Support', code: 'S'},
                {name: 'Billing', code: 'B'},
                {name: 'Scheduling', code: 'C'},
                {name: 'Unpaids Management', code: 'U'},
                {name: 'Payment Management', code: 'P'},
                {name: 'Other', code: 'O'}
            ],
            taskTypesFinancialAdvisor: [
                {name: 'Administration', code: 'D'},
                {name: 'New Business', code: 'E'},
                {name: 'Benefit Query', code: 'F'},
                {name: 'Authorisation', code: 'G'},
                {name: 'Claims', code: 'H'},
                {name: 'Software Support', code: 'S'},
                {name: 'Billing', code: 'B'},
                {name: 'Scheduling', code: 'C'},
                {name: 'Unpaids Management', code: 'U'},
                {name: 'Payment Management', code: 'P'},
                {name: 'Other', code: 'O'}
            ],
            practitionerTypes: [
                {name: 'Occupational Therapist', code: 'A'},
                {name: 'Clinical Psychologist', code: 'B'},
                {name: 'Counselling Psychologist', code: 'C'},
                {name: 'Educational Psychologist', code: 'D'},
                {name: 'Industrial Psychologist', code: 'E'},
                {name: 'Psychologist', code: 'F'},
                {name: 'Psychiatrist', code: 'G'},
                {name: 'Social Worker', code: 'H'},
                {name: 'Registered Counsellor', code: 'I'},
                {name: 'Biokineticist', code: 'J'},
                {name: 'Physiotherapist', code: 'K'},
                {name: 'Speech Therapist', code: 'L'},
                {name: 'Audiologist', code: 'M'},
                {name: 'Speech Therapist and Audiologist', code: 'N'},
                {name: 'Dietician', code: 'O'},
                {name: 'Chiropractor', code: 'P'},
                {name: 'Podiatrist', code: 'Q'},
                {name: 'GP', code: 'R'},
                {name: 'Dentist', code: 'S'},
                {name: 'Specialist Physician', code: 'T'},
                {name: 'Registered Nurse', code: 'V'},
                {name: 'Anaesthetist', code: 'W'},
                {name: 'Gynaecologist', code: 'X'},
                {name: 'Ocularist', code: 'Y'},
                {name: 'Other', code: 'U'},
            ]
        }
    },
    watch: {
        clients() {
            this.filteredItemsCache.clear();
        },
        notes() {
            this.filteredItemsNotesCache.clear();
        },
        'clientConfiguration.copyMainMemberDetails'(newVal) {
            if (newVal) {
                this.copyMainMemberToPatient();
            }
        },
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Clients][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    beforeUnmount() {
        this.cleanupVoice()
        if (this.newVideoRecorder && this.videoActive) {
            console.log("[ClientDetail][beforeUnmount] Stopping video recording.");
            this.newVideoRecorder.stopRecording();
        }
    },
    methods: {
        async loadCompanyContext() {
            console.log('[ClientDetail][loadCompanyContext] Loading data for company', this.userStore.activeCompanyId);

            try {
                this.submitted = true;

                try {
                    // Attempt to get user data
                    const userData = await UserService.getUser(this.userStore.user.id);
                    this.profile = userData.data;
                } catch (e) {
                    console.error("[ClientDetail][mounted] Error fetching user data = ", e);
                    this.userStore.clearUser();
                    this.$router.push('login');
                    return;
                }

                this.profile.companyId = this.userStore.activeCompanyId;

                console.log("[ClientDetail][loadCompanyContext] this.profile = ", this.profile);

                const [userConfigurationData, companyConfigurationData, companyData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id),
                    CompanyService.getCompanyConfiguration(this.profile.companyId),
                    CompanyService.getCompany(this.profile.companyId)
                ]);

                this.userConfiguration = userConfigurationData.data;
                this.companyConfiguration = companyConfigurationData.data;
                this.company = companyData.data;

                await this.loadData();

                this.submitted = false;

            } catch (e) {
                console.error("[ClientDetail][loadCompanyContext] Error fetching additional data = ", e);
            }

            this.submitted = false;
        },
        async loadData() {
            this.submitted = true;

            try {
                const [clientDetailData, labelData] = await Promise.all([
                    ClientService.getClientDetail(this.activeClientId),
                    LabelService.getCompanyLabels(this.profile.companyId)
                ])

                this.client = clientDetailData?.data ?? {};

                this.allLabels = labelData?.data ?? {};

                this.appointments = clientDetailData?.data?.appointments ?? {};
                this.tasks = clientDetailData?.data?.tasks ?? {};
                this.products = clientDetailData?.data?.products ?? {};
                this.notes = clientDetailData?.data?.notes ?? {};
                this.invoices = clientDetailData?.data?.invoices ?? {};
                this.payments = clientDetailData?.data?.payments ?? {};
                this.labels = clientDetailData?.data?.labels ?? {};
                this.files = clientDetailData?.data?.files ?? {};
                this.provisions = clientDetailData?.data?.provisions ?? {};
                this.auditTrails = clientDetailData?.data?.auditTrails ?? {};

                console.log("[ClientDetail][loadData] this.client.created = ", this.client.created);
                console.log("[ClientDetail][loadData] this.client.dob = ", this.client.dob);
                console.log("[ClientDetail][loadData] this.client = ", this.client);

                console.log("[ClientDetail][loadData] this.appointments = ", this.appointments);
                console.log("[ClientDetail][loadData] this.tasks = ", this.tasks);
                console.log("[ClientDetail][loadData] this.products = ", this.products);
                console.log("[ClientDetail][loadData] this.notes = ", this.notes);
                console.log("[ClientDetail][loadData] this.invoices = ", this.invoices);
                console.log("[ClientDetail][loadData] this.payments = ", this.payments);
                console.log("[ClientDetail][loadData] this.labels = ", this.labels);
                console.log("[ClientDetail][loadData] this.files = ", this.files);
                console.log("[ClientDetail][loadData] this.provisions = ", this.provisions);
                console.log("[ClientDetail][loadData] this.auditTrails = ", this.auditTrails);

            } catch (error) {
                console.error("[ClientDetail][loadData] Error loading clients:", error);
                this.clients = [];
                this.totalRecords = 0;
            } finally {
                this.submitted = false;
            }
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return numeral(String(0)).format('0,0.00');
            }
        },
        calculateTimeDifference(startTime) {
            if (!startTime) {
                return 0;
            }

            const targetDate = new Date(startTime);

            if (isNaN(targetDate.getTime())) {
                console.warn("Invalid startTime provided to calculateTimeDifference:", startTime);
                return 0;
            }

            const currentDate = new Date();

            const timeDifferenceMs = currentDate - targetDate;

            return timeDifferenceMs / 1000;
        },
        calculateTimeDifferenceForward(endTime) {
            if (!endTime) {
                return 0;
            }

            const now = new Date();
            const inputDate = new Date(endTime);

            if (isNaN(inputDate.getTime())) {
                console.warn("Invalid endTime provided to calculateTimeDifference:", endTime);
                return 0;
            }

            let targetDate = new Date(
                now.getFullYear(),
                inputDate.getMonth(),
                inputDate.getDate()
            );

            // If already passed → move to next year
            if (targetDate < now) {
                targetDate.setFullYear(now.getFullYear() + 1);
            }

            return (targetDate - now) / 1000;
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        callBackToOverview() {
            this.safeNavigate('/commonClients');
        },
        callMenuSummary() {
            this.activeTab = 1;
        },
        callMenuFinancial() {
            this.activeTab = 2;
        },
        callMenuUpdate() {
            if (this.companyConfiguration.type === 'F') {
                this.activeTab = 41;
            } else {
                this.activeTab = 31;
            }
        },
        callMenuManage() {
            this.activeTab = 4;
        },
        callUpdateFinancialInfo() {
            this.activeTab = 5;
        },
        callManageAppointments() {
            this.activeTab = 101;
        },
        callCreateAppointment() {
            this.activeTab = 102;
        },
        callManageTasks() {
            this.activeTab = 103;
        },
        callCreateTask() {
            this.activeTab = 104;
            this.newTask = {};
            this.newTask.clientVisible = 'N';
        },
        callManageProducts() {
            this.activeTab = 105;
        },
        callAddProduct() {
            this.activeTab = 106;
            this.selectedProduct = {};
        },
        callManageNotes() {
            this.activeTab = 107;
        },
        callCreateNote() {
            this.activeTab = 108;
            this.newVideoRecorder = null;
            this.videoSource = 'C';
            this.videoSocket = null;
            this.videoActive = false;
            this.videoError = null;

            this.note = {};
            this.note.type = 'P';
            this.note.sharable = 'N';
            this.note.editable = 'N';
            this.note.format = 'R';
            this.note.status = 'A';
            this.note.description = '';

            this.newImageEditor = new ImageEditor('new-', this.profile.companyId);
            this.newImageEditorReady = false;
            this.initBackgroundImageOptions();
        },
        callManageInvoices() {
            this.activeTab = 109;
        },
        callCreateInvoice() {
            this.activeTab = 110;
            this.invoice = {};
            this.invoice.type = 'B';
            this.useTaxRate = this.company.taxRegistered;
            this.invoice.invoiced = moment(moment().startOf('hour').toDate()).format('YYYY-MM-DD HH:mm');
            this.invoice.submissionMethod = 'C';
            this.invoice.healthInsuranceSubmission = 'E';
            this.invoice.useSystemProcedureRates = 'N';
            this.invoice.useSystemProductRates = 'N';
            this.invoice.useTaxRate = this.company.taxRegistered;
            this.invoice.useAutomaticSubmission = 'N';
            this.invoice.rateOption = 'D';
        },
        callManagePayments() {
            this.activeTab = 111;
        },
        callCreatePayment() {
            this.activeTab = 112;
        },
        async callManageLabels() {
            this.activeTab = 113;

            const [responseData] = await Promise.all([
                ClientLabelService.getClientLabels(this.client.id)
            ]);

            this.clientLabels = [...responseData.data];
        },
        callAddLabel() {
            this.activeTab = 114;
            this.selectedLabel = {};
        },
        callManageFiles() {
            this.activeTab = 115;
        },
        callUploadFile() {
            this.activeTab = 116;
        },
        callManageProvisions() {
            this.activeTab = 117;
        },
        callAddProvision() {
            this.activeTab = 118;
            this.selectedProvision = {};
        },
        callManageAuditTrails() {
            this.activeTab = 119;
        },
        callCreateAuditTrail() {
            this.activeTab = 120;
        },
        getLabelSeverity(label) {
            const severities = ['primary', 'success', 'info', 'warn', 'danger'];

            return severities[label.labelId % severities.length];
        },
        copyMainMemberToPatient() {
            this.clientConfiguration.medicalDependantFirstname =
                this.clientConfiguration.medicalMemberFirstname;

            this.clientConfiguration.medicalDependantLastname =
                this.clientConfiguration.medicalMemberLastname;

            this.clientConfiguration.medicalDependantInitials =
                this.clientConfiguration.medicalMemberInitials;

            this.clientConfiguration.medicalDependantId =
                this.clientConfiguration.medicalMemberId;

            this.clientConfiguration.medicalDependantCode =
                this.clientConfiguration.medicalMemberCode;
        },
        async submitAudioFile() {
            this.submitted = true;
            this.transcriptionActive = true;

            if (!this.file) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });
                this.submitted = false;
                return;
            }

            const formData = new FormData();
            formData.append('file', this.file);

            const url = `/api/voice/${this.profile.companyId}`;

            try {
                const response = await axios.post(url, formData, {
                    headers: {
                        'Authorization': `Bearer ${this.userStore.accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                console.log("[Clients][submitAudioFile] Success:", response.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Transcription Completed',
                    detail: 'Your audio file was successfully transcribed.',
                    life: 3000
                });

                this.note.description = response.data.transcript;
                this.transcriptionActive = false;

            } catch (error) {
                console.error("[Clients][submitAudioFile] Error:", error);

                this.transcriptionError = error;

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Transcription failed. Please try again.',
                    life: 4000
                });
            }

            this.file = null;
            this.submitted = false;
        },
        floatTo16BitPCM(float32Array) {
            const len = float32Array.length;
            const out = new Int16Array(len);
            for (let i = 0; i < len; i++) {
                let s = Math.max(-1, Math.min(1, float32Array[i]));
                out[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
            }
            return out;
        },
        startAudioWatchdog() {
            if (this.watchdogTimer) clearInterval(this.watchdogTimer);

            this.lastAudioTick = performance.now();

            this.watchdogTimer = setInterval(() => {
                const now = performance.now();
                const diff = now - this.lastAudioTick;

                // If no audio for 3+ seconds → restart mic & socket
                if (diff > 3000) {
                    console.warn("[Clients][startAudioWatchdog] Audio stalled - restarting pipeline.");
                    this.restartVoiceStream();
                }
            }, 1500);
        },
        stopAudioWatchdog() {
            if (this.watchdogTimer) {
                clearInterval(this.watchdogTimer);
                this.watchdogTimer = null;
            }
        },
        async restartVoiceStream() {
            console.warn("[Clients][restartVoiceStream] Restarting audio pipeline.");
            this.cleanupVoice(false);     // false = keep committed text
            await this.initMicPipeline(); // restart mic + processor
        },
        cleanupVoice(resetText = true) {
            this.voiceActive = false;
            this.stopAudioWatchdog();

            if (resetText) {
                this.voiceCommittedText = "";
                this.voiceCurrentTurn = "";
                this.note.description = "";
            }

            if (this.scriptNode) {
                this.scriptNode.disconnect();
                this.scriptNode = null;
            }

            if (this.audioContext) {
                this.audioContext.close().catch(() => {
                });
                this.audioContext = null;
            }

            if (this.mediaStream) {
                this.mediaStream.getTracks().forEach(t => t.stop());
                this.mediaStream = null;
            }

            if (this.voiceSocket &&
                (this.voiceSocket.readyState === WebSocket.OPEN ||
                    this.voiceSocket.readyState === WebSocket.CONNECTING)) {
                try {
                    this.voiceSocket.send("terminate");
                } catch (_) {
                    console.error("error")
                }
                this.voiceSocket.close();
            }

            this.voiceSocket = null;
        },
        async initMicPipeline() {
            console.log("[Clients][initMicPipeline] initMicPipeline start");

            try {
                // ---- 1) Request microphone ----
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: {
                        channelCount: 1,
                        noiseSuppression: true,
                        echoCancellation: true
                    }
                });
                console.log("[Clients][initMicPipeline] mic granted");

                this.mediaStream = stream;

                // Track microphone disconnect
                const track = stream.getAudioTracks()[0];
                track.onended = () => {
                    console.warn("[Clients][initMicPipeline] Microphone ended - recovering.");
                    this.restartVoiceStream();
                };

                // ---- 2) Create AudioContext ----
                const AC = window.AudioContext || window.webkitAudioContext;
                this.audioContext = new AC({sampleRate: 16000});
                await this.audioContext.resume();
                console.log("[Clients][initMicPipeline] audioContext created + resumed");

                // ---- 3) Create MediaStreamSource ----
                const source = this.audioContext.createMediaStreamSource(stream);
                console.log("[Clients][initMicPipeline] mediaStreamSource created");

                // ---- 4) Create ScriptProcessorNode ----
                const bufferSize = 4096;
                this.scriptNode = this.audioContext.createScriptProcessor(bufferSize, 1, 1);
                console.log("[Clients][initMicPipeline] scriptNode created");

                // ---- 5) Process audio ----
                this.scriptNode.onaudioprocess = (e) => {
                    console.log("[Clients][initMicPipeline] audio frame");

                    this.lastAudioTick = performance.now(); // watchdog

                    // Only send if socket is open
                    if (!this.voiceSocket || this.voiceSocket.readyState !== WebSocket.OPEN) {
                        return;
                    }

                    const floatData = e.inputBuffer.getChannelData(0);
                    const pcm16 = this.floatTo16BitPCM(floatData);
                    this.voiceSocket.send(pcm16.buffer);
                };

                // ---- 6) Connect nodes ----
                source.connect(this.scriptNode);
                this.scriptNode.connect(this.audioContext.destination);

                console.log("[Clients][initMicPipeline] mic pipeline READY");

            } catch (err) {
                console.error("[Clients][initMicPipeline] mic init failed:", err);
                this.voiceError = "Microphone access failed.";
                this.cleanupVoice();
            }
        },
        async startVoiceDescription() {
            if (this.voiceActive) return;

            this.voiceError = null;
            this.voiceCommittedText = "";
            this.voiceCurrentTurn = "";
            this.note.description = "";
            this.turnMemory = {};

            let wsUrl;

            if (window.location.hostname === "localhost") {
                wsUrl = `ws://${window.location.hostname}:8081/voice`;
            } else {
                if (window.location.protocol === "https:") {
                    wsUrl = `wss://${window.location.hostname}/voice`;
                } else {
                    wsUrl = `ws://${window.location.hostname}/voice`;
                }
            }

            this.voiceSocket = new WebSocket(wsUrl);
            this.voiceSocket.binaryType = "arraybuffer";

            this.voiceSocket.onopen = async () => {
                console.log("[Clients][startVoiceDescription][onopen] WS connected");
                await this.initMicPipeline();
                this.startAudioWatchdog();
                this.voiceActive = true;
            };

            this.voiceSocket.onclose = () => {
                console.warn("[Clients][startVoiceDescription][onclose] WS closed - recovering.");
                if (this.voiceActive) this.restartVoiceStream();
            };

            this.voiceSocket.onerror = () => {
                console.error("[Clients][startVoiceDescription][onerror] WS error");
                this.voiceError = "Voice connection error.";
                this.restartVoiceStream();
            };

            this.voiceSocket.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    console.log("[Clients][startVoiceDescription][onmessage] data = ", data);

                    const transcript = (data.transcript || "").trim();
                    if (!transcript) return;

                    // Not formatted → interim preview ("partial")
                    if (!data.turn_is_formatted) {
                        this.voiceCurrentTurn = transcript;
                        this.note.description =
                            (this.voiceCommittedText + " " + this.voiceCurrentTurn).trim();
                        return;
                    }

                    // Ignore duplicate finals
                    if (!this.turnMemory) this.turnMemory = {};
                    const turn = data.turn_order;
                    if (this.turnMemory[turn]) return;
                    this.turnMemory[turn] = true;

                    // Final sentence → commit permanently
                    this.voiceCommittedText =
                        (this.voiceCommittedText + " " + transcript).trim();

                    this.voiceCurrentTurn = "";
                    this.note.description = this.voiceCommittedText;

                } catch (e) {
                    console.error("[Clients][startVoiceDescription][onmessage] bad payload:", event.data);
                }
            };
        },
        stopVoiceDescription() {
            console.log("[Clients][stopVoiceDescription] Stopping voice description.");
            this.cleanupVoice(false);   // keep transcription text
        },
        openVideoWebSocket() {
            console.info("[Clients][openVideoWebSocket] Opening video webSocket...");

            let wsUrl;
            if (window.location.hostname === "localhost") {
                wsUrl = `ws://${window.location.hostname}:8081/video`;
            } else {
                if (window.location.protocol === "https:") {
                    wsUrl = `wss://${window.location.hostname}/video`;
                } else {
                    wsUrl = `ws://${window.location.hostname}/video`;
                }
            }

            this.videoSocket = new WebSocket(wsUrl);

            this.videoSocket.onopen = (e) => {
                console.info("[Clients][openVideoWebSocket][onopen] WebSocket open:", e);
                this.videoActive = true;
            }
            this.videoSocket.onmessage = (e) => {
                console.debug("[Clients][openVideoWebSocket][onmessage] WebSocket message:", e);

                const msg = JSON.parse(e.data);
                if (msg.sessionId) {
                    console.info("[Clients][openVideoWebSocket][onmessage] Storing sessionId", msg.sessionId);
                    this.note.videoSessionId = msg.sessionId;
                } else {
                    console.debug("Incoming: " + e.data);
                }
            }
            this.videoSocket.onclose = () => {
                console.info("[Clients][openVideoWebSocket][onclose] WebSocket closed");
                this.videoActive = false;
            }
            this.videoSocket.onerror = (err) => {
                console.error("[Clients][openVideoWebSocket][onerror] WebSocket error:", err);
                this.videoError = "Video connection error.";
            }

            console.info("[Clients][openVideoWebSocket] Opened video webSocket");
        },
        sendMediaData(contents, type, stopping) {
            console.debug("[Clients][sendMediaData] Sending media data...");

            if (this.videoSocket === undefined || this.videoSocket.readyState !== WebSocket.OPEN) {
                console.error("[Clients][sendMediaData] Web socket instance not found or not ready");
                this.newVideoRecorder.stopRecording();
                return;
            }

            console.debug("[Clients][sendMediaData] Outgoing: Type: " + type + " and length: " + contents.length + " state stopping:" + stopping);

            let messageObject = {
                type: type,
                stopping: stopping,
                contents: contents
            };
            this.videoSocket.send(JSON.stringify(messageObject));

            console.debug("[Clients][sendMediaData] Sent media data with type", type);
        },
        closeVideoWebSocket() {
            console.info("[Clients][closeVideoWebSocket] Closing video websocket...");

            if (this.videoSocket === undefined) {
                console.error("[Clients][closeVideoWebSocket] Web socket instance not found");
                return;
            }
            this.videoSocket.close();
            this.videoSocket = null;

            console.info("[Clients][closeVideoWebSocket] Closed video websocket");
        },
        async startVideoRecording() {
            console.log("[Clients][startVideoRecording] Starting video recording.");
            if (this.voiceActive) return;

            this.newVideoRecorder = new VideoRecorder('note-', this.openVideoWebSocket, this.sendMediaData, this.closeVideoWebSocket);
            if (this.videoSource === 'C') {
                this.newVideoRecorder.initUserMedia();
            } else if (this.videoSource === 'A') {
                this.newVideoRecorder.initUserMediaAudioOnly();
            } else {
                this.newVideoRecorder.initDisplayMedia();
            }

            console.info('[Clients][startVideoRecording] Created newVideoRecorder', this.newVideoRecorder);

            this.voiceError = null;
        },
        stopVideoRecording() {
            console.log("[Clients][stopVideoRecording] Stopping video recording.");
            this.newVideoRecorder.stopRecording();
        },
        async initNewImageEditor() {
            console.log("[Clients][initNewImageEditor] Init image editor.");
            this.newImageEditor.initImageEditor();

            if (this.note.data) {
                console.log("[Clients][initNewImageEditor] Loading canvas data.", this.note.data);
                this.newImageEditor.loadCanvas(this.note.data);
            }

            this.newImageEditorReady = true;
        },
        async initUpdateImageEditor() {
            console.log("[Clients][initUpdateImageEditor] Init image editor.");
            this.updateImageEditor.initImageEditor();

            if (this.note.data) {
                console.log("[Clients][initUpdateImageEditor] Loading canvas data.", this.note.data);
                this.updateImageEditor.loadCanvas(this.note.data);
            }

            this.updateImageEditorReady = true;
        },
        async initViewImageEditor() {
            console.log("[Clients][initViewImageEditor] Init image editor.");
            this.viewImageEditor.initImageEditor();

            if (this.note.data) {
                console.log("[Clients][initViewImageEditor] Loading canvas data.", this.note.data);
                this.viewImageEditor.loadCanvas(this.note.data);
            }

            this.viewImageEditorReady = true;
        },
        formatDate(inputDate) {

            if (!inputDate) {
                return "";
            }

            const converted = this.convertDateIntoLocalTimezone(inputDate);
            const date = new Date(converted);

            if (isNaN(date.getTime())) {
                return "";
            }

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            return formattedDate;
        },
        onPage(event) {
            console.log("[Clients][onPage] Page Event:", event);
            this.lazyParams.first = event.first;
            this.lazyParams.rows = event.rows;
            this.loadData();
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField;
            this.lazyParams.sortOrder = event.sortOrder;
            this.loadData();
        },
        onFilter(event) {
            this.lazyParams.filters = event.filters;
            this.loadData();
        },
        onSearch() {
            console.log("[Clients][onSearch] Searching with:", this.filters['global'].value);
            this.lazyParams.first = 0;
            this.loadData();
        },
        onToggleStandardFilters() {
            console.log("[Clients][onToggleStandardFilters] Applying Standard Filter:", this.selectedStandardFilter);
            this.lazyParams.first = 0;
            this.loadData();
        },
        clearFilter() {
            this.initFilters();
            console.log("🔄 Clearing search filters...");
            // this.filters['global'] = { value: '' }; // Reset global search
            this.lazyParams.filters = {}; // Clear all column filters
            this.lazyParams.first = 0; // Reset pagination to first page
            this.loadData();
        },
        async clearFilterForFiles() {
            this.initFilters();
            console.log("Clearing search filters...");

            this.activeTab = 28;
            this.submitted = true;

            try {
                const [clientFilesData] = await Promise.all([
                    StorageService.getCompanyStorageForClient(this.profile.companyId, this.client.id),
                ]);

                this.clientFiles = clientFilesData.data;
                console.log("[Clients][clearFilterForFiles] this.clientFiles = ", this.clientFiles);

                this.submitted = false;

            } catch (e) {
                console.error("[Clients][clearFilterForFiles] Error fetching additional data = ", e);
            }

            this.submitted = false;
            // this.filters['global'] = { value: '' }; // Reset global search
        },
        restoreToOriginal() {
            console.log("🔄 Restoring table to original view...");
            this.lazyParams = {
                first: 0,
                rows: 100,
                sortField: null,
                sortOrder: 1,
                filters: {...this.originalFilters}, // Restore saved filters
            };
            // this.clients = [...this.originalClients]; // Restore original data
            this.loadData();
            window.location.reload();
        },
        async initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'name': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'email': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'mobile': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }

            };

            this.filtersForFiles = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'simpleFilename': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        callReset() {
            this.activeTab = 1;
            this.selectedDigitalForm = null;
        },
        callResetProducts() {
            this.activeTab = 7;
        },
        callResetLabels() {
            this.activeTab = 113;
        },
        callResetProvisions() {
            this.activeTab = 32;
        },
        callResetNotes() {
            this.activeTab = 9;
        },
        callResetImportPayments() {
            this.activeTab = 40;
        },
        callResetTasks() {
            this.activeTab = 11;
        },
        callResetUploadClientFiles() {
            this.activeTab = 116;
        },
        async searchProcesses(event) {
            const [responseData] = await Promise.all([
                ProcessService.searchCompanyProcesses(this.profile.companyId, event.query.toLowerCase())
            ]);

            this.filteredProcesses = responseData.data;
        },
        async searchUsers() {
            const [responseData] = await Promise.all([
                UserService.getCompanyUsers(this.profile.companyId)
            ]);

            this.filteredUsers = responseData.data;
        },
        async searchClients(event) {
            const [responseData] = await Promise.all([
                ClientService.searchCompanyClients(this.profile.companyId, event.query.toLowerCase())
            ]);

            this.filteredClients = responseData.data;
        },
        async searchAffiliateClients(event) {
            console.log("[Clients][searchAffiliateClients] event = ", event);
            const [responseData] = await Promise.all([
                ClientService.searchCompanyAffiliateClients(this.profile.companyId, event.query.toLowerCase())
            ]);

            this.filteredAffiliateClients = responseData.data;
        },
        async searchCompanyPractitionersInternal(event) {
            console.log("[Clients][searchCompanyPractitionersInternal] event = ", event);

            const q = (event?.query ?? '').trim().toLowerCase();

            // If dropdown was clicked with an empty input, show all (or a cached subset)
            if (!q) {
                // Option A: use an already-fetched list
                this.filteredPractitioners = (this.filteredPractitioners ?? []).slice(0, 50); // cap if large
                return;
            }

            PractitionerService.searchAllCompanyPractitioners(this.profile.companyId, q, 'I')
                .then(data => {
                    console.log("[Clients][searchCompanyPractitionersInternal] Getting practitioner data for company = ", this.profile.companyId);
                    this.filteredPractitioners = data.data;
                    console.log("[Clients][searchCompanyPractitionersInternal] Got practitioner data = ", data.data);
                })
                .catch(e => {
                    console.log("[Clients][searchCompanyPractitionersInternal] Could not get practitioner data for company = ", this.profile.companyId);
                    console.log("[Clients][searchCompanyPractitionersInternal] Error = ", e);
                    this.filteredPractitioners = [];
                });

            console.log("[Clients][searchCompanyPractitionersInternal] this.filteredPractitioners = ", this.filteredPractitioners);
        },
        async searchCompanyPractitionersReferring(event) {
            console.log("[Clients][searchCompanyPractitionersReferring] event = ", event);

            const q = (event?.query ?? '').trim().toLowerCase();

            // If dropdown was clicked with an empty input, show all (or a cached subset)
            if (!q) {
                // Option A: use an already-fetched list
                this.filteredPractitionersReferring = (this.filteredPractitionersReferring ?? []).slice(0, 50); // cap if large
                return;
            }

            PractitionerService.searchAllCompanyPractitioners(this.profile.companyId, q, 'R')
                .then(data => {
                    console.log("[Clients][searchCompanyPractitionersReferring] Getting practitioner data for company = ", this.profile.companyId);
                    this.filteredPractitionersReferring = data.data;
                    console.log("[Clients][searchCompanyPractitionersReferring] Got practitioner data = ", data.data);
                })
                .catch(e => {
                    console.log("[Clients][searchCompanyPractitionersReferring] Could not get practitioner data for company = ", this.profile.companyId);
                    console.log("[Clients][searchCompanyPractitionersReferring] Error = ", e);
                    this.filteredPractitionersReferring = [];
                });

            console.log("[Clients][searchCompanyPractitionersReferring] this.filteredPractitionersReferring = ", this.filteredPractitionersReferring);
        },
        async searchPractitioners(event) {
            console.log("[Clients][searchPractitioners] event = ", event);

            const q = (event?.query ?? '').trim().toLowerCase();

            // If dropdown was clicked with an empty input, show all (or a cached subset)
            if (!q) {
                // Option A: use an already-fetched list
                this.filteredPractitioners = (this.filteredPractitioners ?? []).slice(0, 50); // cap if large
                return;
            }

            PractitionerService.searchCompanyPractitioners(this.profile.companyId, q)
                .then(data => {
                    console.log("[Clients][searchPractitioners] Getting practitioner data for company = ", this.profile.companyId);
                    this.filteredPractitioners = data.data;
                    console.log("[Clients][searchPractitioners] Got practitioner data = ", data.data);
                })
                .catch(e => {
                    console.log("[Clients][searchPractitioners] Could not get practitioner data for company = ", this.profile.companyId);
                    console.log("[Clients][searchPractitioners] Error = ", e);
                    this.filteredPractitioners = [];
                });

            console.log("[Clients][searchPractitioners] this.filteredPractitioners = ", this.filteredPractitioners);
        },
        async searchProducts(event) {

            const q = (event?.query ?? '').trim().toLowerCase();

            // If dropdown was clicked with an empty input, show all (or a cached subset)
            if (!q) {
                // Option A: use an already-fetched list
                this.filteredProducts = (this.products ?? []).slice(0, 50); // cap if large
                return;
            }

            ProductService.searchProducts(this.profile.companyId, q)
                .then(data => {
                    console.log("[Clients][searchProducts] Getting products for company = ", this.profile.companyId);
                    this.filteredProducts = data.data;
                    console.log("[Clients][searchProducts] Got products = ", data.data);
                })
                .catch(e => {
                    console.log("[Clients][searchProducts] Could not get products for company = ", this.profile.companyId);
                    console.log("[Clients][searchProducts] Error = ", e);
                    this.filteredProducts = [];
                });
        },
        async searchLabels(event) {

            const q = (event?.query ?? '').trim().toLowerCase();

            if (!q) {
                const existingLabelIds = new Set(
                    (this.allLabels || []).map(cl => Number(cl.labelId))
                );

                this.filteredLabels = (this.labels || [])
                    .filter(label => !existingLabelIds.has(Number(label.id)))
                    .slice(0, 50);

                return;
            }

            try {
                const response = await LabelService.searchCompanyLabels(this.profile.companyId, q);

                const existingLabelIds = new Set(
                    (this.clientLabels || []).map(cl => Number(cl.labelId))
                );

                this.filteredLabels = (response.data || []).filter(label =>
                    !existingLabelIds.has(Number(label.id))
                );

                console.log("[DEBUG] clientLabels =", this.clientLabels);
                console.log("[DEBUG] existing IDs =", (this.clientLabels || []).map(c => c.labelId));

            } catch (e) {
                this.filteredLabels = [];
            }
        },
        async searchProvisions(event) {

            const q = (event?.query ?? '').trim().toLowerCase();

            // If dropdown was clicked with an empty input, show all (or a cached subset)
            if (!q) {
                // Option A: use an already-fetched list
                this.filteredProvisions = (this.provisions ?? []).slice(0, 50); // cap if large
                return;
            }

            ProvisionService.getActiveProvisions(this.profile.companyId, q)
                .then(data => {
                    console.log("[Clients][searchProvisions] Getting provisions for company = ", this.profile.companyId);
                    this.filteredProvisions = data.data;
                    console.log("[Clients][searchProvisions] Got provisions = ", data.data);
                })
                .catch(e => {
                    console.log("[Clients][searchProvisions] Could not get provisions for company = ", this.profile.companyId);
                    console.log("[Clients][searchProvisions] Error = ", e);
                    this.filteredProvisions = [];
                });
        },
        async searchDigitalForms(event) {

            const q = (event?.query ?? '').trim().toLowerCase();

            if (!q) {
                this.filteredDigitalForms = (this.digitalForms ?? []).slice(0, 50); // cap if large
                return;
            }

            DigitalFormService.searchCompanyDigitalForms(this.profile.companyId, q)
                .then(data => {
                    console.log("[Clients][searchDigitalForms] Searching digital forms for company = ", this.profile.companyId);
                    this.filteredDigitalForms = data.data;
                    console.log("[Clients][searchDigitalForms] Got digital forms = ", data.data);
                })
                .catch(e => {
                    console.log("[Clients][searchDigitalForms] Could not search digital forms for company = ", this.profile.companyId);
                    console.log("[Clients][searchDigitalForms] Error = ", e);
                    this.filteredDigitalForms = [];
                });
        },
        async searchBillingPlan(event) {
            const q = (event?.query ?? '').trim().toLowerCase();

            // If dropdown was clicked with an empty input, show all (or a cached subset)
            if (!q) {
                // Option A: use an already-fetched list
                this.filteredBillingPlans = (this.billingPlans ?? []).slice(0, 50); // cap if large
                return;
            }

            BillingPlanService.searchBillingPlans(this.profile.companyId, q)
                .then(data => {
                    console.log("[Clients][searchBillingPlan] Getting billing plans for company = ", this.profile.companyId);
                    this.filteredBillingPlans = data.data;
                    console.log("[Clients][searchBillingPlan] Got billing plans = ", data.data);
                })
                .catch(e => {
                    console.log("[Clients][searchBillingPlan] Could not get billing plans for company = ", this.profile.companyId);
                    console.log("[Clients][searchBillingPlan] Error = ", e);
                    this.filteredBillingPlans = [];
                });
        },
        async searchProviders(event) {
            const [responseData] = await Promise.all([
                ProviderService.searchProvidersByName(event.query.toLowerCase())
            ]);

            this.filteredProviders = responseData.data;
        },
        async searchDiagnosticCodes(event) {
            const [responseData] = await Promise.all([
                this.icd10CodeService.getIcd10CodesSimple(event.query.toLowerCase())
            ]);

            this.filteredDiagnosticCodes = responseData.data;
        },
        callSetViewToBasic() {
            this.advancedView = false;
            this.activeTab = 1;
            this.filteredItemsCache.clear();
        },
        callSetViewToAdvanced() {
            this.advancedView = true;
            this.activeTab = 1;
            this.filteredItemsCache.clear();
        },
        callNewClient() {
            this.newClient = {};
            this.newClient.type = 'N';
            this.newClient.addressCountry = 'ZA';
            this.newClient.gender = 'F';
            this.newClient.commStatus = 'Y';
            this.newClient.taxRegistered = 'N';
            this.newClient.status = 'A';
            this.activeTab = 2;
        },
        callNewClientHealthInsurance() {
            this.newClient = {};
            this.clientConfiguration = {};
            this.newClient.type = 'N';
            this.newClient.addressCountry = 'ZA';
            this.newClient.gender = 'F';
            this.newClient.commStatus = 'Y';
            this.newClient.taxRegistered = 'N';
            this.newClient.status = 'A';
            this.activeTab = 33;
        },
        callMemberBenefitCheck() {
            this.clientConfiguration = {};
            this.activeTab = 34;
        },
        callBulkSms() {
            this.bulkSmsMessage = '';
            this.activeTab = 24;
            this.filteredItemsCache.clear();
        },
        async processBulkSms() {

            try {
                const [responseData] = await Promise.all([
                    ClientService.processBulkSms(this.profile.companyId, this.bulkSmsMessage)
                ]);

                console.log("[Clients][processBulkSms] responseData = ", responseData);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Processed Bulk SMS',
                    life: 3000
                });

            } catch (error) {
                console.error('[Clients][processBulkSms] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to send Bulk SMS. Please try again.',
                    life: 3000
                });
            }

            this.bulkSmsMessage = '';
            this.activeTab = 1;
            this.filteredItemsCache.clear();
        },
        callImportClientIntake() {
            this.activeTab = 26;
            this.inputFormat = '001';
        },
        callImportClients() {
            this.activeTab = 40;
            this.inputFormatImportClients = '001';
        },
        callResetImportClients() {
            this.activeTab = 1;
            this.fileClientImport = null;
            this.fileClientImport.value = null;
            this.inputFormatClientImport = '001';
        },
        callResetImportClientIntake() {
            this.activeTab = 1;
            this.file = null;
            this.file.value = null;
            this.inputFormat = '001';
        },
        handleFileUpload(event) {
            this.file = event.target.files[0];
        },
        handleFileUploadClientImport(event) {
            this.fileClientImport = event.target.files[0];
        },
        async submitFile() {
            this.submitted = true;

            if (!this.file) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });
            }

            console.log('[Clients][submitFile] this.inputFormat = ', this.inputFormat);

            const formData = new FormData();
            formData.append('file', this.file);

            var url = "/api/client1/import/clientintake/evexia/" + this.profile.companyId;

            if (this.inputFormat == "001") {
                url = "/api/client1/import/clientintake/evexia/" + this.profile.companyId;
            } else if (this.inputFormat == "002") {
                url = "/api/client1/import/clientintake/netcare/" + this.profile.companyId;
            }

            try {
                const response = await axios.post(url, formData, {
                    headers: {
                        'Authorization': `Bearer ${this.userStore.accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                console.log('[Clients][submitFile] Upload successful = ', response.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Imported client intake',
                    life: 3000
                });

                this.loadData();

                this.activeTab = 1;
            } catch (error) {
                console.error('Error uploading file:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Import of client intake NOT successful',
                    life: 3000
                });
            }

            this.file = null;
            this.submitted = false;
        },
        async submitFileClientImport() {
            this.submitted = true;

            if (!this.fileClientImport) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });
            }

            console.log('[Clients][submitFileClientImport] this.inputFormatClientImport = ', this.inputFormatClientImport);

            const formData = new FormData();
            formData.append('file', this.fileClientImport);

            var url = "/api/client1/upload/generic/clients/" + this.profile.companyId;

            if (this.inputFormatClientImport == "001") {
                url = "/api/client1/upload/generic/clients/" + this.profile.companyId;
            } else if (this.inputFormatClientImport == "002") {
                url = "/api/client1/upload/smemetrics/clients/" + this.profile.companyId;
            }

            try {
                const response = await axios.post(url, formData, {
                    headers: {
                        'Authorization': `Bearer ${this.userStore.accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                console.log('[Clients][submitFile] Upload successful = ', response.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Imported clients',
                    life: 3000
                });

                this.loadData();

                this.activeTab = 1;
            } catch (error) {
                console.error('Error uploading file:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Import of client intake NOT successful',
                    life: 3000
                });
            }

            this.file = null;
            this.submitted = false;
        },
        async callExportClients() {
            try {
                const [responseData] = await Promise.all([
                    ClientService.exportClientInfo(this.profile.companyId)
                ]);

                const url = window.URL.createObjectURL(new Blob([responseData.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'isoevolve-clients.csv');
                document.body.appendChild(link);
                link.click();

                // Clean up
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Exported client information',
                    life: 3000
                });

            } catch (error) {
                console.error('[ClientsNew][saveNewClient] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to export client information. Please try again.',
                    life: 3000
                });
            }
        },
        async callImportTemplate() {
            try {
                const [responseData] = await Promise.all([
                    ClientService.exportImportTemplate(this.profile.companyId)
                ]);

                const url = window.URL.createObjectURL(new Blob([responseData.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'isoevolve-import-template.csv');
                document.body.appendChild(link);
                link.click();

                // Clean up
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Exported import template',
                    life: 3000
                });

            } catch (error) {
                console.error('[ClientsNew][saveNewClient] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to export import template. Please try again.',
                    life: 3000
                });
            }
        },
        callHelp() {
            console.log('[ConfigurationBilling][callHelp] Start.');
        },
        callSupport() {
            console.log('[ConfigurationBilling][callSupport] Start.');
        },
        async callUpdateHealthcareClient(data) {
            this.activeTab = 3;
            this.client = data;
            // this.useExistingReferringPractitioner = 'Y';

            try {
                const [clientData, clientConfigData] = await Promise.all([
                    ClientService.getClient(this.client.id),
                    ClientService.getClientConfiguration(this.client.id)
                ]);

                this.client = clientData.data;
                console.log("[Clients][mounted] this.client = ", this.client);

                this.clientConfiguration = clientConfigData.data;
                console.log("[Clients][mounted] this.clientConfiguration = ", this.clientConfiguration);

                this.submitted = false;

            } catch (e) {
                console.error("[Clients][mounted] Error fetching additional data = ", e);
            }

        },
        async callViewUsers(data) {
            this.activeTab = 27;
            this.client = data;

            const [responseData] = await Promise.all([
                UserService.getClientUsers(this.client.companyId, this.client.email)
            ]);

            this.clientUser = responseData.data;

            console.log("[Clients][callViewUsers] this.clientUser = ", this.clientUser);

        },
        callUpdateClient(data) {
            this.activeTab = 4;
            this.client = data;
        },
        callDeleteClient() {
            this.activeTab = 407;
            this.confirmationResponse = 'N';
        },
        callDeleteLabel(data) {
            this.activeTab = 46;
            this.label = data;
            this.confirmationResponse = 'N';

            console.log("[Clients][callDeleteLabel] this.label = ", this.label);
        },
        async callViewProducts(data) {
            this.activeTab = 7;
            this.client = data;

            const [responseData] = await Promise.all([
                ClientProductService.getClientProducts(this.client.id)
            ]);

            this.clientProducts = responseData.data;
        },
        async callViewProvisions(data) {
            this.activeTab = 32;
            this.client = data;

            const [responseData] = await Promise.all([
                ClientProvisionService.getClientProvisions(this.client.id)
            ]);

            this.clientProvisions = responseData.data;
        },
        async callUpdateProduct(data) {
            this.activeTab = 18;
            this.product = data;
        },
        async callDeleteProduct(data) {
            this.activeTab = 19;
            this.product = data;
        },
        async callUpdateProvision(data) {
            this.activeTab = 36;
            this.provision = data;
        },
        async callDeleteProvision(data) {
            this.activeTab = 37;
            this.provision = data;
        },
        async callViewProvisionComponents(data) {
            this.activeTab = 38;
            this.clientProvision = data;

            console.log("[Clients][callViewProvisionComponents] this.clientProvision = ", this.clientProvision);

            const [provisionComponentData] = await Promise.all([
                ClientProvisionComponentService.getClientProvisionComponents(this.clientProvision.id)
            ]);

            this.clientProvisionComponents = provisionComponentData.data;

            console.log("[Clients][callViewProvisionComponents] this.clientProvisionComponents = ", this.clientProvisionComponents);
        },
        initBackgroundImageOptions() {
            StorageService.getCompanyStorage(this.profile.companyId).then((storageData) => {
                this.backgroundImageOptions = []
                for (const sr of storageData.data) {
                    if (sr.contentType !== 'image/png' && sr.contentType !== 'image/jpeg') {
                        continue;
                    }
                    let imageOption = {
                        id: sr.id,
                        name: sr.simpleFilename
                    };
                    this.backgroundImageOptions.push(imageOption);
                }
                console.info('Got background image options', this.backgroundImageOptions);
            });
        },
        async callAddNoteWithTemplate(data) {
            this.activeTab = 25;
            this.client = data;

            const noteTemplateData = await NoteTemplateService.getCompanyNoteTemplates(this.profile.companyId);
            this.noteTemplates = noteTemplateData.data;
        },
        async callViewNotes(data) {
            this.activeTab = 9;
            this.client = data;

            const [responseData] = await Promise.all([
                NoteService.getClientNotes(this.client.id)
            ]);

            this.notes = responseData.data;
            console.info("[Clients][callViewNotes] notes = ", this.notes);
        },
        async callViewNote(data) {
            this.activeTab = 20;
            this.note = data;

            this.viewImageEditor = new ImageEditor('view-', this.profile.companyId);
            this.viewImageEditorReady = false;
            this.backgroundImageOptions = []

            console.log("[Clients][callViewNote] this.note = ", this.note);

        },
        async callUpdateNote(data) {
            this.activeTab = 21;
            this.note = data;

            this.updateImageEditor = new ImageEditor('update-', this.profile.companyId);
            this.updateImageEditorReady = false;
            this.initBackgroundImageOptions();

            console.log("[Clients][callUpdateNote] this.note = ", this.note);

        },
        async callDeleteNote(data) {
            this.activeTab = 23;
            this.note = data;
        },
        async callViewTasks(data) {
            this.activeTab = 11;
            this.client = data;

            const [responseData] = await Promise.all([
                TaskService.getCompanyAndClientAllTasks(this.profile.companyId, this.client.id)
            ]);

            this.tasks = responseData.data;
        },
        async callViewTask(data) {
            this.activeTab = 22;
            this.task = data;
        },
        callSendStatement() {
            this.activeTab = 406;

            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(1, 'months');

            this.newStatement = {};
            this.newStatement.type = 'C';
            this.newStatement.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');
            this.newStatement.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');
        },
        async callManageClientFiles(data) {
            console.log("[Clients][callManageClientFiles] data = ", data);

            this.activeTab = 28;
            this.submitted = true;
            this.client = data;

            try {
                const [clientFilesData] = await Promise.all([
                    StorageService.getCompanyStorageForClient(this.profile.companyId, this.client.id),
                ]);

                this.clientFiles = clientFilesData.data;
                console.log("[Clients][callManageClientFiles] this.clientFiles = ", this.clientFiles);

                this.submitted = false;

            } catch (e) {
                console.error("[Clients][callManageClientFiles] Error fetching additional data = ", e);
            }

            this.submitted = false;

            console.log("[Clients][callManageClientFiles] this.client = ", this.client);
        },
        callUploadClientFile() {
            console.log("[Clients][callUploadClientFile] this.client = ", this.client);
            this.activeTab = 29;
            this.selectedClientFileType = 'C';
        },
        async callDeleteClientFile(data) {
            this.activeTab = 30;
            this.confirmationResponse = 'N';
            this.specificClientFile = data;
        },
        handleClientFileUpload(event) {
            const file = event.target.files[0];

            if (!file) {
                this.file = null;
                return;
            }

            const allowedTypes = [
                'application/pdf',
                'image/png',
                'image/jpeg'
            ];

            if (!allowedTypes.includes(file.type)) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Invalid file type',
                    detail: 'Only PDF, PNG, and JPG files are allowed.',
                    life: 3000
                });
                this.resetFileInput();
                return;
            }

            this.file = file;
        },
        resetClientFileInput() {
            this.file = null;
            this.$refs.fileInput.value = ''; // clears input element
        },
        async createClientHealthcareInsurance() {
            try {
                this.submitted = true;

                console.log('[Clients][createClientHealthcareInsurance] this.clientConfiguration = ', this.clientConfiguration);

                if (this.clientConfiguration.medicalName.id === null || this.clientConfiguration.medicalNumber === null) {

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create client. Invalid info submitted.',
                        life: 3000
                    });

                } else {
                    const response = await ClientService.createClientHealthcareInsurance(this.profile.companyId,
                        this.clientConfiguration.medicalName.id, this.clientConfiguration.medicalNumber);

                    console.log('[Clients][createClientHealthcareInsurance] Response = ', response);

                    this.loadData();
                    this.activeTab = 1;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Client successfully created',
                        life: 3000
                    });

                }

            } catch (e) {
                console.error('[ClientsNew][createClientHealthcareInsurance] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to create client. Please try again.',
                    life: 3000
                });

            } finally {
                this.newClient = {};
                this.clientConfiguration = {};
                this.activeTab = 1;
                this.submitted = false;
            }
        },
        async updateHealthcareInsuranceDetails() {
            try {
                this.submitted = true;

                console.log('[Clients][updateHealthcareInsuranceDetails] this.client = ', this.client);

                const response = await ClientService.updateHealthcareInsuranceDetails(this.profile.companyId, this.client.id);

                console.log('[Clients][updateHealthcareInsuranceDetails] Response = ', response);

                const [clientData, clientConfigData] = await Promise.all([
                    ClientService.getClient(this.client.id),
                    ClientService.getClientConfiguration(this.client.id)
                ]);

                this.client = clientData.data;
                console.log("[Clients][updateHealthcareInsuranceDetails] this.client = ", this.client);

                this.clientConfiguration = clientConfigData.data;
                console.log("[Clients][updateHealthcareInsuranceDetails] this.clientConfiguration = ", this.clientConfiguration);

                this.activeTab = null;
                await this.$nextTick();
                this.activeTab = 3;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Client successfully updated',
                    life: 3000
                });

            } catch (e) {
                console.error('[Clients][updateHealthcareInsuranceDetails] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update client. Please try again.',
                    life: 3000
                });

            } finally {
                this.activeTab = 3;
                this.submitted = false;
            }
        },
        async createMemberBenefitCheck() {
            try {
                this.submitted = true;

                console.log('[Clients][createMemberBenefitCheck] this.clientConfiguration = ', this.clientConfiguration);

                if (this.clientConfiguration.medicalName.id === null ||
                    this.clientConfiguration.billingPlan.id === null ||
                    this.clientConfiguration.medicalNumber === null) {

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create member benefit check. Invalid info submitted.',
                        life: 3000
                    });

                } else {
                    const response = await ClaimService.createUnlinkedClaimBenefitCheckByEdi(this.profile.companyId,
                        this.clientConfiguration.medicalName.id, this.clientConfiguration.billingPlan.id,
                        this.clientConfiguration.medicalNumber);

                    console.log('[Clients][createMemberBenefitCheck] Response = ', response);
                    this.clientConfiguration.responseCode = response.data.responseCode;
                    this.clientConfiguration.responseReference = response.data.responseReference;
                    this.clientConfiguration.responseDescription = response.data.responseDescription;

                    this.activeTab = 35;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Member benefit check successfully created',
                        life: 3000
                    });

                }

            } catch (e) {
                console.error('[ClientsNew][createMemberBenefitCheck] Error:', e);

                this.activeTab = 1;

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to create member benefit check. Please try again.',
                    life: 3000
                });

            } finally {
                this.submitted = false;
            }
        },
        async uploadClientFile() {
            this.submitted = true;

            if (!this.file) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });
            }

            // console.log('[OverviewFiles][uploadClientFile] this.selectedClientFileType = ', this.selectedClientFileType);

            console.log('[Clients][uploadClientFile] this.client = ', this.client);

            const formData = new FormData();
            formData.append('file', this.file);

            const originalName = this.file.name;
            const filenameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.')) || originalName;

            const storageRecord = {
                companyId: this.profile.companyId,
                clientId: this.client.id,
                noteId: null,
                taskId: null,
                type: 'C',
                provider: 'H',
                filename: filenameWithoutExt,
                contentType: this.file.type
            };

            // Append as a JSON string
            formData.append('storageRecord', new Blob([JSON.stringify(storageRecord)], {type: 'application/json'}));

            try {
                const response = await axios.post('/api/storage/hetzner/upload', formData, {
                    headers: {
                        'Authorization': 'Bearer ' + this.userStore.accessToken,
                        'Content-Type': 'multipart/form-data'
                    }
                });

                console.log('[Clients][uploadClientFile] Upload successful:', response.data);

                const [clientFilesData] = await Promise.all([
                    StorageService.getCompanyStorageForClient(this.profile.companyId, this.client.id),
                ]);

                this.clientFiles = clientFilesData.data;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'File uploaded successfully',
                    life: 3000
                });

            } catch (error) {
                console.error('Error uploading file:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Upload Failed',
                    detail: 'File upload NOT successful',
                    life: 3000
                });
            }

            this.resetClientFileInput();
            this.submitted = false;
            this.activeTab = 116;
        },
        async deleteClientFile() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.specificClientFile.id) {

                    try {

                        await StorageService.deleteCompanyStorage(this.specificClientFile.id);

                        const [clientFilesData] = await Promise.all([
                            StorageService.getCompanyStorageForClient(this.profile.companyId, this.client.id),
                        ]);

                        this.clientFiles = clientFilesData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted file',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[Clients][deleteFile] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete file. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 28;
            this.submitted = false;

        },
        async viewClientFile(data) {
            try {
                this.specificClientFile = data;

                const [response] = await Promise.all([
                    StorageService.downloadFile(this.profile.companyId, this.specificClientFile.id)
                ]);

                const blob = new Blob(
                    [response.data],
                    {type: this.specificClientFile.contentType}
                );

                const url = URL.createObjectURL(blob);
                window.open(url);

            } catch (error) {
                console.error('[Clients][viewClientFile] Error:', error);
            }
        },
        async downloadClientFile(data) {
            try {
                this.specificClientFile = data;

                const [responseData] = await Promise.all([
                    StorageService.downloadFile(this.profile.companyId, this.specificClientFile.id)
                ]);

                const url = window.URL.createObjectURL(new Blob([responseData.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.specificClientFile.simpleFilename);
                document.body.appendChild(link);
                link.click();

                // Clean up
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Downloaded file',
                    life: 3000
                });

            } catch (error) {
                console.error('[Clients][downloadClientFile] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to download file. Please try again.',
                    life: 3000
                });
            }
        },
        callSendEmail() {
            this.activeTab = 401;
        },
        callSendSms() {
            this.activeTab = 402;
        },
        callSendWhatsapp(data) {
            this.activeTab = 42;
            this.client = data;
        },
        callSendBookingLink() {
            this.activeTab = 403;
            this.confirmationResponse = 'N';
        },
        async callSendDigitalFormLink() {
            this.activeTab = 404;

            const digitalFormsData = await DigitalFormService.getDigitalForms(this.profile.companyId);
            this.digitalForms = digitalFormsData.data;
        },
        callCreateUnpaidNotice() {
            this.activeTab = 405;
            this.unpaid.unpaidType = 'G';
        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col =>
                value.some(selected => selected.field === col.field)
            );
        },
        getFilteredItems(data) {
            if (this.filteredItemsCache.has(data.id)) {
                return this.filteredItemsCache.get(data.id);
            }

            const items = [];

            if (this.advancedView) {

                if (this.companyConfiguration.type === 'H') {
                    items.push({
                        label: 'Update',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callUpdateHealthcareClient(data);
                        }
                    });
                } else {
                    items.push({
                        label: 'Update',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callUpdateClient(data);
                        }
                    });
                }

                items.push({
                    label: 'Delete',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callDeleteClient(data);
                    }
                });

                items.push({
                    label: 'Add Product',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callAddProduct(data);
                    }
                });

                items.push({
                    label: 'View Products',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callViewProducts(data);
                    }
                });

                items.push({
                    label: 'Add Provision',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callAddProvision(data);
                    }
                });

                items.push({
                    label: 'View Provisions',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callViewProvisions(data);
                    }
                });

                items.push({
                    label: 'Add Note (Blank)',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callAddNote(data);
                    }
                });

                items.push({
                    label: 'Add Note (Template)',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callAddNoteWithTemplate(data);
                    }
                });

                items.push({
                    label: 'View Notes',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callViewNotes(data);
                    }
                });

                if (!this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)) {
                    items.push({
                        label: 'Add Task',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callAddTask(data);
                        }
                    });

                    items.push({
                        label: 'View Tasks',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callViewTasks(data);
                        }
                    });
                }

                items.push({
                    label: 'Send Email',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callSendEmail(data);
                    }
                });

                items.push({
                    label: 'Send SMS',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callSendSms(data);
                    }
                });

                // items.push({
                //     label: 'Send WhatsApp',
                //     class: 'mb-4 mr-4 ml-4 mt-4',
                //     command: () => {
                //         this.callSendWhatsapp(data);
                //     }
                // });

                items.push({
                    label: 'Send Booking Link',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callSendBookingLink(data);
                    }
                });

                items.push({
                    label: 'Send Digital Form Link',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callSendDigitalFormLink(data);
                    }
                });

                items.push({
                    label: 'Add Audit Trail',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callAddAuditTrail(data);
                    }
                });

                items.push({
                    label: 'Create Unpaid Notice',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callCreateUnpaidNotice(data);
                    }
                });

                if (this.userConfiguration.enableInvoicing != 'N') {
                    items.push({
                        label: 'Create Invoice',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callCreateInvoice(data);
                        }
                    });
                }

                items.push({
                    label: 'Send Statement',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callSendStatement(data);
                    }
                });

                items.push({
                    label: 'Manage Files',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callManageClientFiles(data);
                    }
                });

                items.push({
                    label: 'Manage Labels',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callManageLabels(data);
                    }
                });

            } else {

                if (this.companyConfiguration.type === 'H') {
                    items.push({
                        label: 'Update',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callUpdateHealthcareClient(data);
                        }
                    });
                } else {
                    items.push({
                        label: 'Update',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callUpdateClient(data);
                        }
                    });
                }

                items.push({
                    label: 'Delete',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callDeleteClient(data);
                    }
                });

                items.push({
                    label: 'Add Note (Blank)',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callAddNote(data);
                    }
                });

                items.push({
                    label: 'Add Note (Template)',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callAddNoteWithTemplate(data);
                    }
                });

                items.push({
                    label: 'View Notes',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callViewNotes(data);
                    }
                });

                items.push({
                    label: 'Add Product',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callAddProduct(data);
                    }
                });

                if (!this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)) {
                    items.push({
                        label: 'Add Task',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callAddTask(data);
                        }
                    });

                    items.push({
                        label: 'View Tasks',
                        class: 'mb-4 mr-4 ml-4 mt-4',
                        command: () => {
                            this.callViewTasks(data);
                        }
                    });
                }

                if (!this.userStore.user.roles.includes('ROLE_ISORISE', 0)) {
                    if (this.userConfiguration.enableInvoicing != 'N') {
                        items.push({
                            label: 'Create Invoice',
                            class: 'mb-4 mr-4 ml-4 mt-4',
                            command: () => {
                                this.callCreateInvoice(data);
                            }
                        });
                    }
                }

                items.push({
                    label: 'Send Statement',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callSendStatement(data);
                    }
                });

                items.push({
                    label: 'Manage Files',
                    class: 'mb-4 mr-4 ml-4 mt-4',
                    command: () => {
                        this.callManageClientFiles(data);
                    }
                });

            }

            // console.log('[getFilteredItems] items = ', items);

            this.filteredItemsCache.set(data.id, items);

            return items;
        },
        getFilteredItemsNotes(data) {
            if (this.filteredItemsNotesCache.has(data.id)) {
                return this.filteredItemsNotesCache.get(data.id);
            }

            const items = [];

            items.push({
                label: 'View',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callViewNote(data);
                }
            });

            items.push({
                label: 'Update',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callUpdateNote(data);
                }
            });

            items.push({
                label: 'Delete',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callDeleteNote(data);
                }
            });

            console.log('[getFilteredItems] items = ', items);

            this.filteredItemsNotesCache.set(data.id, items);

            return items;
        },
        chooseBlankSelection(data) {
            console.log('[chooseBlankSelection] data = ', data);
            this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select a valid option.',
                life: 3000
            });
        },
        convertDateIntoUtcTimezone(inputDate) {
            console.log("[convertDateIntoUtcTimezone] inputDate :", inputDate);

            try {
                const moment = require("moment-timezone");

                let inputTimeZone = "Europe/London";

                if (this.clientConfiguration.region == "ZA") {
                    inputTimeZone = "Africa/Johannesburg";
                }

                const targetTimeZone = "Etc/UTC"; // Assuming the input date is in UTC

                console.log("[convertDateIntoUtcTimezone] inputTimeZone :", inputTimeZone);
                console.log("[convertDateIntoUtcTimezone] targetTimeZone :", targetTimeZone);

                // Parse the input date string and set the input time zone
                const parsedDate = moment.tz(inputDate, "YYYY-MM-DD HH:mm:ss", inputTimeZone);

                console.log("[convertDateIntoUtcTimezone] parsedDate :", parsedDate);

                // Convert the date to the target time zone
                const outputDate = parsedDate.clone().tz(targetTimeZone);

                console.log("[convertDateIntoUtcTimezone] Output Date :", outputDate.format("YYYY-MM-DD HH:mm:ss"));

                return outputDate.format("YYYY-MM-DD HH:mm:ss");

            } catch (error) {
                console.error("[convertDateIntoLocalTimezone] Could not convert date. Returning input date. Error :", error);

                return inputDate;
            }

        },
        convertDateIntoLocalTimezone(inputDate) {
            // console.log("[convertDateIntoLocalTimezone] inputDate :", inputDate);

            try {
                const moment = require("moment-timezone");
                const inputTimeZone = "Etc/UTC"; // Assuming the input date is in UTC

                let targetTimeZone = "Europe/London";

                if (this.clientConfiguration.region == "ZA") {
                    targetTimeZone = "Africa/Johannesburg";
                }

                // console.log("[convertDateIntoLocalTimezone] targetTimeZone :", targetTimeZone);

                // Parse the input date string and set the input time zone
                const parsedDate = moment.tz(inputDate, "YYYY-MM-DD HH:mm:ss", inputTimeZone);

                // console.log("[convertDateIntoLocalTimezone] parsedDate :", parsedDate);

                // Convert the date to the target time zone
                const outputDate = parsedDate.clone().tz(targetTimeZone);

                // console.log("[convertDateIntoLocalTimezone] Output Date :", outputDate.format("YYYY-MM-DD HH:mm:ss"));

                return outputDate.format("YYYY-MM-DD HH:mm:ss");

            } catch (error) {
                console.error("[convertDateIntoLocalTimezone] Could not convert date. Returning input date. Error :", error);

                return inputDate;
            }

        },
        formatTime(seconds) {
            const days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;

            const hours = Math.floor(seconds / 3600);
            seconds -= hours * 3600;

            const minutes = Math.floor(seconds / 60);
            seconds -= minutes * 60;

            let formattedTime = "";

            if (days > 0) {
                formattedTime += `${days} day${days > 1 ? 's' : ''} `;
            }

            if (hours > 0) {
                formattedTime += `${hours} hr${hours > 1 ? 's' : ''} `;
            }

            if (minutes > 0) {
                formattedTime += `${minutes} min${minutes > 1 ? 's' : ''} `;
            }

            // if (seconds > 0 || formattedTime === "") {
            //     formattedTime += `${seconds} sec${seconds !== 1 ? 's' : ''}`;
            // }

            return formattedTime;
        },
        async createClient() {

            try {
                this.submitted = true;

                if (this.newClient.type.trim()) {

                    console.log("[ClientsNew][saveNewClient] this.client = [", this.newClient);
                    console.log("[ClientsNew][saveNewClient] this.client.dob = ", this.newClient.dob);

                    var tempDob = null;

                    if (this.newClient.dob === undefined) {
                        console.log("[ClientsNew][saveNewClient] this.client.dob is NULL.");
                    } else {
                        console.log("[ClientsNew][saveNewClient] this.client.dob is NOT NULL.");
                        tempDob = moment(this.newClient.dob).format('YYYY-MM-DD')
                    }

                    console.log("[MsClients][saveNewClient] tempDob = ", tempDob);

                    var tempName = this.newClient.name;
                    if (this.newClient.type == 'N') {
                        tempName = this.newClient.firstName + " " + this.newClient.lastName;
                    }

                    var tempBillingClient = "";
                    try {
                        if (this.newClient.billingClientName === null || this.newClient.billingClientName.length === 0) {
                            console.log("[ClientsNew][saveNewClient] this.client.billingClientName is null.");
                            tempBillingClient = null;
                        } else {
                            console.log("[ClientsNew][saveNewClient] this.client.billingClientName is NOT null. this.newClient.billingClientName = ", this.newClient.billingClientName);
                            tempBillingClient = this.newClient.billingClientName.id;
                        }

                    } catch (error) {
                        tempBillingClient = null;
                    }

                    console.log("[ClientsNew][saveNewClient] tempBillingClient = ", tempBillingClient);

                    var tempAdminClient = "";

                    try {
                        if (this.newClient.adminClientName === null || this.newClient.adminClientName.length === 0) {
                            console.log("[ClientsNew][saveNewClient] this.newClient.adminClientName is null.");
                            tempAdminClient = null;
                        } else {
                            tempAdminClient = this.newClient.adminClientName.id;
                        }

                    } catch (error) {
                        tempAdminClient = null;
                    }

                    console.log("[ClientsNew][saveNewClient] tempAdminClient = ", tempAdminClient);

                    var tempFather = "";
                    try {
                        if (this.newClient.fatherName === null || this.newClient.fatherName.length === 0) {
                            console.log("[ClientsNew][saveNewClient] this.client.fatherName is null.");
                            tempFather = null;
                        } else {
                            console.log("[ClientsNew][saveNewClient] this.client.fatherName is NOT null. this.newClient.fatherName = ", this.newClient.fatherName);
                            tempFather = this.newClient.fatherName.id;
                        }

                    } catch (error) {
                        tempFather = null;
                    }

                    console.log("[ClientsNew][saveNewClient] tempFather = ", tempFather);


                    var tempMother = "";
                    try {
                        if (this.newClient.motherName === null || this.newClient.motherName.length === 0) {
                            console.log("[ClientsNew][saveNewClient] this.client.motherName is null.");
                            tempMother = null;
                        } else {
                            console.log("[ClientsNew][saveNewClient] this.client.motherName is NOT null. this.newClient.motherName = ", this.newClient.motherName);
                            tempMother = this.newClient.motherName.id;
                        }

                    } catch (error) {
                        tempMother = null;
                    }

                    console.log("[ClientsNew][saveNewClient] tempMother = ", tempMother);

                    var tempAffiliateClient = "";
                    try {
                        if (this.newClient.affiliateClientName === null || this.newClient.affiliateClientName.length === 0) {
                            console.log("[ClientsNew][saveNewClient] this.client.affiliateClientName is null.");
                            tempAffiliateClient = null;
                        } else {
                            console.log("[ClientsNew][saveNewClient] this.client.billingClientName is NOT null. this.newClient.billingClientName = ", this.newClient.billingClientName);
                            tempAffiliateClient = this.newClient.affiliateClientName.id;
                        }

                    } catch (error) {
                        tempAffiliateClient = null;
                    }

                    console.log("[ClientsNew][saveNewClient] this.newClient.affiliateClientName = ", this.newClient.affiliateClientName);
                    console.log("[ClientsNew][saveNewClient] tempAffiliateClient = ", tempAffiliateClient);

                    var tempPractitioner = "";
                    try {
                        if (this.newClient.practitionerName === null || this.newClient.practitionerName.length === 0) {
                            console.log("[ClientsNew][saveNewClient] this.client.practitionerName is null.");
                            tempPractitioner = null;
                        } else {
                            console.log("[ClientsNew][saveNewClient] this.client.practitionerName is NOT null. this.newClient.practitionerName = ", this.newClient.practitionerName);
                            tempPractitioner = this.newClient.practitionerName.id;
                        }

                    } catch (error) {
                        tempPractitioner = null;
                    }

                    console.log("[ClientsNew][saveNewClient] tempPractitioner = ", tempPractitioner);

                    var newClientDto = {
                        type: this.newClient.type,
                        name: tempName,
                        firstName: this.newClient.firstName,
                        lastName: this.newClient.lastName,
                        preferredName: this.newClient.preferredName,
                        idNumber: this.newClient.idNumber,
                        gender: this.newClient.gender,
                        genderOther: this.newClient.genderOther,
                        email: this.newClient.email,
                        alternateEmail: this.newClient.alternateEmail,
                        mobile: this.newClient.mobile,
                        address1: this.newClient.address1,
                        address2: this.newClient.address2,
                        addressRegion: this.newClient.addressRegion,
                        addressState: this.newClient.addressState,
                        addressCountry: this.newClient.addressCountry,
                        addressPostalCode: this.newClient.addressPostalCode,
                        taxRegistered: this.newClient.taxRegistered,
                        taxNumber: this.newClient.taxNumber,
                        commStatus: this.newClient.commStatus,
                        dob: tempDob,
                        fatherClientId: tempFather,
                        motherClientId: tempMother,
                        billingClientId: tempBillingClient,
                        adminClientId: tempAdminClient,
                        affiliateClientId: tempAffiliateClient,
                        practitionerId: tempPractitioner
                    };

                    console.log("[ClientsNew][saveNewClient] Before creating client back-end call. Data = ", newClientDto);

                    const response = await ClientService.createClient(this.profile.companyId, newClientDto);
                    console.log('[ClientsNew][saveNewClient] Response = ', response);

                    this.loadData();
                    this.activeTab = 1;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created client',
                        life: 3000
                    });

                }

            } catch (e) {
                console.error('[ClientsNew][saveNewClient] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to create client. Please try again.',
                    life: 3000
                });

            } finally {
                // this.resetSubmission();
                this.newClient = {};
                this.activeTab = 1;
                this.submitted = false;
            }

        },
        async updateHealthcareClient() {

            this.submitted = true;

            if (this.client.id) {

                try {

                    console.log("[Clients][updateHealthcareClient] this.client = [" + this.client + "].");
                    console.log("[Clients][updateHealthcareClient] this.clientConfiguration.useExistingReferringPractitioner = ",
                        this.clientConfiguration.useExistingReferringPractitioner);
                    console.log("[Clients][updateHealthcareClient] this.clientConfiguration.referringName = ",
                        this.clientConfiguration.referringName);

                    var tempName = this.client.name;
                    if ((this.client.type === 'N') || (this.client.type === 'M')) {
                        tempName = this.client.firstName + " " + this.client.lastName;
                    }

                    let tempBillingClient = null;

                    if (this.client.billingClientName) {
                        if (this.client?.billingClientName?.id) {
                            tempBillingClient = this.client.billingClientName.id;
                        } else {
                            tempBillingClient = -1;
                        }
                    } else {
                        tempBillingClient = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] this.client.billingClientName = ", this.client.billingClientName);
                    console.log("[Clients][updateHealthcareClient] tempBillingClient = ", tempBillingClient);

                    let tempAdminClient = null;

                    if (this.client.adminClientName) {
                        if (this.client?.adminClientName?.id) {
                            tempAdminClient = this.client.adminClientName.id;
                        } else {
                            tempAdminClient = -1;
                        }
                    } else {
                        tempAdminClient = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] this.client.adminClientName = ", this.client.adminClientName);
                    console.log("[Clients][updateHealthcareClient] tempAdminClient = ", tempAdminClient);

                    console.log("[Clients][updateHealthcareClient] ------- this.client.fatherName = [" + this.client.fatherName + "].");

                    let tempFather = null;

                    if (this.client.fatherName) {
                        if (this.client?.fatherName?.id) {
                            tempFather = this.client.fatherName.id;
                        } else {
                            tempFather = -1;
                        }
                    } else {
                        tempFather = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] ------- tempFather = [" + tempFather + "].");

                    let tempMother = null;

                    if (this.client.motherName) {
                        if (this.client?.motherName?.id) {
                            tempMother = this.client.motherName.id;
                        } else {
                            tempMother = -1;
                        }
                    } else {
                        tempMother = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] ------- tempMother = [" + tempMother + "].");


                    let tempAffiliateClient = null;

                    if (this.client.affiliateClientName) {
                        if (this.client?.affiliateClientName?.id) {
                            tempAffiliateClient = this.client.affiliateClientName.id;
                        } else {
                            tempAffiliateClient = -1;
                        }
                    } else {
                        tempAffiliateClient = -2;
                    }

                    var tempDob = null;

                    console.log("[Clients][updateHealthcareClient] this.client.dob = ", this.client.dob);

                    if ((this.client.dob === undefined) || (this.client.dob === null)) {
                        console.log("[Clients][updateHealthcareClient] this.client.dob is NULL.");
                    } else {
                        console.log("[Clients][updateHealthcareClient] this.client.dob is NOT NULL.");
                        tempDob = moment(this.client.dob).format('YYYY-MM-DD')
                    }

                    console.log("[Clients][updateHealthcareClient] tempDob = ", tempDob);

                    let tempPractitioner = null;

                    if (this.client.practitionerName) {
                        if (this.client?.practitionerName?.id) {
                            tempPractitioner = this.client.practitionerName.id;
                        } else {
                            tempPractitioner = -1;
                        }
                    } else {
                        tempPractitioner = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] ------- tempPractitioner = [" + tempPractitioner + "].");

                    var updateClientDto = {
                        id: this.client.id,
                        name: tempName,
                        type: this.client.type,
                        firstName: this.client.firstName,
                        lastName: this.client.lastName,
                        preferredName: this.client.preferredName,
                        idNumber: this.client.idNumber,
                        gender: this.client.gender,
                        genderOther: this.client.genderOther,
                        email: this.client.email,
                        alternateEmail: this.client.alternateEmail,
                        mobile: this.client.mobile,
                        address1: this.client.address1,
                        address2: this.client.address2,
                        addressRegion: this.client.addressRegion,
                        addressState: this.client.addressState,
                        addressCountry: this.client.addressCountry,
                        addressPostalCode: this.client.addressPostalCode,
                        taxRegistered: this.client.taxRegistered,
                        taxNumber: this.client.taxNumber,
                        commStatus: this.client.commStatus,
                        dob: tempDob,
                        status: this.client.status,
                        fatherClientId: tempFather,
                        motherClientId: tempMother,
                        billingClientId: tempBillingClient,
                        adminClientId: tempAdminClient,
                        affiliateClientId: tempAffiliateClient,
                        practitionerId: tempPractitioner
                    };

                    console.log("[Clients][updateHealthcareClient] Before update call and before cleanup. Data = ", updateClientDto);

                    const responseClientUpdate = await ClientService.updateClient(this.client.id, updateClientDto);
                    console.log('[Clients][updateHealthcareClient] responseClientUpdate = ', responseClientUpdate);

                    var tempDiagnosisCode1 = "";
                    var tempDiagnosisCode2 = "";
                    var tempDiagnosisCode3 = "";
                    var tempDiagnosisCode4 = "";
                    var tempDiagnosisCode5 = "";

                    console.log("[Clients][updateHealthcareClient] this.clientConfiguration = ", this.clientConfiguration);

                    if (this.clientConfiguration.diagnosisCode1 != null) {
                        if (this.clientConfiguration.diagnosisCode1.length > 1) {
                            tempDiagnosisCode1 = this.clientConfiguration.diagnosisCode1;
                        } else {
                            try {
                                tempDiagnosisCode1 = this.clientConfiguration.diagnosisCode1.icd10Code;
                            } catch (error) {
                                tempDiagnosisCode1 = this.clientConfiguration.diagnosisCode1;
                            }
                        }
                    }

                    if (this.clientConfiguration.diagnosisCode2 != null) {
                        if (this.clientConfiguration.diagnosisCode2.length > 1) {
                            tempDiagnosisCode2 = this.clientConfiguration.diagnosisCode2;
                        } else {
                            try {
                                tempDiagnosisCode2 = this.clientConfiguration.diagnosisCode2.icd10Code;
                            } catch (error) {
                                tempDiagnosisCode2 = this.clientConfiguration.diagnosisCode2;
                            }
                        }
                    }

                    if (this.clientConfiguration.diagnosisCode3 != null) {
                        if (this.clientConfiguration.diagnosisCode3.length > 1) {
                            tempDiagnosisCode3 = this.clientConfiguration.diagnosisCode3;
                        } else {

                            try {
                                tempDiagnosisCode3 = this.clientConfiguration.diagnosisCode3.icd10Code;
                            } catch (error) {
                                tempDiagnosisCode3 = this.clientConfiguration.diagnosisCode3;
                            }
                        }
                    }

                    if (this.clientConfiguration.diagnosisCode4 != null) {
                        if (this.clientConfiguration.diagnosisCode4.length > 1) {
                            tempDiagnosisCode4 = this.clientConfiguration.diagnosisCode4;
                        } else {

                            try {
                                tempDiagnosisCode4 = this.clientConfiguration.diagnosisCode4.icd10Code;
                            } catch (error) {
                                tempDiagnosisCode4 = this.clientConfiguration.diagnosisCode4;
                            }
                        }
                    }

                    if (this.clientConfiguration.diagnosisCode5 != null) {
                        if (this.clientConfiguration.diagnosisCode5.length > 1) {
                            tempDiagnosisCode5 = this.clientConfiguration.diagnosisCode5;
                        } else {

                            try {
                                tempDiagnosisCode5 = this.clientConfiguration.diagnosisCode5.icd10Code;
                            } catch (error) {
                                tempDiagnosisCode5 = this.clientConfiguration.diagnosisCode5;
                            }
                        }
                    }

                    console.log("[Clients][updateHealthcareClient] tempDiagnosisCode1 = ", tempDiagnosisCode1);
                    console.log("[Clients][updateHealthcareClient] tempDiagnosisCode2 = ", tempDiagnosisCode2);
                    console.log("[Clients][updateHealthcareClient] tempDiagnosisCode3 = ", tempDiagnosisCode3);
                    console.log("[Clients][updateHealthcareClient] tempDiagnosisCode4 = ", tempDiagnosisCode4);
                    console.log("[Clients][updateHealthcareClient] tempDiagnosisCode5 = ", tempDiagnosisCode5);

                    console.log("[Clients][updateHealthcareClient] this.clientConfiguration.medicalName = ", this.clientConfiguration.medicalName);

                    var tempProvider = "";

                    try {
                        tempProvider = this.clientConfiguration.medicalName.id;
                    } catch (error) {
                        tempProvider = "";
                    }

                    console.log("[Clients][updateHealthcareClient] tempProvider = ", tempProvider);

                    console.log("[Clients][updateHealthcareClient] this.clientConfiguration.referringName = ",
                        this.clientConfiguration.referringName);

                    let tempReferringPractitioner = null;

                    if (this.clientConfiguration.referringName) {
                        if (this.clientConfiguration?.referringName?.id) {
                            tempReferringPractitioner = this.clientConfiguration.referringName.id;
                        } else {
                            tempReferringPractitioner = -1;
                        }
                    } else {
                        tempReferringPractitioner = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] tempReferringPractitioner = ", tempReferringPractitioner);

                    var updatedConfiguration = {
                        type: 'H',
                        diagnosisCode1: tempDiagnosisCode1,
                        diagnosisCode2: tempDiagnosisCode2,
                        diagnosisCode3: tempDiagnosisCode3,
                        diagnosisCode4: tempDiagnosisCode4,
                        diagnosisCode5: tempDiagnosisCode5,
                        providerId: tempProvider,
                        // medicalName: this.clientConfiguration.medicalName,
                        medicalNumber: this.clientConfiguration.medicalNumber,
                        medicalPlan: this.clientConfiguration.medicalPlan,
                        medicalMemberFirstname: this.clientConfiguration.medicalMemberFirstname,
                        medicalMemberLastname: this.clientConfiguration.medicalMemberLastname,
                        medicalMemberInitials: this.clientConfiguration.medicalMemberInitials,
                        medicalMemberId: this.clientConfiguration.medicalMemberId,
                        medicalMemberCode: this.clientConfiguration.medicalMemberCode,
                        medicalDependantFirstname: this.clientConfiguration.medicalDependantFirstname,
                        medicalDependantLastname: this.clientConfiguration.medicalDependantLastname,
                        medicalDependantInitials: this.clientConfiguration.medicalDependantInitials,
                        medicalDependantId: this.clientConfiguration.medicalDependantId,
                        medicalDependantCode: this.clientConfiguration.medicalDependantCode,
                        claimPreference: this.clientConfiguration.claimPreference,
                        referringFirstname: this.clientConfiguration.referringFirstname,
                        referringLastname: this.clientConfiguration.referringLastname,
                        referringEmail: this.clientConfiguration.referringEmail,
                        referringMobile: this.clientConfiguration.referringMobile,
                        referringRegistrationNumber: this.clientConfiguration.referringRegistrationNumber,
                        referringPracticeNumber: this.clientConfiguration.referringPracticeNumber,
                        referringQualification: this.clientConfiguration.referringQualification,
                        referringType: this.clientConfiguration.referringType,
                        rafLinkNumber: this.clientConfiguration.rafLinkNumber,
                        authorisation: this.clientConfiguration.authorisation,
                        inHospital: this.clientConfiguration.inHospital,
                        pmb: this.clientConfiguration.pmb,
                        useExistingReferringPractitioner: this.clientConfiguration.useExistingReferringPractitioner,
                        referringPractitionerId: tempReferringPractitioner
                    };

                    console.log("[Clients][updateHealthcareClient] Before update call. Data = ", updatedConfiguration);

                    const response = await ClientService.updateClientConfiguration(this.client.id, updatedConfiguration);
                    console.log('[Clients][updateHealthcareClient] Response = ', response);

                    this.loadData();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[Clients][updateHealthcareClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async updateClient() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    var tempName = this.client.name;
                    if (this.client.type == 'N') {
                        tempName = this.client.firstName + " " + this.client.lastName;
                    }

                    let tempBillingClient = null;

                    if (this.client.billingClientName) {
                        if (this.client?.billingClientName?.id) {
                            tempBillingClient = this.client.billingClientName.id;
                        } else {
                            tempBillingClient = -1;
                        }
                    } else {
                        tempBillingClient = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] this.client.billingClientName = ", this.client.billingClientName);
                    console.log("[Clients][updateHealthcareClient] tempBillingClient = ", tempBillingClient);

                    let tempAdminClient = null;

                    if (this.client.adminClientName) {
                        if (this.client?.adminClientName?.id) {
                            tempAdminClient = this.client.adminClientName.id;
                        } else {
                            tempAdminClient = -1;
                        }
                    } else {
                        tempAdminClient = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] this.client.adminClientName = ", this.client.adminClientName);
                    console.log("[Clients][updateHealthcareClient] tempAdminClient = ", tempAdminClient);

                    console.log("[Clients][updateHealthcareClient] ------- this.client.fatherName = [" + this.client.fatherName + "].");

                    let tempFather = null;

                    if (this.client.fatherName) {
                        if (this.client?.fatherName?.id) {
                            tempFather = this.client.fatherName.id;
                        } else {
                            tempFather = -1;
                        }
                    } else {
                        tempFather = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] ------- tempFather = [" + tempFather + "].");

                    let tempMother = null;

                    if (this.client.motherName) {
                        if (this.client?.motherName?.id) {
                            tempMother = this.client.motherName.id;
                        } else {
                            tempMother = -1;
                        }
                    } else {
                        tempMother = -2;
                    }

                    console.log("[Clients][updateHealthcareClient] ------- tempMother = [" + tempMother + "].");


                    let tempAffiliateClient = null;

                    if (this.client.affiliateClientName) {
                        if (this.client?.affiliateClientName?.id) {
                            tempAffiliateClient = this.client.affiliateClientName.id;
                        } else {
                            tempAffiliateClient = -1;
                        }
                    } else {
                        tempAffiliateClient = -2;
                    }

                    var tempDob = null;

                    console.log("[Clients][updateClient] this.client.dob = ", this.client.dob);

                    if ((this.client.dob === undefined) || (this.client.dob === null)) {
                        console.log("[Clients][updateClient] this.client.dob is NULL.");
                    } else {
                        console.log("[Clients][updateClient] this.client.dob is NOT NULL.");
                        tempDob = moment(this.client.dob).format('YYYY-MM-DD')
                    }

                    console.log("[Clients][updateClient] tempDob = ", tempDob);

                    var updateClientDto = {
                        id: this.client.id,
                        name: tempName,
                        type: this.client.type,
                        firstName: this.client.firstName,
                        lastName: this.client.lastName,
                        preferredName: this.client.preferredName,
                        idNumber: this.client.idNumber,
                        gender: this.client.gender,
                        genderOther: this.client.genderOther,
                        email: this.client.email,
                        alternateEmail: this.client.alternateEmail,
                        mobile: this.client.mobile,
                        address1: this.client.address1,
                        address2: this.client.address2,
                        addressRegion: this.client.addressRegion,
                        addressState: this.client.addressState,
                        addressCountry: this.client.addressCountry,
                        addressPostalCode: this.client.addressPostalCode,
                        taxRegistered: this.client.taxRegistered,
                        taxNumber: this.client.taxNumber,
                        commStatus: this.client.commStatus,
                        dob: tempDob,
                        status: this.client.status,
                        fatherClientId: tempFather,
                        motherClientId: tempMother,
                        billingClientId: tempBillingClient,
                        adminClientId: tempAdminClient,
                        affiliateClientId: tempAffiliateClient
                    };

                    console.log("[Clients][updateClient] Before update call and before cleanup. Data = ", updateClientDto);

                    updateClientDto = Object.fromEntries(
                        Object.entries(updateClientDto).filter(([, value]) => value !== undefined && value !== null)
                    );

                    console.log("[Clients][updateClient] Before update call and after cleanup. Data = ", updateClientDto);

                    const response = await ClientService.updateClient(this.client.id, updateClientDto);
                    console.log('[Clients][updateClient] Response = ', response);

                    this.loadData();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[Clients][updateClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async deleteClient() {
            this.submitted = true;

            console.log('[ClientDetail][deleteClient] this.client = ', this.client);
            console.log('[ClientDetail][deleteClient] this.confirmationResponse = ', this.confirmationResponse);

            if (this.confirmationResponse.trim() === "Y") {

                if (this.client.id) {

                    try {

                        const response = await ClientService.deleteClient(this.client.id);
                        console.log('[ClientDetail][deleteClient] Response = ', response);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted client',
                            life: 3000
                        });

                        this.safeNavigate('/commonClients');

                    } catch (error) {
                        console.error('[ClientDetail][deleteClient] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete client. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        async addProduct() {
            this.submitted = true;

            if (this.client.id) {

                try {
                    var tempProduct = "";

                    try {
                        tempProduct = this.selectedProduct.product.id;
                    } catch (error) {
                        tempProduct = "";
                    }

                    console.log("[" + name + "][submitToolboxAddProduct] tempProduct = ", tempProduct);

                    const response = await ClientProductService.createProductForClient(this.client.id, tempProduct);
                    console.log('[ClientsNew][saveNewClient] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Added product for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientsNew][saveNewClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add product for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async addLabel() {
            this.submitted = true;

            console.log("[Clients][addLabel] this.client = ", this.client);
            console.log("[Clients][addLabel] this.selectedLabel = ", this.selectedLabel);

            if (this.client.id) {

                try {
                    var tempLabel = "";

                    try {
                        tempLabel = this.selectedLabel.label.id;
                    } catch (error) {
                        tempLabel = "";
                    }

                    console.log("[Clients][addLabel] tempLabel = ", tempLabel);

                    const response = await ClientLabelService.createLabelForClient(this.client.id, tempLabel);
                    console.log('[Clients][addLabel] Response = ', response);

                    const [responseData] = await Promise.all([
                        ClientLabelService.getClientLabels(this.client.id)
                    ]);

                    this.clientLabels = responseData.data;

                    this.loadData();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Added label for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[Clients][addLabel] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add label for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 113;
            this.submitted = false;

        },
        async addProvision() {
            this.submitted = true;

            if (this.client.id) {

                try {
                    console.log("[Client][addProvision] this.selectedProvision = ", this.selectedProvision);

                    var tempProvision = "";

                    try {
                        tempProvision = this.selectedProvision.provision.id;
                    } catch (error) {
                        tempProvision = "";
                    }

                    console.log("[Client][addProvision] tempProvision = ", tempProvision);

                    const response = await ClientProvisionService.createProvisionForClient(this.client.id, tempProvision);
                    console.log('[Client][addProvision] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Added provision for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[Client][addProvision] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add provision for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async updateProduct() {
            this.submitted = true;

            if (this.product.id) {

                try {

                    var tempBillingPlan = "";

                    try {
                        tempBillingPlan = this.product.billingPlanName.id;
                    } catch (error) {
                        tempBillingPlan = "";
                    }

                    console.log("[" + name + "][processEditClientProduct] Before creating product back-end call. tempBillingPlan = ", tempBillingPlan);

                    var tempInception = null;

                    if ((this.product.inception === undefined) || (this.product.inception === null)) {
                        console.log("[PmClients][saveNewClient] this.product.inception is NULL.");
                    } else {
                        console.log("[PmClients][saveNewClient] this.product.inception is NOT NULL.");
                        tempInception = moment(this.product.inception).format('YYYY-MM-DD');
                    }

                    console.log("[PmClients][saveNewClient] this.product.inception = ", this.product.inception);
                    console.log("[PmClients][saveNewClient] tempInception = ", tempInception);

                    var tempTermination = null;

                    if ((this.product.termination === undefined) || (this.product.termination === null)) {
                        console.log("[PmClients][saveNewClient] this.product.termination is NULL.");
                    } else {
                        console.log("[PmClients][saveNewClient] this.product.termination is NOT NULL.");
                        tempTermination = moment(this.product.termination).format('YYYY-MM-DD');
                    }

                    console.log("[PmClients][saveNewClient] this.product.termination = ", this.product.termination);
                    console.log("[PmClients][saveNewClient] tempTermination = ", tempTermination);

                    var newProductDto = {
                        name: this.product.name,
                        description: this.product.description,
                        uniqueId: this.product.uniqueId,
                        premium: this.product.premium,
                        value: this.product.value,
                        billingPlanId: tempBillingPlan,
                        inception: tempInception,
                        termination: tempTermination,
                        status: this.product.status
                    };

                    console.log("[" + name + "][processEditClientProduct] Before creating product back-end call. newProductDto = ", newProductDto);

                    const response = await ClientProductService.updateSpecificProductForClient(this.product.id, newProductDto);
                    console.log('[ClientsNew][saveNewClient] Response = ', response);

                    const [responseData] = await Promise.all([
                        ClientProductService.getClientProducts(this.client.id)
                    ]);

                    this.clientProducts = responseData.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated product for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientsNew][saveNewClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update product for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 7;
            this.submitted = false;

        },
        async deleteProduct() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.product.id) {

                    console.log("[" + name + "][processDeleteClientProduct] this.product.id = ", this.product.id);

                    try {

                        const response = await ClientProductService.deleteSpecificProductForClient(this.product.id);
                        console.log('[ClientsNew][saveNewClient] Response = ', response);

                        const [responseData] = await Promise.all([
                            ClientProductService.getClientProducts(this.client.id)
                        ]);

                        this.clientProducts = responseData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted product for client',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[ClientsNew][saveNewClient] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete product for client. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 7;
            this.submitted = false;

        },
        async deleteLabel() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.label.id) {

                    console.log("[Clients][deleteLabel] this.label.id = ", this.label.id);

                    try {

                        const response = await ClientLabelService.deleteSpecificLabelForClient(this.label.id);
                        console.log('[Clients][deleteLabel] Response = ', response);

                        const [responseData] = await Promise.all([
                            ClientLabelService.getClientLabels(this.client.id)
                        ]);

                        this.clientLabels = responseData.data;

                        this.loadData();

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted label for client',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[Clients][deleteLabel] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete label for client. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 113;
            this.submitted = false;

        },
        async updateProvision() {
            this.submitted = true;

            if (this.provision.id) {

                try {

                    var tempBillingPlan = "";

                    try {
                        tempBillingPlan = this.provision.billingPlanName.id;
                    } catch (error) {
                        tempBillingPlan = "";
                    }

                    console.log("[Clients][updateProvision] Before creating product back-end call. tempBillingPlan = ", tempBillingPlan);

                    var newProvisionDto = {
                        name: this.provision.name,
                        description: this.provision.description,
                        billingPlanId: tempBillingPlan,
                        status: this.provision.status
                    };

                    console.log("[Clients][updateProvision] Before creating provision back-end call. newProvisionDto = ", newProvisionDto);

                    const response = await ClientProvisionService.updateSpecificProvisionForClient(this.provision.id, newProvisionDto);
                    console.log('[Clients][updateProvision] Response = ', response);

                    const [responseData] = await Promise.all([
                        ClientProvisionService.getClientProvisions(this.client.id)
                    ]);

                    this.clientProvisions = responseData.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated provision for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientsNew][saveNewClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update provision for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 32;
            this.submitted = false;

        },
        async deleteProvision() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.provision.id) {

                    console.log("[" + name + "][processDeleteClientProduct] this.provision.id = ", this.provision.id);

                    try {

                        const response = await ClientProvisionService.deleteSpecificProvisionForClient(this.provision.id);
                        console.log('[ClientsNew][saveNewClient] Response = ', response);

                        const [responseData] = await Promise.all([
                            ClientProvisionService.getClientProvisions(this.client.id)
                        ]);

                        this.clientProvisions = responseData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted provision for client',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[ClientsNew][saveNewClient] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete provision for client. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 32;
            this.submitted = false;

        },
        async addNote() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    console.log("[Clients][addNote] this.note.subject = ", this.note.subject);
                    console.log("[Clients][addNote] this.note.description = ", this.note.description);

                    // Optional
                    let videoSessionId = '';
                    if (this.note.videoSessionId) {
                        console.log("[Clients][addNote] this.note.videoSessionId = ", this.note.videoSessionId);
                        videoSessionId = this.note.videoSessionId;
                    }

                    // Optional
                    let data = {jsonData: '', imageData: ''};
                    if (this.note.format === 'C' && this.newImageEditorReady) {
                        data = this.newImageEditor.saveCanvas();
                        console.log("[Clients][addNote] Using saved canvas json data = ", data);
                    }

                    var newNoteDto = {
                        subject: this.note.subject,
                        description: this.note.description,
                        data: data.jsonData,
                        mediaData: data.imageData,
                        type: this.note.type,
                        format: this.note.format,
                        videoSessionId: videoSessionId,
                        sharable: this.note.sharable,
                        editable: this.note.editable
                    };

                    console.log("[" + name + "][processCreateClientNote] newNoteDto = ", newNoteDto);

                    const response = await NoteService.createClientNote(this.client.id, newNoteDto);
                    console.log('[ClientsNew][saveNewClient] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Added note for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientsNew][saveNewClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add note for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async updateNote() {
            this.submitted = true;

            if (this.note.id) {

                try {
                    console.log("[" + name + "][processEditClientNote] this.note.id = ", this.note.id);

                    // Optional
                    let data = {jsonData: '', imageData: ''};
                    if (this.note.format === 'C' && this.updateImageEditorReady) {
                        data = this.updateImageEditor.saveCanvas();
                        console.log("[Clients][updateNote] Using saved canvas json data = ", data);
                    }

                    var newNoteDto = {
                        subject: this.note.subject,
                        description: this.note.description,
                        data: data.jsonData,
                        mediaData: data.imageData,
                        type: this.note.type,
                        sharable: this.note.sharable,
                        editable: this.note.editable,
                        status: this.note.status
                    };

                    console.log("[" + name + "][processEditClientNote] newNoteDto = ", newNoteDto);

                    const response = await NoteService.updateClientNote(this.note.id, newNoteDto);
                    console.log('[ClientsNew][saveNewClient] Response = ', response);

                    const [responseData] = await Promise.all([
                        NoteService.getClientNotes(this.client.id)
                    ]);

                    this.notes = responseData.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated note for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientsNew][saveNewClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update note for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 9;
            this.submitted = false;

        },
        async deleteNote() {
            this.submitted = true;

            if (this.note.id) {

                try {
                    console.log("[" + name + "][processEditClientNote] this.note.id = ", this.note.id);

                    const response = await NoteService.deleteNote(this.note.id);
                    console.log('[ClientsNew][saveNewClient] Response = ', response);

                    const [responseData] = await Promise.all([
                        NoteService.getClientNotes(this.client.id)
                    ]);

                    this.notes = responseData.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Deleted note for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientsNew][saveNewClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete note for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 9;
            this.submitted = false;

        },
        async addNoteWithTemplate() {
            this.submitted = true;

            if (this.client.id) {

                try {
                    console.log("[Clients][addNoteWithTemplate] this.client = ", this.client);
                    console.log("[Clients][addNoteWithTemplate] this.noteTemplateId = ", this.noteTemplateId);

                    const response = await NoteService.createClientNoteWithTemplate(this.client.id, this.noteTemplateId);
                    console.log('[Clients][addNoteWithTemplate] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Added note for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[Clients][addNoteWithTemplate] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add note for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async addTask() {
            this.submitted = true;

            if (this.client.id) {

                if (this.newTask.description) {
                    try {

                        var tempProcess = "";
                        var tempUser = "";

                        try {
                            tempProcess = this.newTask.process.id;
                        } catch (error) {
                            tempProcess = "";
                        }

                        try {
                            tempUser = this.newTask.user.id;
                        } catch (error) {
                            tempUser = "";
                        }

                        var newTaskDto = {
                            companyId: this.profile.companyId,
                            processId: tempProcess,
                            userId: tempUser,
                            clientId: this.client.id,
                            description: this.newTask.description,
                            note: this.newTask.note,
                            type: this.newTask.type,
                            clientVisible: this.newTask.clientVisible
                        };

                        console.log("[" + name + "][saveNewTask] newTaskDto = ", newTaskDto);

                        const response = await TaskService.createTask(this.profile.companyId, newTaskDto);
                        console.log('[ClientsNew][saveNewClient] Response = ', response);

                        const [responseData] = await Promise.all([
                            TaskService.getCompanyAndClientAllTasks(this.profile.companyId, this.client.id)
                        ]);

                        this.tasks = responseData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Added task',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[ClientsNew][saveNewClient] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to add task. Please try again.',
                            life: 3000
                        });
                    }
                }

            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async emailStatement() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    const startDateInput = new Date(this.convertDateIntoLocalTimezone(this.newStatement.startDate));
                    const yearStart = startDateInput.getFullYear();
                    const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
                    const dayStart = String(startDateInput.getDate()).padStart(2, '0');
                    const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

                    const endDateInput = new Date(this.convertDateIntoLocalTimezone(this.newStatement.endDate));
                    const yearEnd = endDateInput.getFullYear();
                    const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
                    const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
                    const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

                    console.log("[ClientDetail][emailStatement] startDate = ", startDate);
                    console.log("[ClientDetail][emailStatement] endDate = ", endDate);

                    const response = await ClientService.emailStatement(
                        this.client.id, this.newStatement.type, startDate, endDate);

                    console.log('[ClientDetail][emailStatement] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Emailed statement',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientDetail][emailStatement] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to email statement. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        async downloadStatement() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    const startDateInput = new Date(this.convertDateIntoLocalTimezone(this.newStatement.startDate));
                    const yearStart = startDateInput.getFullYear();
                    const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
                    const dayStart = String(startDateInput.getDate()).padStart(2, '0');
                    const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

                    const endDateInput = new Date(this.convertDateIntoLocalTimezone(this.newStatement.endDate));
                    const yearEnd = endDateInput.getFullYear();
                    const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
                    const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
                    const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

                    console.log("[ClientDetail][downloadStatement] startDate = ", startDate);
                    console.log("[ClientDetail][downloadStatement] endDate = ", endDate);

                    const response = await ClientService.downloadStatement(
                        this.client.id, this.newStatement.type, startDate, endDate);

                    console.log('[ClientDetail][downloadStatement] Response = ', response);

                    const blob = new Blob([response.data], {type: 'application/pdf'});

                    // Create a link element and simulate a click to trigger the download
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.client.id + '.statement.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Downloaded statement',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientDetail][downloadStatement] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to download statement. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        async sendEmail() {
            console.log("[ClientDetail][sendEmail] this.client = ", this.client);

            this.submitted = true;

            if (this.client.id) {

                try {

                    var emailDto = {
                        companyId: this.profile.companyId,
                        userId: this.userStore.user.id,
                        emailSubject: this.email.emailSubject,
                        emailMessage: this.email.emailMessage
                    };

                    console.log("[ClientDetail][sendEmail] emailDto = ", emailDto);

                    const response = await ClientService.sendClientEmail(this.client.id, emailDto);
                    console.log('[ClientDetail][sendEmail] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Sent email',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientDetail][sendEmail] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send email. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        async sendSms() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    var smsDto = {
                        companyId: this.profile.companyId,
                        userId: this.userStore.user.id,
                        smsMessage: this.sms.smsMessage,
                    };

                    console.log("[ClientDetail][sendSms] smsDto = ", smsDto);

                    const response = await ClientService.sendClientSms(this.client.id, smsDto);
                    console.log('[ClientDetail][sendSms] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Sent SMS',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientDetail][sendSms] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send SMS. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        async sendWhatsapp() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    var smsDto = {
                        companyId: this.profile.companyId,
                        userId: this.userStore.user.id,
                        smsMessage: this.sms.smsMessage,
                    };

                    console.log("[PmClients][submitToolboxSms] smsDto = ", smsDto);

                    const response = await ClientService.sendClientWhatsapp(this.client.id, smsDto);
                    console.log('[ClientsNew][saveNewClient] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Sent WhatsApp',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientsNew][saveNewClient] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send WhatsApp. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async sendBookingLink() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {
                if (this.client.id) {

                    try {

                        const response = await ClientService.sendBookingLink(this.client.id);
                        console.log('[ClientDetail][sendBookingLink] Response = ', response);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Sent Booking Link',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[ClientDetail][sendBookingLink] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to send booking link. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        async sendDigitalFormLink() {
            this.submitted = true;

            console.log('[ClientDetail][sendDigitalFormLink] this.client.id = ', this.client.id);
            console.log('[ClientDetail][sendDigitalFormLink] this.selectedDigitalForm = ', this.selectedDigitalForm);

            if (this.client.id) {

                try {

                    const response = await ClientService.sendDigitalFormLink(this.client.id, this.selectedDigitalForm.id);
                    console.log('[ClientDetail][sendDigitalFormLink] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Sent Digital Form Link',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientDetail][sendDigitalFormLink] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send digital form link. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        async createAuditTrail() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    var auditTrailDto = {
                        companyId: this.profile.companyId,
                        userId: this.userStore.user.id,
                        auditTrailSubProcess: this.auditTrail.auditTrailSubProcess,
                        auditTrailDescription: this.auditTrail.auditTrailDescription
                    };

                    console.log("[ClientDetail][createAuditTrail] auditTrailDto = ", auditTrailDto);

                    const response = await ClientService.updateClientAuditTrail(this.client.id, auditTrailDto);
                    console.log('[ClientDetail][createAuditTrail] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Add audit trail for client',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientDetail][createAuditTrail] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add audit trail for client. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async createUnpaidNotice() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    var unpaidDto = {
                        companyId: this.profile.companyId,
                        userId: this.userStore.user.id,
                        unpaidType: this.unpaid.unpaidType,
                        unpaidAmountOutstanding: this.unpaid.unpaidAmountOutstanding,
                    };

                    console.log("[ClientDetail][createUnpaidNotice] unpaidDto = ", unpaidDto);

                    const response = await ClientService.sendClientUnpaid(this.client.id, unpaidDto);
                    console.log('[ClientDetail][createUnpaidNotice] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Create unpaid notice',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[ClientDetail][createUnpaidNotice] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create unpaid notice. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        async createInvoice() {
            this.submitted = true;

            if (this.client.id) {

                try {

                    var tempProduct = "";
                    var tempBillingPlan = "";

                    if (this.invoice.type === 'B') {

                        try {
                            tempBillingPlan = this.invoice.billingPlan.id;
                        } catch (error) {
                            tempBillingPlan = "";
                        }

                        var invoiceDtoBillingPlan = {
                            invoiced: moment(this.invoice.invoiced).format('YYYY-MM-DD HH:mm'),
                            userId: this.profile.id,
                            billingPlanId: tempBillingPlan,
                            appointmentId: null,
                            clientId: this.client.id,
                            submissionMethod: 'C',
                            healthInsuranceSubmission: 'E',
                            useSystemProcedureRates: 'N',
                            useSystemProductRates: 'N',
                            useTaxRate: this.invoice.useTaxRate,
                            useAutomaticSubmission: this.invoice.useAutomaticSubmission,
                            rateOption: 'D'
                        };

                        console.log("[Client][createInvoice] tempBillingPlan = ", tempBillingPlan);

                        console.log('[Client][createInvoice] invoiceDtoBillingPlan = ', invoiceDtoBillingPlan);

                        const response = await InvoiceService.createInvoiceForBillingPlan(
                            this.client.id, invoiceDtoBillingPlan);
                        console.log('[Client][createInvoice] Created Billing Plan Invoice. Response = ', response);
                    } else {
                        try {
                            tempProduct = this.invoice.product.id;
                        } catch (error) {
                            tempProduct = "";
                        }

                        console.log("[Client][createInvoice] tempProduct = ", tempProduct);

                        var invoiceDtoProduct = {
                            invoiced: moment(this.invoice.invoiced).format('YYYY-MM-DD HH:mm'),
                            userId: this.profile.id,
                            billingPlanId: null,
                            productId: tempProduct,
                            appointmentId: null,
                            clientId: this.client.id,
                            submissionMethod: 'C',
                            healthInsuranceSubmission: 'E',
                            useSystemProcedureRates: 'N',
                            useSystemProductRates: 'N',
                            useTaxRate: this.invoice.useTaxRate,
                            useAutomaticSubmission: this.invoice.useAutomaticSubmission,
                            rateOption: 'D'
                        };

                        console.log('[Client][createInvoice] invoiceDtoProduct = ', invoiceDtoProduct);

                        const response = await InvoiceService.createInvoiceForProduct(
                            this.client.id, invoiceDtoProduct);
                        console.log('[Client][createInvoice] Created Product Invoice. Response = ', response);
                    }

                    const invoicesData = await InvoiceService.getAllCompanyInvoices(this.profile.companyId);
                    this.userStore.setInvoices(invoicesData.data);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created invoice',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[Client][createInvoice] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create invoice. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
    }
};
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

::v-deep(.p-datatable-frozen-tbody) {
    font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
    font-weight: bold;
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.customer-badge,
.status-badge,
.client-badge,
.type-badge,
.format-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.customer-badge {
    &.status-C {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-I {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-R {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-V {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-A {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-new {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-renewal {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-proposal {
        background: #FFD8B2;
        color: #805B36;
    }
}

.status-badge {
    &.status-A {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-P {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-C {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-W {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-I {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-R {
        background: #B3E5FC;
        color: #23547B;
    }

}

.client-badge {
    &.status-N {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-J {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-M {
        background: #B3E5FC;
        color: #23547B;
    }
}

.type-badge {
    &.status-Y {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-N {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-S {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-B {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-C {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-U {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-P {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-O {
        background: #ECCFFF;
        color: #c75226;
    }

    &.status-R {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-E {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-F {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-G {
        background: #ECCFFF;
        color: #c75226;
    }

    &.status-H {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-A {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-D {
        background: #C8E6C9;
        color: #256029;
    }

}

.format-badge {

    &.status-R {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-F {
        background: #aea658;
        color: #6e632a;
    }

    &.status-V {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-O {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-C {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-A {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-S {
        background: #d9b78a;
        color: #b94f03;
    }

}


.tabview-custom {

    i,
    span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-tabview p {
    line-height: 1.5;
    margin: 0;
}

.accordion-custom {

    i,
    span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-accordion p {
    line-height: 1.5;
    margin: 0;
}

.mb-2 {
    margin-bottom: 1rem;
}

.mr-2 {
    margin-right: 1rem;
}

.buttons {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-top: 8px;
}

.notes-video-container {
    border: 2px solid #e7e7e7;
    display: none;
    padding: 3px;
}

.note-video-timer {
    font-size: 2em;
}

.iso-image-editor {
    width: 790px;
}

.iso-image-editor .canvas-container {
    border: solid 1px #dee2e6;
    margin: auto;
}

.iso-image-editor .toolbar {
    border: solid 1px #dee2e6;
    margin-bottom: 2px;
}

.iso-image-editor .image-canvas {
    border: solid 1px #dee2e6;
}

.iso-image-editor .mode-buttons {
    display: inline-block;
    padding: 5px;
}

.iso-image-editor .action-buttons {
    display: inline-block;
    margin-left: 30px;
    padding: 5px;
}

.iso-image-editor .drawing-mode-options {
    display: none;
    vertical-align: top;
}

.iso-image-editor .field-group {
    display: inline-block;
    margin-left: 20px;
}

.iso-image-editor .field {
    display: flex;
    align-items: center;
    margin-bottom: 3px;
}

.iso-image-editor label {
    display: inline-block;
    width: 150px;
}

.iso-image-editor .info {
    display: inline-block;
    width: 15px;
}

.iso-image-editor button {
    padding: 5px 10px;
    margin-right: 5px;
    border: none;
    border-radius: 3px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #888;
    color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.iso-image-editor button:hover {
    background: #777;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.iso-image-editor button:active {
    background: #666;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);
}

.p-inputtext {
    border-radius: 6px !important;
}
</style>
